/* ==== HAKEN SIND ATTRIBUTE, KEINE KLASSEN — 21.09.2026 ====
   Der Warenkorb-Block traegt ab heute die echten `.ic-cross-sell`-Klassen
   (Enzo: „es soll genau dieser Kasten sein“). Damit waere jede Klassen-
   abfrage zweideutig: sie traefe auch den Original-Cross-Sell. Alle acht
   Griffe sind deshalb auf Attribute umgestellt:
     `[data-s304-korb]`  = mein Bundle-Block   (Liquid setzt es)
     `[data-s304-add]`   = eine waehlbare Karte
     `[data-cross-sell]` = der ORIGINAL-Cross-Sell, den ich verberge
   ⛔ Wer hier wieder `.s304-korb` schreibt, greift ins Leere: die Klasse
      steht seit dem 21.09. nicht mehr im Markup. */
/* ==== SPRACHE: 2-FUER-1-TEXTE AUF ENGLISCH, 21.09.2026 ====
   Enzo: "alle Texte, die wir auf den Seiten haben, muessen ja auch ins Englisch
   uebersetzt werden, die Funktion haben wir auch schon."
   ⭐ Dieselbe Wahrheit wie `request.locale.iso_code` in den Liquid-Bausteinen
      (304-kollektion-daten, 304-korb-fuss), nur schon im Dokument: Shopify setzt
      auf /en/ ein `<html lang="en">`. Kein zweiter Kanal, keine Dopplung.
   ⛔ Fail-safe nach DEUTSCH: fehlt das Attribut, bleibt alles wie bisher. */
(function(){
  var l = (document.documentElement.getAttribute('lang') || 'de').toLowerCase();
  window.s304EN = l.indexOf('de') !== 0;
  window.s304T  = function(de, en){ return window.s304EN ? en : de; };
})();

/* ══════════════════════════════════════════════════════════════════════════
   DER EINLAUF FUER DIE ZWEI ERZAEHL-SEITEN                       22.08.2026
   ══════════════════════════════════════════════════════════════════════════
   ENZO: „bei Become a Creator und About us, da vielleicht wie bei Handfee das
   mal so ein bisschen umaendern. Da wollte ich so eine Animation haben."
   AUSDRUECKLICH NUR DORT. Am selben Tag hat er die Kachel-Animation auf
   Kategorie- und Produktseite zweimal abgelehnt: „das will ich auch fuer
   keinen Fall, sondern das soll so bleiben wie davor." Deshalb haengt hier
   alles an `.cr` und `.au` — den beiden Seitencontainern — und an nichts sonst.

   ── WAS handfee WIRKLICH MACHT (am 22.08. aus deren Quelltext gelesen) ──
   Keine Bibliothek, acht Zeilen:
     .hf-tk__reveal{opacity:0;transform:translateY(24px);
       transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s …}
     .hf-tk__reveal.is-in{opacity:1;transform:translateY(0)}
   plus ein IntersectionObserver bei 15 % und `min(i,5) * 0.06s` Staffelung.

   ── WARUM HIER TROTZDEM KEIN ZWEITER BEOBACHTER ENTSTEHT ──
   `assets/theme.js` traegt bereits einen IntersectionObserver, einen
   MutationObserver fuer nachgeladene Teile und einen Anker-Beobachter.
   `assets/theme.css` traegt 29 Animationsarten sowie Dauern und Verzoegerungen
   in 50-ms-Schritten; `data-aos-duration="700"` ist dort 0,7 s, also exakt
   handfees Zeit. Es fehlten nur die Attribute, nicht die Maschine.

   ── WARUM DAS FRUEH GENUG LAEUFT ──
   `304-custom.js` und `theme.js` tragen beide `defer` und laufen deshalb in
   Dokumentreihenfolge, nachdem der Baum steht. `304-custom.js` steht VOR
   `theme.js` (snippets/social-meta.liquid:53) — wenn dessen Start
   `querySelectorAll('[data-aos]:not([data-aos-anchor]):not(.aos-animate)')`
   ausfuehrt, stehen unsere Attribute also schon da.

   ⛔ BEWUSST OHNE `data-aos-anchor`: der Anker-Beobachter sucht mit
   `anker.querySelectorAll(...)` nur NACHFAHREN, nie das Element selbst. Ein
   Anker auf sich selbst liesse das Element dauerhaft auf `opacity: 0` stehen.
   ⚠ Das Sicherheitsnetz dazu steht in `assets/304-custom.css`. Ohne das waere
   ein ausgefallener Beobachter keine fehlende Animation, sondern eine LEERE
   SEITE. */
(function(){
  /* ⛔ 22.08.2026, ZWEITER ANLAUF — VORHER LIEF JEDER SATZ EIN.
     Im ersten Anlauf standen hier auch `.cr-p`, `.cr-lead`, `.cr-list > li`,
     `.au-p`, `.au-spec` und so weiter: 45 bzw. 23 Elemente. ENZO danach:
     „du hast das jetzt bei jedem Text gemacht, das ist nur cool bei vielleicht
     mal einer Grafik und deswegen ist das so ein bisschen buggy."

     Er hat recht, und der Grund ist nicht Geschmack: wenn JEDER Absatz erst
     erscheinen muss, liest man nicht mehr, man wartet. Der Blick springt beim
     Scrollen staendig auf etwas, das noch nicht da ist. Bewegung wirkt nur,
     wenn sie selten ist.

     Jetzt laufen nur noch UEBERSCHRIFTEN und BILDER ein. Fliesstext, Listen,
     Kennzahlen und Knoepfe stehen sofort. Damit bleibt die Seite lesbar und
     die Animation setzt genau die Akzente, die handfee auch setzt. */
  /* ⛔ 22.08.2026, DRITTER ANLAUF — UEBERSCHRIFTEN RAUS.
     ENZO: „Die Scrollanimation sind jetzt Ueberschriften. Das ist irgendwie
     nicht gut, beziehungsweise ist dann halt auch ein bisschen redundant.
     Vielleicht bei den Grafiken oder sowas."

     Er hat recht, und der Grund ist benennbar: eine Ueberschrift ist ohnehin
     schon der Bruch im Lesefluss. Sie gross, fett und andersfarbig zu setzen
     UND sie zusaetzlich einlaufen zu lassen, sagt dieselbe Sache zweimal.
     Ein Bild dagegen hat keine solche Auszeichnung — dort ist Bewegung das
     einzige Mittel, das den Auftritt markiert.

     ── Was das je Seite bedeutet, gemessen am 22.08. ──
     `.au` (About Us) hat drei echte Grafiken UNTERHALB des ersten Bildschirms:
     zwei Bildbaender (`.au-band`, y 975 und y 2224) und die zwei Produktkarten
     (`.au-piece-media`, y 3854). Alle `position: relative`, also gefahrlos.
     `.cr` (Become a Creator) hat **genau ein** Bild, und das steht bei y 167,
     also ueber der Falz. Eine SCROLL-Animation hat dort nichts zu tun — sie
     waere eine Ladeanimation, und genau die hat Enzo auf den Kategorieseiten
     abgelehnt. Deshalb steht `.cr` hier bewusst LEER, statt etwas zu animieren,
     nur damit ueberall etwas passiert. */
  /* ⭐ 22.08.2026, VIERTER UND LETZTER STAND — DIE KACHELN SIND DAS ZIEL.
     ENZO: „Widgetkacheln wie bei Handfee, das ist cool, dann wird es auch
     nicht so viel Text." Damit hat der Einlauf endlich etwas, worauf er
     gehoert: Kacheln sind gleichrangige Elemente ohne eigene Auszeichnung,
     genau dort markiert Bewegung den Auftritt. Ueberschriften bleiben aussen
     vor (die sind schon durch Groesse und Farbe markiert), Fliesstext auch.

     11 Kacheln auf `/pages/creator` (4 Stufen, 3 Schritte, 4 Vorteile),
     3 auf `/pages/about-us` (Materialdaten), dazu die zwei Bildbaender.
     Gestaffelt je Elternelement, also faengt jede Gruppe bei 0 an. */
  /* ⛔ 23.08.2026 — ABOUT US VORUEBERGEHEND ABGESCHALTET, ALS MESSUNG.
     ENZO zum dritten Mal: „wenn ich da scrolle, faengt er mich mit meinem Finger
     und ich kann fuer eine kurze Zeit nicht weiter scrollen."
     Gemessen am 23.08.: auf /pages/about-us tragen GENAU FUENF Elemente
     `data-aos` (2 Baender + 3 Materialdaten), Dauer 0,4 s, Verzug 0-0,1 s.
     Das kann eine Scrollgeste nicht blockieren. Verdaechtig ist stattdessen die
     Scroll-Einrichtung des Themes selbst: `html` rechnet auf
     `overflow-x: hidden` UND `scroll-behavior: smooth` — beides ist auf iOS ein
     bekannter Klebefinger-Effekt und gilt SEITENWEIT, nicht nur hier.
     Deshalb ist `.au` hier herausgenommen: bleibt das Gefuehl, liegt es NICHT an
     der Animation und die Suche geht ans Theme. Verschwindet es, lag ich falsch.
     Rueckbau = die eine Zeile wieder einkommentieren. */
  var SEITEN = [
    { wurzel: '.cr', ziele: '.cr-list > li' }
    /* , { wurzel: '.au', ziele: '.au-band, .au-spec' } */
  ];

  SEITEN.forEach(function(seite){
    var wurzel = document.querySelector(seite.wurzel);
    if(!wurzel) return;

    var alle = [];
    seite.ziele.split(',').forEach(function(sel){
      sel = sel.trim();
      if(!sel) return;
      [].forEach.call(wurzel.querySelectorAll(sel), function(el){
        if(el.hasAttribute('data-aos')) return;   /* nichts Vorhandenes ueberschreiben */
        if(el.closest('form')) return;            /* das Bewerbungsformular bleibt sofort da */
        /* ⛔ Nie eine abgeloeste Ebene bewegen. `position:absolute/fixed` heisst
           in aller Regel: dieses Element DECKT etwas ab. Verschiebt man es,
           wird das Darunterliegende sichtbar — genau der Streifen, der am
           22.08. am Heldenbild von About Us aufblitzte. Diese Bremse steht hier
           dauerhaft, damit die Falle beim naechsten Selektor nicht wiederkommt. */
        var lage = getComputedStyle(el).position;
        if(lage === 'absolute' || lage === 'fixed') return;
        if(alle.indexOf(el) < 0) alle.push(el);
      });
    });
    if(!alle.length) return;

    /* Dokumentreihenfolge, sonst staffelt es in der Reihenfolge der
       Selektorenliste und nicht von oben nach unten. */
    alle.sort(function(a,b){
      return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    });

    /* Gestaffelt je Elternelement: so faengt jeder Abschnitt seine Kaskade neu
       an und die Seite laeuft nicht irgendwo unten mit 3 s Verzug weiter.
       Deckel bei 5 wie bei handfee, Schritte von 100 ms, weil das Theme nur
       Vielfache von 50 kennt. */
    var zaehler = new Map();
    alle.forEach(function(el){
      var p = el.parentElement;
      var i = zaehler.get(p) || 0;
      zaehler.set(p, i + 1);
      el.setAttribute('data-aos', 'fade-up');
      /* ⛔ 22.08.2026 — TEMPO NACHGEZOGEN.
         ENZO: „die Scrollanimationen gehen nicht so schnell wie man scrollt und
         dann kann man teilweise zwischendurch nicht weiter scrollen."

         Vorher 700 ms Dauer plus bis zu 500 ms Verzoegerung — im schlechtesten
         Fall 1,2 Sekunden, bis eine Kachel steht. Wer zuegig scrollt, ist da
         laengst vorbei und sieht nur noch halb erschienene Kaesten. Das ist
         kein Effekt mehr, das ist Nachhinken.

         Jetzt 400 ms und hoechstens 100 ms Verzoegerung, also maximal eine
         halbe Sekunde. Die Staffelung bleibt spuerbar (0/50/100), zieht die
         Gruppe aber nicht mehr auseinander.
         ⚠ Beide Werte muessen Vielfache von 50 sein — das Theme kennt nur
         solche Stufen (`[data-aos-duration="400"]`, `[data-aos-delay="50"]`).
         Ein krummer Wert greift schlicht nicht. */
      el.setAttribute('data-aos-duration', '400');
      var d = Math.min(i, 2) * 50;
      if(d) el.setAttribute('data-aos-delay', String(d));
    });
  });

  /* ── DAS NETZ: nur bei echtem Ausfall, nicht als Zeitschaltuhr ──
     `[data-aos^=fade]` steht auf `opacity: 0`, bis der Beobachter
     `aos-animate` vergibt. Faellt der aus, ist die Seite nicht „nicht
     animiert", sondern LEER. Bei einer Bewerbungsseite ist das teurer als
     jede fehlende Animation.

     ⚠ Ein reines CSS-Netz mit fester Verzoegerung waere falsch — es haette
     auch alles freigeschaltet, was noch 4000 px weiter unten liegt, und damit
     die Animation genau dort abgeschaltet, wo man sie sieht. Deshalb wird hier
     GEMESSEN statt gewartet: hat nach drei Sekunden kein einziges Element
     `aos-animate`, dann laeuft die Maschine nicht.

     ⚠ Gezaehlt wird nur SICHTBARE Zeit. In einem Hintergrund-Tab feuert kein
     IntersectionObserver und es laufen keine CSS-Animationen; ohne diese
     Bedingung wuerde das Netz dort jedes Mal ausloesen und die Animation
     wegwerfen, bevor der Nutzer die Seite ueberhaupt ansieht. Genau dieser
     Messfehler ist mir am 22.08. zweimal selbst passiert. */
  var SICHTBAR = '.cr [data-aos], .au [data-aos]';
  if(document.querySelector(SICHTBAR)){
    var sichtbareZeit = 0;
    var wache = setInterval(function(){
      if(document.visibilityState !== 'visible') return;
      sichtbareZeit += 250;
      if(sichtbareZeit < 3000) return;
      clearInterval(wache);
      if(document.querySelector('.cr [data-aos].aos-animate, .au [data-aos].aos-animate')) return;
      [].forEach.call(document.querySelectorAll(SICHTBAR), function(el){
        el.classList.add('aos-animate');
      });
    }, 250);
  }
})();

(function(){
  /* ===== Sold-Out Badge (PDP) ===== */
  function addBadge(){
    if(!document.querySelector('.price--sold-out')) return false;
    var media = document.querySelector('.product__slide.media--active')
             || document.querySelector('.product__media, .product-single__media, [data-product-media]')
             || document.querySelector('.product__slide');
    if(!media) return false;
    if(media.querySelector('.sold-out-badge-304')) return true;
    if(getComputedStyle(media).position === 'static'){ media.style.position = 'relative'; }
    var b = document.createElement('span'); b.className = 'sold-out-badge-304'; b.textContent = 'Sold Out';
    media.appendChild(b); return true;
  }

  /* ===== Store-Gesamtbewertung 4,7 -> 4,8 (NUR store-weit) ===== */
  function fixStoreRating(){
    var els = document.querySelectorAll('.wc-trust-header__text, .menu-trust-badge__text');
    for(var i=0;i<els.length;i++){ if(els[i].textContent.indexOf('4,7') !== -1){ els[i].textContent = els[i].textContent.replace('4,7','4,8'); } }
    var sp = document.querySelectorAll('span');
    for(var j=0;j<sp.length;j++){ if(sp[j].childElementCount===0 && sp[j].textContent.trim()==='4,7 STERNE'){ sp[j].textContent='4,8 STERNE'; } }
  }

  /* ===== Produktseite: Desktop-Review-Widget mit echten Daten fuellen ===== */
  function fixPdpRating(){
    if(!document.body || document.body.className.indexOf('template-product') === -1) return;
    var rating=null, cnt=null;
    var rows=document.querySelectorAll('.pdp-reviews-member-row, .custom-star-row, .rev-heading-row');
    for(var i=0;i<rows.length;i++){ var m=(rows[i].textContent||'').match(/(\d+[.,]\d+)\s*\|\s*(\d+)\s*Bewertung/i); if(m){ rating=m[1]; cnt=m[2]; break; } }
    if(!rating) return;
    var texts=document.querySelectorAll('.custom-rating-text');
    for(var j=0;j<texts.length;j++){ if(/[–-]/.test(texts[j].textContent||'')){ texts[j].textContent = ((window.T304&&window.T304.rating)||'{r} | {n} Bewertungen').replace('{r}', parseFloat(rating).toLocaleString((window.T304&&window.T304.numfmt)||'de-DE',{minimumFractionDigits:1,maximumFractionDigits:1})).replace('{n}', cnt); } }
  }

  /* ===== Produktseite Desktop: Sticky-Kaufen-Leiste ein-/ausblenden je nach
     Sichtbarkeit des oberen Kaufen-Buttons (IntersectionObserver). Nur >=990px. ===== */
  function initStickyCartBar(){
    if(!document.body || document.body.className.indexOf('template-product') === -1) return;
    if(window.innerWidth < 990) return;
    var bar=document.querySelector('.cart-bar'); if(!bar || bar.dataset.cb304) return;
    var mainAtc=null;
    var btns=document.querySelectorAll('button,[name="add"]');
    for(var i=0;i<btns.length;i++){ var b=btns[i]; if(b.closest('.cart-bar')) continue; if(/warenkorb/i.test(b.textContent||'')){ mainAtc=b; break; } }
    if(!mainAtc) return;
    bar.dataset.cb304='1';
    var io=new IntersectionObserver(function(es){ for(var k=0;k<es.length;k++){ if(es[k].isIntersecting) bar.classList.remove('cb-show-304'); else bar.classList.add('cb-show-304'); } },{threshold:0});
    io.observe(mainAtc);
  }

  function tick(){ addBadge(); fixStoreRating(); fixPdpRating(); initStickyCartBar(); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', tick); } else { tick(); }
  window.addEventListener('load', tick);
  var tries = 0;
  var iv = setInterval(function(){ tries++; tick(); if(tries > 20) clearInterval(iv); }, 300);
  if(window.MutationObserver){
    var pending=false;
    function schedule(){ if(pending) return; pending=true; setTimeout(function(){ pending=false; fixStoreRating(); fixPdpRating(); initStickyCartBar(); }, 150); }
    function startObs(){ new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true}); }
    if(document.body){ startObs(); } else { document.addEventListener('DOMContentLoaded', startObs); }
  }
})();

/* ==== 2 FÜR 1 — PDP-Verhalten, Stand 20.09.2026 (Fassung 2) ====
   Liest seine Daten aus <script id="s304-bundle-daten" type="application/json">
   (snippets/304-bundle-daten.liquid). Fehlt der Block, passiert NICHTS.

   ⛔ NICHTS LANDET UNGEFRAGT IM WARENKORB. Das zweite Stück wird erst gelegt,
      wenn der Kunde es ausdrücklich dazulegt ("armiert"). Begründung: ein
      ungefragt mitgeliefertes Produkt kostet echte Ware und Versand und fühlt
      sich wie ein Trick an. Wer das umdrehen will: unten START_ARMIERT = true.
   ⛔ Der Kaufknopf wird NICHT abgefangen. Gemessen am 20.09.: Shopify nimmt
      im selben Formular `id`+`quantity` UND `items[0][...]` entgegen und legt
      BEIDE hinein. Deshalb genügen zwei versteckte Felder — das Theme macht
      Laden, Fehlerbehandlung und Schublade selbst (theme.dev.js:1588 cartAddEvent).
   ⛔ Die Sichtbarkeit der cart-bar steuert das Theme (initStickyCartBar).
      Hier wird NICHT getoggelt. */
(function(){
  "use strict";
  var START_ARMIERT = false;

  var quelle = document.getElementById('s304-bundle-daten');
  if (!quelle) return;
  var D; try { D = JSON.parse(quelle.textContent); } catch(e) { return; }
  if (!D || !D.haupt || !D.liste || !D.liste.length) return;

  /* ⛔ 20.09. abends: seit der Preisdeckel weg ist, kann das erste Stueck in der Liste
     TEURER sein als das Hauptprodukt — gemessen auf LINE 47 (95 €) war BIG STEEL (120 €)
     vorausgewaehlt, mit "0 €" daran. Das ist falsch: Shopify rabattiert das guenstigere.
     Deshalb ist die Vorauswahl das erste Stueck, das HOECHSTENS so teuer ist wie das
     Hauptprodukt — dann stimmt die Null von Anfang an. */
  /* \u26d4 R1, 20.09. 17:40 \u2014 DER DECKEL IST ZURUECK, und diesmal mit Enzos Begruendung:
     \u201edie Kunden wollen eigentlich weniger bezahlen \u2014 ich sag LINE 47, dann f\u00fcgen sie BIG STEEL
     hinzu, auf einmal kostet es 120." Ein teureres Zweitst\u00fcck macht das Bundle TEURER, nicht
     g\u00fcnstiger. Wer BIG STEEL will, baut das Bundle von dessen eigener Seite aus.
     \u2b50 Der Deckel sitzt jetzt HIER in der Oberfl\u00e4che, nicht mehr im Liquid \u2014 so bleiben die
     Daten vollst\u00e4ndig (fuer die Galerie im Popup) und die Regel steht an einer Stelle. */
  /* \u26d4 Der Deckel und das Paar-Foto ziehen gegeneinander. Gemessen: ICY STELLAR (55 \u20ac)
     ist auf 10 von 12 Bracelet-Fotos das zweite St\u00fcck, alle anderen kosten 50 \u2014 der Deckel
     wirft es dort raus, und die Galerie kann nicht springen.
     \u2b50 AUFSCHLAG_ERLAUBT = 0 h\u00e4lt Enzos Ansage: nichts Teureres dazulegbar.
     Auf 5 gesetzt w\u00fcrde ICY STELLAR auf allen Seiten passen \u2014 der Kunde zahlt dann 55 statt
     50 und bekommt ein 50-\u20ac-St\u00fcck gratis. Das ist EINE Zahl, keine Umbauarbeit. */
  /* ✅ 20.09.2026 von Enzo freigegeben: „mach das mit dem Bildsprung.“
     5 € Aufschlag erlaubt — damit passt ICY STELLAR (55) auf allen 50-€-Bracelets, und
     das Paar-Foto stimmt auf 12 von 12 statt 2 von 12. Der Kunde zahlt dann 55 statt 50
     und bekommt ein 50-€-Stück gratis — also MEHR Umsatz, nicht weniger.
     ⛔ BIG STEEL bleibt gesperrt: 120 gegen 95 sind 25 € Aufschlag, nicht 5. */
  var AUFSCHLAG_ERLAUBT = 5;
  D.liste = D.liste.filter(function(p){ return p.p <= D.haupt.std + AUFSCHLAG_ERLAUBT; });
  if (!D.liste.length) return;

  /* \u2b50 VORAUSWAHL: mit Paar-Foto zuerst.
     Enzo: \u201ebei Default muss das Piece stehen, was man kostenlos dazubekommt \u2014 und dann
     muss oben das Bild dahin springen." Ein Stueck ohne Paar-Foto kann nichts zum Springen
     bringen; also bekommt eins MIT Foto den Vorzug. Danach gilt die alte Regel weiter. */
  var gewaehlt = null;
  for (var gi = 0; gi < D.liste.length; gi++) {
    if (D.liste[gi].p <= D.haupt.std + AUFSCHLAG_ERLAUBT && typeof D.liste[gi].pb === 'number') { gewaehlt = D.liste[gi]; break; }
  }
  if (!gewaehlt) {
    for (var gj = 0; gj < D.liste.length; gj++) {
      if (D.liste[gj].p <= D.haupt.std + AUFSCHLAG_ERLAUBT) { gewaehlt = D.liste[gj]; break; }
    }
  }
  if (!gewaehlt) gewaehlt = D.liste[0];

  /* Gratis ist immer das guenstigere der beiden Stuecke. */
  /* ⭐ 21.09.2026 — der Originalpreis bleibt sichtbar, durchgestrichen.
     Gleiche Darstellung wie im Popup (Enzos Vorgabe R3). */
  function preisLabel(p){
    return (p.p <= D.haupt.std)
      ? '<s class="s304-alt">' + eur(p.p) + '</s><b class="s304-frei">0 \u20ac</b>'
      : eur(p.p);
  }
  /* Welches der beiden Stuecke ist wirklich gratis? Shopifys BXGY rabattiert das
     GUENSTIGERE. Bei Gleichstand das Zweitstueck \u2014 das ist das, was der Kunde gerade
     ausgesucht hat. */
  function zweitesIstGratis(p){ return !!p && p.p <= D.haupt.std; }

  /* \u26d4 WAS WIRKLICH ZU ZAHLEN IST. Shopifys BXGY rabattiert das GUENSTIGERE Stueck,
     also ist der faellige Betrag das TEURERE der beiden \u2014 nicht automatisch der
     Hauptpreis. Gemessen am 20.09.: LINE 47 (95) + BIG STEEL (120) liess den Kaufknopf
     \u201e95 \u20ac\u201c sagen, waehrend an der Kasse 120 faellig sind. */
  function zuZahlen(){
    var zweites = armiert;
    if (!zweites) return D.haupt.std;
    return Math.max(D.haupt.std, zweites.p);
  }
  var armiert  = START_ARMIERT ? gewaehlt : null;
  var eur = function(n){ return (Math.round(n*100)/100).toString().replace('.',',') + ' €'; };
  var bild = function(p){ return p && (p.fs || p.b) || ''; };

  function melde(name, wert){
    try { if (window.clarity) window.clarity('event', name); } catch(e){}
    try { if (window.clarity && wert) window.clarity('set', name + '_wert', String(wert)); } catch(e){}
    try { if (window.dataLayer) window.dataLayer.push({event:name, wert:wert}); } catch(e){}
  }

  var emblem = '<svg class="s304-em" width="22" height="14" viewBox="0 0 62 40" aria-hidden="true">'
    + '<rect class="ring" x="2.2" y="9" width="32" height="22" rx="11"/>'
    + '<rect class="ring" x="27.8" y="9" width="32" height="22" rx="11"/></svg>';

  /* ---------- Die versteckten Formularfelder ---------- */
  function formulare(){
    /* ⛔ NUR das Formular mit dem echten Kaufknopf. Gemessen am 20.09. auf der
       Live-PDP: es gibt DREI Formulare auf /cart/add — zwei davon sind versteckte
       `shop-pay-terms`-Formulare. In ein Express-Kauf-Formular gehoert das Feld
       nicht. Die cart-bar hat kein eigenes Formular, sie benutzt dieses hier
       (assets/cart-bar.js: this.form = this.section.querySelector(...)). */
    return Array.prototype.filter.call(
      document.querySelectorAll('form[action*="/cart/add"]'),
      function(f){ return !!f.querySelector('[name="add"]'); });
  }
  function felderSetzen(p){
    formulare().forEach(function(f){
      var alt = f.querySelectorAll('.s304-feld');
      Array.prototype.forEach.call(alt, function(x){ x.remove(); });
      if (!p || !p.id) return;
      var menge = 1;
      var mf = f.querySelector('[name="quantity"]');
      if (mf && parseInt(mf.value, 10) > 0) menge = parseInt(mf.value, 10);
      [['items[0][id]', p.id], ['items[0][quantity]', menge]].forEach(function(paar){
        var i = document.createElement('input');
        i.type = 'hidden'; i.className = 's304-feld';
        i.name = paar[0]; i.value = paar[1];
        f.appendChild(i);
      });
    });
  }
  /* Beim Absenden die Menge nachziehen — NUR schreiben, nie abbrechen. */
  document.addEventListener('submit', function(){ if (armiert) felderSetzen(armiert); }, true);

  /* ---------- Der Kasten über dem Kaufknopf ---------- */
  var anker = document.querySelector('.product__submit__item');
  if (!anker || !anker.parentNode) return;

  var huelle = document.createElement('div');
  huelle.className = 's304-huelle';

  var knopf = document.createElement('button');
  knopf.className = 's304-duo'; knopf.type = 'button';

  /* Enzo, 20.09.: „wenn du 2 fuer 1 gemacht hast und ein zweites Produkt
     hinzugefuegt hast, dass sich der CTA aendert — beide in den Warenkorb legen,
     kleiner Punkt in der Mitte, dann der Preis."
     ⛔ Der Originaltext wird beim ersten Mal gesichert und beim Entfernen exakt
     zurueckgeschrieben — das Theme schreibt den Knopf sonst selbst wieder um. */
  /* ⭐ 21.09.2026 — nach aussen gereicht, damit die Leiste nachziehen kann,
     wenn das Theme <cart-bar> erst spaeter rendert. Funktionsdeklarationen
     werden hochgezogen, der Verweis unten greift also schon hier. */
  window.s304Kaufknopf = function(){ try { return kaufknopfSchreiben(); } catch(e){} };

  function kaufknopfSchreiben(){
    /* ⛔ NUR den Textträger anfassen. Am 20.09. am Live-Knopf gemessen:
         <button name="add">
           <span class="btn__text">In den Warenkorb legen</span>
           <span class="btn__added"> </span>
           <span class="btn__loader"> …svg… </span>
         </button>
       Wer hier den ganzen Knopf beschreibt, wirft den Lade-Indikator weg.
       Die klebende Leiste hat dagegen einen nackten Knopf ohne Kinder. */
    var ziele = [];
    Array.prototype.forEach.call(document.querySelectorAll('button[name=add]'), function(kn){
      ziele.push({el: kn.querySelector('.btn__text') || kn, schwebend: false});
    });
    var leiste = document.querySelector('cart-bar .cart-bar__atc-btn, #cart-bar-custom-atc');
    if (leiste) ziele.push({el: leiste, schwebend: true});

    ziele.forEach(function(z){
      var ziel = z.el;
      if (!ziel.hasAttribute('data-s304-alt')) ziel.setAttribute('data-s304-alt', ziel.textContent);
      /* ==== S304-CTA-SCHLICHT — 21.09.2026, nachts ====
         Enzo: auf der Produktseite nur „In den Warenkorb legen", zentriert,
         ohne Preis — in beiden Zustaenden. „Beide in den Warenkorb legen"
         steht nur noch unten im Blatt.
         ⛔ Frueher standen hier zwei Spans (Text links, Preis rechts). Die
            Preis-Spanne ist raus, nicht nur versteckt: `textContent` htte sie
            sonst weitergetragen. */
      if (true) {
        ziel.innerHTML = '<span class="s304-cta-l">' + s304T('In den Warenkorb legen', 'Add to cart') + '</span>';
      } else if (armiert) {
        ziel.innerHTML = '<span class="s304-cta-l">' + s304T('Beide in den Warenkorb legen', 'Add both to cart')
                       + '</span><span class="s304-cta-p">' + eur(zuZahlen()) + '</span>';
      } else {
        /* Enzo, 20.09.: „dann steht da ,in den Warenkorb legen‘ und so ein Punkt
           und der Preis".
           ⭐ 21.09.2026 — galt bis dahin nur fuer die SCHWEBENDE Leiste; der
           eingebettete Knopf fiel in einen dritten Zweig, der ihn auf seinen
           Urtext zuruecksetzte. Enzo: „Das soll aber auch schon so aussehen,
           wenn da nur steht ,in den Warenkorb legen‘ und 95 Euro." Also beide. */
        ziel.innerHTML = '<span class="s304-cta-l">' + s304T('In den Warenkorb legen', 'Add to cart')
                       + '</span><span class="s304-cta-p">' + eur(D.haupt.std) + '</span>';
      }
    });
  }

  function duoZeichnen(){
    var zweites = armiert || gewaehlt;
    var mehrzahl = D.haupt.typ === 'Walletchain' ? 'Walletchains' : 'Bracelets';
    var einzahl  = D.haupt.typ === 'Walletchain' ? 'eine' : 'eins';
    /* Enzo, 20.09. abends: „im Bundle soll dann stehen: plus dein zweites
       Bracelet, plus deine zweite Walletchain.“
       ⛔ Das Geschlecht unterscheidet sich: DAS Bracelet → dein zweites,
       DIE Walletchain → deine zweite. */
    /* U1, Enzo 17:40: \u201eauf der PDP muss genau der Text stehen: such dir ein weiteres
       Bracelet aus, aber bezahl nur eins." */
    /* ⛔ 20.09. nachts, Enzo: „das soll auch der gleiche Spruch sein wie auf
       der Kollektionsseite." Der alte Wortlaut („Such dir ein zweites …")
       stammt von 17:40 desselben Tages und wird damit abgeloest. Die Quelle
       ist `304-kollektion-daten.liquid`, dort steht wortgleich:
       „Lege zwei Bracelets in den Warenkorb und bezahle eins." */
    var zweitzeile = D.haupt.typ === 'Walletchain'
      ? s304T('Lege zwei Walletchains in den Warenkorb und bezahle eine.', 'Add two wallet chains to your cart and pay for one.')
      : s304T('Lege zwei Bracelets in den Warenkorb und bezahle eins.', 'Add two bracelets to your cart and pay for one.');
    knopf.classList.toggle('an', !!armiert);
    /* Enzo, 20.09.: „bei drei haette ich jetzt gerne mit plus, aber bei dem
       Produkt nach dem plus soll da dran stehen: gratis." */
    knopf.innerHTML =
      '<span class="s304-duo__b">'
      +   '<span class="s304-duo__ha"><img src="'+bild(D.haupt)+'" alt=""></span>'
      +   '<span class="s304-duo__plus">+</span>'
      +   '<span class="s304-duo__zw"><img src="'+bild(zweites)+'" alt=""></span>'
      + '</span>'
      /* ⭐ 21.09.2026 — EIN Abzeichen, Kind des KASTENS statt eines Bildes.
         Vorher stand es je nach Lage in `__ha` oder `__zw` und wechselte
         dadurch die Seite. Siehe umbau-2fuer1/abzeichen_fest.py. */
      + '<span class="s304-duo__gratis">' + s304T('2 f\u00fcr 1', '2 for 1') + '</span>'
      + '<span class="s304-duo__t"><span class="gr">' + s304T('2 für 1', '2 for 1') + '</span>'
      + '<span class="kl">'
      +   (armiert
            ? armiert.n + s304T(' liegt gratis dabei.', ' is included free.') + '<span class="s304-weg">' + s304T('entfernen', 'remove') + '</span>'
            : zweitzeile)
      + '</span></span>'
      + '<span class="s304-duo__p'+(armiert?' ok':'')+'">'+(armiert?'✓':'+')+'</span>';
    var weg = knopf.querySelector('.s304-weg');
    if (weg) weg.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      armiert = null; felderSetzen(null); duoZeichnen(); leisteSetzen(null); kaufknopfSchreiben();
      melde('s304_bundle_entfernt');
    });
  }

  /* Enzo, 20.09.: „wenn ich jetzt Line 47 vorausgewaehlt habe, dann soll im
     Dropdown darunter nicht nochmal Line 47 sein." Der Index bleibt der Index in
     D.liste — er darf sich durch das Auslassen NICHT verschieben. */
  function zeileOption(p, i){
    if (gewaehlt && p.h === gewaehlt.h) return '';
    return '<button class="s304-sel__o" type="button" data-i="'+i+'">'
      + '<img src="'+bild(p)+'" alt="">'
      + '<span class="n"><span class="lnk" data-h="'+p.h+'">'+p.n+'</span></span>'
      + '<span class="p">'+preisLabel(p)+'</span></button>';
  }
  function listeNeu(){
    if (liste) liste.innerHTML = D.liste.map(zeileOption).join('');
  }
  function zeileGewaehlt(p){
    /* R2: kein Pfeil mehr am Namen \u2014 Bild und Name oeffnen beide das Popup.
       Das \u25be bleibt: es ist das einzige Zeichen daf\u00fcr, dass hier eine Auswahl aufgeht. */
    /* M4 \u2014 Enzo: \u201eich finde das auf jeden Fall gut, dass da steht: am h\u00e4ufigsten
       dazugelegt." Der Aufn\u00e4her sitzt am VORAUSGEWAEHLTEN St\u00fcck, also an dem, das auch
       auf dem Paar-Foto zu sehen ist.
       \u26d4 Es ist eine Behauptung ohne Messung \u2014 die echte Zahl liefert
       `s304_bundle_gewaehlt` in etwa zwei Wochen. Bis dahin ist es Enzos Entscheidung.
       Rueckweg: `oftGewaehlt` auf false. */
    var oftGewaehlt = true;
    return '<img src="'+bild(p)+'" alt="">'
      + '<span class="n"><span class="lnk" data-h="'+p.h+'">'+p.n+'</span>'
      + (oftGewaehlt ? '<span class="s304-oft">am h\u00e4ufigsten dazugelegt</span>' : '')
      + '</span>'
      + '<span class="p">'+preisLabel(p)+'</span>'
      + '<span class="pf" aria-hidden="true">\u25be</span>';
  }

  var fenster = document.createElement('div');
  fenster.className = 's304-pop';
  fenster.innerHTML = '<span class="s304-pop__z"></span>'
    + '<p class="s304-pop__t">' + s304T('Such dir ', 'Pick ') + (D.haupt.typ === 'Walletchain' ? s304T('eine Walletchain', 'a wallet chain') : s304T('ein Bracelet', 'a bracelet'))
    + s304T(' <b>gratis</b> dazu aus.</p>', ' <b>free</b>.</p>')
    + '<div class="s304-sel">'
    +   '<div class="s304-sel__kopf">' + s304T('Dein Bundle', 'Your bundle') + '</div>'
    +   '<div class="s304-sel__haupt"><img src="'+bild(D.haupt)+'" alt="">'
    +     '<span class="n">'+D.haupt.n+'</span><span class="pr">'+eur(D.haupt.std)+'</span></div>'
    +   '<span class="s304-sel__l">' + (D.haupt.typ === 'Walletchain'
          ? s304T('deine zweite Walletchain (kostenlos)', 'your second wallet chain (free)')
          : s304T('plus dein zweites Bracelet (kostenlos)', 'plus your second bracelet (free)')) + '</span>'
    +   '<button class="s304-sel__d" type="button">'+zeileGewaehlt(gewaehlt)+'</button>'
    +   '<div class="s304-sel__liste">'+D.liste.map(zeileOption).join('')+'</div>'
    + '</div>'
    + '<button class="s304-pop__x" type="button">' + s304T('schließen', 'close') + '</button>';

  anker.parentNode.insertBefore(huelle, anker);
  huelle.appendChild(knopf); huelle.appendChild(fenster);
  duoZeichnen();

  var dd    = fenster.querySelector('.s304-sel__d');
  var liste = fenster.querySelector('.s304-sel__liste');

  function auf(){
    fenster.classList.add('da');
    knopf.classList.add('aufgeklappt');  /* T1: die Stuecke faechern auf */
    paarBildZeigen(armiert || gewaehlt);  /* AA: oben das Foto mit beiden Stuecken */
    knopf.classList.remove('wackelt');
    if (wackelUhr) { clearTimeout(wackelUhr); wackelUhr = null; }
    streifen.classList.remove('da'); blase.classList.remove('da');   /* nichts darf die Auswahl verdecken */
    melde('s304_bundle_auf');
  }
  function zu(){
    fenster.classList.remove('da');
    liste.classList.remove('auf');
    knopf.classList.remove('aufgeklappt');       /* T1: zurueck an die gerade Stelle */
  }

  /* ==== T2 \u00b7 nach 8 Sekunden ohne Klick wackeln die beiden Bilder einmal ====
     Enzo: \u201ewenn der Kunde 8 Sekunden auf der PDP war, aber immer noch nicht da drauf
     geklickt hat, dann lass die beiden, wo das Plus ist, einfach mal so wackeln."
     \u26d4 Genau EINMAL je Sitzung und nur, wenn der Kasten im Bild ist \u2014 ein Element, das
     unbemerkt im Hintergrund wackelt, hat nichts erreicht und nervt beim zweiten Mal. */
  var wackelUhr = null, schonGewackelt = false;
  function wackelStarten(){
    if (schonGewackelt || armiert) return;
    wackelUhr = setTimeout(function(){
      if (schonGewackelt || armiert || fenster.classList.contains('da')) return;
      var r = knopf.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) { wackelStarten(); return; }
      schonGewackelt = true;
      knopf.classList.add('wackelt');
      melde('s304_bundle_gewackelt');
      setTimeout(function(){ knopf.classList.remove('wackelt'); }, 1100);
    }, 8000);
  }
  wackelStarten();

  knopf.addEventListener('click', function(e){
    e.preventDefault();
    fenster.classList.contains('da') ? zu() : auf();
  });
  fenster.querySelector('.s304-pop__x').addEventListener('click', function(e){ e.preventDefault(); zu(); });

  /* ==== D · DAS ZWEITSTÜCK-POPUP, 20.09.2026 abends ====
     Enzo: „wir wollen die Friction so niedrig wie möglich halten, dass man gar
     nicht von der PDP runter muss … dann öffnet sich einfach ein Popup, der
     Hintergrund wird ein bisschen blurry … und dann kann man auch in dem Popup
     auf hinzufügen drücken … dann brauche ich nicht noch ein Gratis dazulegen,
     das war schon der Dazuleg-Akt."
     ⛔ Deshalb ist der Knopf „Gratis dazulegen" ERSATZLOS weg. Es gibt genau
     einen Handlungsknopf: den im Popup, und danach den Kaufknopf. */

  /* ==== AA \u00b7 DIE GALERIE SPRINGT AUF DAS PAAR-FOTO, 20.09.2026 ====
     Enzo: \u201eauf jeder Produktseite bei den Bracelets haben wir auch immer ein Bild, wo zwei
     Bracelets sind. Wenn man den Reiter aufmacht, soll sich oben automatisch das Produktbild
     \u00e4ndern auf das, wo zwei sind \u2026 und wenn ich das Produkt \u00e4ndere, dann soll sich nur das
     Bild oben ersetzen. Mein Main Piece bleibt da."

     \u26d4 GEMESSEN, WIE DIE GALERIE SCHALTET (20.09., ICY STELLAR): sieben
     `.product__slide[data-media-id]` mit `media--active`/`media--hidden`, dazu sieben
     `a.product__thumb__link[data-media-id]` in DERSELBEN Reihenfolge. Ein Klick auf das
     Vorschaubild schaltet zuverl\u00e4ssig um.
     \u2b50 Deshalb wird GEKLICKT statt an Klassen gedreht \u2014 so bleibt der Zustand des Themes
     (Wischen, Punkte, Videos) heil. Ein eigener Umschalter w\u00e4re ein zweites Regelwerk.
     \u26d4 Ohne Metafeld `custom.paar_bilder` springt NICHTS. Die Seite bleibt exakt wie bisher. */
  var galerieStart = null;

  function galerieSpringen(index){
    if (index === null || index === undefined) return false;
    var thumbs = document.querySelectorAll('a.product__thumb__link[data-media-id]');
    if (!thumbs.length || index < 0 || index >= thumbs.length) return false;
    if (galerieStart === null) {
      var aktiv = document.querySelector('.product__slide.media--active');
      var alle = Array.prototype.slice.call(document.querySelectorAll('.product__slide[data-media-id]'));
      galerieStart = aktiv ? alle.indexOf(aktiv) : 0;
    }
    try { thumbs[index].click(); } catch(e){ return false; }
    melde('s304_galerie_gesprungen', String(index));
    return true;
  }

  function paarBildZeigen(p){
    if (!p) return;
    galerieSpringen(typeof p.pb === 'number' ? p.pb : null);
  }

  /* \u2b50 21.09.: das Gegenstueck zu `armieren`. `felderSetzen(null)` raeumt die
     versteckten Felder — mehr braucht ein Abwaehlen nicht. */
  function entwaffnen(){
    armiert = null;
    felderSetzen(null);
    leisteSetzen(null);
    kaufknopfSchreiben();
  }

  function armieren(p){
    armiert = p;
    schonGewackelt = true;
    if (wackelUhr) { clearTimeout(wackelUhr); wackelUhr = null; }
    gewaehlt = p;
    felderSetzen(armiert);
    if (dd) dd.innerHTML = zeileGewaehlt(p);
    listeNeu();
    duoZeichnen();
    leisteSetzen(armiert);
    kaufknopfSchreiben();
    zu();
    melde('s304_bundle_armiert');
  }

  /* ---------- Das Popup ---------- */
  var modal = document.createElement('div');
  modal.className = 's304-mod';
  modal.setAttribute('hidden', '');
  modal.innerHTML =
      '<div class="s304-mod__bg"></div>'
    + '<div class="s304-mod__k" role="dialog" aria-modal="true">'
    +   '<button class="s304-mod__x" type="button" aria-label="Schlie\u00dfen">\u00d7</button>'
    +   '<div class="s304-mod__gal"></div>'
    +   '<div class="s304-mod__u">'
    +     '<p class="s304-mod__n"></p>'
    +     '<p class="s304-mod__p"></p>'
    +     '<button class="s304-mod__add" type="button"></button>'
    +     '<a class="s304-mod__mehr" href="#">ganze Produktseite ansehen <span aria-hidden="true">\u2192</span></a>'
    +   '</div>'
    + '</div>';
  document.body.appendChild(modal);

  var mGal  = modal.querySelector('.s304-mod__gal');
  var mName = modal.querySelector('.s304-mod__n');
  var mPr   = modal.querySelector('.s304-mod__p');
  var mAdd  = modal.querySelector('.s304-mod__add');
  var mMehr = modal.querySelector('.s304-mod__mehr');
  var mAktuell = null;

  function modalZu(){
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('s304-mod-offen');
  }
  function modalAuf(p){
    if (!p) return;
    mAktuell = p;
    var bilder = (p.g && p.g.length) ? p.g.slice() : [bild(p)];
    /* ⭐ 21.09.2026 — FREISTELLER ZUERST, wie auf der PDP.
       Enzo: „ich will, dass jedes Produkt immer mit dem Freisteller anfängt."
       ⛔ Gemessen an allen 5 Kandidaten von BIG STEEL: `p.fs` liegt immer an
          Index 1 von `p.g`, nie an 0 — das Popup oeffnete mit einem
          Lifestyle-Foto. Gesucht wird trotzdem DYNAMISCH.
       ⛔ Verglichen wird der DATEINAME ohne Query: `fs` traegt
          `crop=top&height=…`, `g[i]` traegt `width=900`. Ein Vergleich der
          vollen URL faende nie etwas.
       ⛔ `.slice()` ist Pflicht: `p.g` ist dieselbe Array-Referenz wie in
          `D.liste`; ein `splice` darauf wuerde die geteilten Daten dauerhaft
          umsortieren. */
    if (p.fs) {
      var fsDatei = String(p.fs).split('?')[0];
      var fsIdx = -1;
      for (var bi2 = 0; bi2 < bilder.length; bi2++) {
        if (String(bilder[bi2]).split('?')[0] === fsDatei) { fsIdx = bi2; break; }
      }
      if (fsIdx > 0) bilder.unshift(bilder.splice(fsIdx, 1)[0]);
    }
    mGal.innerHTML = bilder.map(function(u, i){
      return '<img src="' + u + '" alt="" ' + (i ? 'loading="lazy"' : '') + '>';
    }).join('');
    mName.textContent = p.n;
    /* ⛔ GRATIS IST IMMER DAS GÜNSTIGERE STÜCK — so rabattiert Shopifys BXGY.
       Ist das gewählte Stück teurer als das Hauptprodukt, wäre „0 €" daran eine
       Lüge: dann wird das HAUPTPRODUKT gratis und dieses hier bezahlt. */
    /* R3, Enzo: \u201e95 Euro soll genauso gro\u00df sein wie 0 Euro, soll durchgeschrieben sein,
       und dann steht da: du zahlst 0 Euro."
       \u26d4 ABER NUR, WENN ES AUCH STIMMT. Seit ein Aufschlag erlaubt ist, kann das gewaehlte
       Stueck teurer sein als das Hauptprodukt \u2014 dann wird das HAUPTPRODUKT gratis und dieses
       hier bezahlt. Live gemessen: Popup sagte "du zahlst 0 \u20ac" fuer ICY STELLAR, der Korb
       berechnete 55 \u20ac. Die Anzeige folgt jetzt dem Geld. */
    if (zweitesIstGratis(p)) {
      mPr.innerHTML = '<s>' + eur(p.p) + '</s><b>0 \u20ac</b>'
                    + '<span class="s304-mod__hin">' + s304T('du zahlst 0 \u20ac', 'you pay 0 \u20ac') + '</span>';
    } else {
      mPr.innerHTML = '<b>' + eur(p.p) + '</b>'
                    + '<span class="s304-mod__hin">' + s304T('daf\u00fcr ist dein ', 'that makes your ') + D.haupt.n
                    + s304T(' gratis \u2014 du zahlst ', ' free \u2014 you pay ') + eur(p.p) + '</span>';
    }
    mAdd.textContent = s304T('gratis hinzuf\u00fcgen', 'add for free');
    mMehr.setAttribute('href', '/products/' + p.h);
    /* ⭐ 21.09.2026 — der Link heisst wie das Produkt.
       Enzo: „da soll dann lieber stehen Produkttitel ansehen mit dem Link."
       ⛔ Nur den TEXTKNOTEN ersetzen — im Anker steckt der Pfeil als eigenes
          <span>. `textContent =` haette ihn geloescht (derselbe Fehler wie
          heute Nacht am Kassenknopf). */
    for (var mi = 0; mi < mMehr.childNodes.length; mi++){
      var mk = mMehr.childNodes[mi];
      if (mk.nodeType === 3 && mk.nodeValue.trim()){
        mk.nodeValue = s304T(p.n + ' ansehen ', 'View ' + p.n + ' ');
        break;
      }
    }
    /* ⛔ Der Klick lief ins Leere: ein Handler weiter oben faengt Klicks im
       Popup ab, um es zu schliessen. Ein eigener Handler mit
       `stopPropagation` laesst den Link zuerst arbeiten. */
    mMehr.onclick = function(ev){
      ev.stopPropagation();
      window.location.href = '/products/' + p.h;
    };
    modal.removeAttribute('hidden');
    document.documentElement.classList.add('s304-mod-offen');
    melde('s304_modal_auf', p.h);
  }

  modal.querySelector('.s304-mod__x').addEventListener('click', function(e){ e.preventDefault(); modalZu(); melde('s304_modal_zu'); });
  modal.querySelector('.s304-mod__bg').addEventListener('click', function(){ modalZu(); melde('s304_modal_zu'); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hasAttribute('hidden')) modalZu(); });
  mAdd.addEventListener('click', function(e){
    e.preventDefault();
    if (!mAktuell) return;
    armieren(mAktuell);
    modalZu();
    melde('s304_modal_hinzugefuegt', mAktuell.h);
  });
  mMehr.addEventListener('click', function(){ melde('s304_bundle_produkt_angesehen'); });

  function istLink(t){ return t.classList && (t.classList.contains('lnk') || t.tagName === 'IMG'); }
  dd.addEventListener('click', function(e){
    /* ⛔ FRÜHER FÜHRTE DER NAME AUF EINE ANDERE SEITE. Genau das wollte Enzo weg:
       „dass man gar nicht von der PDP runter muss." Jetzt öffnet er das Popup. */
    if (istLink(e.target)) { e.preventDefault(); e.stopPropagation(); modalAuf(gewaehlt); return; }
    e.preventDefault(); liste.classList.toggle('auf');
  });
  liste.addEventListener('click', function(e){
    var o = e.target.closest ? e.target.closest('.s304-sel__o') : null;
    if (!o) return;
    e.preventDefault();
    /* \u26d4 In der Liste fuehrt KEIN Klick mehr von der Seite weg \u2014 Bild, Name und Zeile
       oeffnen alle dasselbe Popup. Vorher sprang ein Klick aufs Bild nach /products/null,
       weil Bilder kein data-h tragen. */
    e.stopPropagation();
    var p = D.liste[parseInt(o.getAttribute('data-i'), 10)];
    if (!p) return;
    gewaehlt = p;
    dd.innerHTML = zeileGewaehlt(p);
    listeNeu();                 /* das neu Gewaehlte faellt aus der Liste */
    liste.classList.remove('auf');
    duoZeichnen();
    melde('s304_bundle_gewaehlt', p.h);
    paarBildZeigen(p);   /* AA: nur das Bild oben wechselt, das Hauptprodukt bleibt */
    /* \u26d4 21.09. nachts: hier stand `modalAuf(p)` — ein Tipp waehlte aus UND
       oeffnete das Produktfenster. Enzo: „die Auswahlvariante ist einfach nur
       mit anklicken." Das Fenster kommt jetzt ausschliesslich ueber
       „MEHR ERFAHREN" im Blatt. */
  });

  /* ---------- Die schwebende Leiste ----------
     Enzo, 20.09.: „wenn man halt ein Bundle erstellt hat, ist da trotzdem immer
     noch nur der Preis vom Normalen. Da muessen dann beide Walletchains auftauchen."
     ⛔ Deshalb wird jetzt die KOPFZEILE der Leiste umgeschrieben statt eine
     zweite Zeile daruntergehaengt — sonst waechst die Leiste (gemessen 153 → 193 px)
     und die Kopfzeile widerspricht dem Knopf darunter.
     ⛔ Der Originalinhalt wird beim ersten Mal gesichert und beim Entfernen exakt
     zurueckgeschrieben. */
  function leisteSetzen(p){
    var bar = document.querySelector('cart-bar');
    if (!bar) return;
    var alt = bar.querySelector('.s304-cb'); if (alt) alt.remove();
    var kopf = bar.querySelector('.cart-bar__row-top');
    if (!kopf) return;
    if (!kopf.hasAttribute('data-s304-alt')) kopf.setAttribute('data-s304-alt', kopf.innerHTML);
    if (!p) { kopf.innerHTML = kopf.getAttribute('data-s304-alt'); kopf.classList.remove('s304-duo-kopf'); return; }
    kopf.classList.add('s304-duo-kopf');
    kopf.innerHTML =
        '<span class="s304-lb">'
      +   '<img src="'+bild(D.haupt)+'" alt="">'
      +   '<span class="s304-duo__plus">+</span>'
      +   '<span class="s304-duo__zw"><img src="'+bild(p)+'" alt="">'
      +     '<span class="s304-duo__gratis">' + s304T('gratis', 'free') + '</span></span>'
      + '</span>'
      + '<span class="s304-ln">'+D.haupt.n+' <span class="pl">+</span> '+p.n+'</span>'
      + '<span class="s304-lp">'+eur(D.haupt.std)+'</span>';
    kopf.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      auf(); huelle.scrollIntoView({block:'center', behavior:'smooth'});
      melde('s304_leiste_getippt');
    });
  }
  if (armiert) { felderSetzen(armiert); leisteSetzen(armiert); }

  /* ---------- Seitlicher Streifen nach 15 s, Blase nach 45 s ---------- */
  var gesehen = 's304_gesehen_' + (D.haupt.h || '');
  function einmalProSitzung(schluessel){
    try { if (sessionStorage.getItem(schluessel)) return false;
          sessionStorage.setItem(schluessel, '1'); return true; }
    catch(e) { return true; }
  }

  var streifen = document.createElement('button');
  streifen.className = 's304-str'; streifen.type = 'button';
  streifen.innerHTML = '<span class="z1">' + s304T('2 FÜR 1', '2 FOR 1') + '</span><span class="z2">' + s304T('zweites gratis', 'second one free') + '</span>'
    + '<span class="pf">‹</span>';
  streifen.addEventListener('click', function(e){
    e.preventDefault(); auf(); liste.classList.add('auf');
    huelle.scrollIntoView({block:'center', behavior:'smooth'});
    melde('s304_streifen_getippt');
  });
  document.body.appendChild(streifen);

  var blase = document.createElement('div');
  blase.className = 's304-bl';
  blase.innerHTML = '<button class="s304-bl__x" type="button" aria-label="' + s304T('schließen', 'close') + '">&times;</button>'
    + '<img src="'+bild(D.haupt)+'" alt="">'
    + '<p class="s304-bl__t">' + s304T('Schon vom <b>2 für 1</b> gehört? Zwei ', 'Heard about <b>2 for 1</b>? Two ')
    + (D.haupt.typ === 'Walletchain' ? s304T('Walletchains', 'wallet chains') : s304T('Bracelets', 'bracelets')) + s304T(', du zahlst ', ', you pay for ')
    + (D.haupt.typ === 'Walletchain' ? s304T('eine', 'one') : s304T('eins', 'one')) + '.</p>';
  blase.querySelector('.s304-bl__x').addEventListener('click', function(e){
    e.preventDefault(); e.stopPropagation(); blase.classList.remove('da'); melde('s304_blase_zu');
  });
  blase.querySelector('.s304-bl__t').addEventListener('click', function(e){
    e.preventDefault(); blase.classList.remove('da'); auf(); liste.classList.add('auf');
    huelle.scrollIntoView({block:'center', behavior:'smooth'});
    melde('s304_blase_getippt');
  });
  document.body.appendChild(blase);

  /* ⛔ Hintergrund-Tabs drosseln Timer auf ~1x/Minute. Deshalb erst starten,
     wenn die Seite sichtbar ist, und bei Rückkehr neu takten. */
  var t1, t2;
  function offen(){ return fenster.classList.contains('da'); }
  function takten(){
    clearTimeout(t1); clearTimeout(t2);
    if (document.visibilityState !== 'visible') return;
    t1 = setTimeout(function(){
      if (armiert || offen()) return;
      if (!einmalProSitzung(gesehen + '_str')) return;
      streifen.classList.add('da'); melde('s304_streifen_gezeigt');
    }, 15000);
    t2 = setTimeout(function(){
      if (armiert || offen()) return;
      if (!einmalProSitzung(gesehen + '_bl')) return;
      blase.classList.add('da'); melde('s304_blase_gezeigt');
    }, 45000);
  }
  document.addEventListener('visibilitychange', takten);
  takten();

  /* ⛔⛔ 20.09.2026 — HIER LAG DER SEITEN-CRASH. NICHT WIEDER SO BAUEN.
     Vorher stand hier:
       new MutationObserver(...).observe(document.body,
         {attributes:true, subtree:true, attributeFilter:['class']})
     und im Rueckruf `streifen.classList.remove('da')`.
     DOMTokenList.remove() SCHREIBT das Klassen-Attribut auch dann, wenn das Wort
     gar nicht drin war. Das erzeugt einen neuen Mutationsdatensatz -> der Rueckruf
     feuert erneut -> und weil MutationObserver-Rueckrufe MIKROTASKS sind, gibt der
     Hauptthread NIE wieder ab. Folge: beim Oeffnen der Warenkorb-Schublade fror die
     ganze Seite ein, auch Neuladen ging nicht mehr.
     ⛔ Ich hatte den Haenger viermal selbst im Browser-Werkzeug gesehen und ihn dem
     WERKZEUG angelastet statt dem Shop. Gemeldet hat es Enzo.
     Jetzt zwei Riegel: (1) nur das Schubladen-Element selbst beobachten, ohne
     subtree — Aenderungen an streifen/blase koennen den Beobachter gar nicht mehr
     erreichen; (2) nur anfassen, wenn die Klasse wirklich gesetzt ist. */
  function wegnehmen(){
    if (streifen.classList.contains('da')) streifen.classList.remove('da');
    if (blase.classList.contains('da')) blase.classList.remove('da');
  }
  var schublade = document.querySelector('cart-drawer, .drawer--cart');
  if (schublade) {
    var beobachter = new MutationObserver(function(){
      if (schublade.classList.contains('is-open')) wegnehmen();
    });
    beobachter.observe(schublade, {attributes: true, attributeFilter: ['class']});
  }
  /* Zusaetzlich die Ereignisse des Themes nutzen — kostet nichts und wirkt auch,
     falls die Schublade erst spaeter in den Baum kommt. */
  ['theme:cart:open', 'theme:drawer:open', 'theme:cart:add'].forEach(function(n){
    document.addEventListener(n, wegnehmen);
  });

  window.S304_BUNDLE = { daten: D, gewaehlt: function(){ return gewaehlt; },
                         armiert: function(){ return armiert; },
                         /* \u2b50 Das Blatt von unten braucht das: `armieren` setzt ueber
                            `felderSetzen()` die versteckten Formularfelder. Ohne den
                            Aufruf legt der Kaufknopf NUR das Hauptprodukt ein. */
                         armieren: function(p){ armieren(p || gewaehlt); },
                         /* \u2b50 „MEHR ERFAHREN" im Blatt braucht einen direkten Weg
                            ins Produktfenster — der Klick auf den Namen wird seit
                            dem 21.09. nicht mehr abgefangen. */
                         entwaffnen: function(){ entwaffnen(); },
                         zeigen: function(h){
                           var p = null;
                           for (var i = 0; i < D.liste.length; i++)
                             if (D.liste[i].h === h) { p = D.liste[i]; break; }
                           if (p) modalAuf(p);
                         } };
  melde('s304_bundle_bereit');
})();

/* ==== 2 FÜR 1 — KOLLEKTIONSSEITE, Stand 20.09.2026 ====
   Enzo woertlich, zur Form: „ich will eigentlich, dass da ganz normal wieder steht,
   wie es bei uns im Theme ist, Wallet Chains oder Bracelets und da drunter einfach
   in einem schwarz umrandeten Kasten, so rund, aber in der Mitte ist es weiss."

   ⛔ WARUM PER JS UND NICHT PER LIQUID: die Zeile mit Titel und Sternen
      (.wc-trust-header) wird selbst von JavaScript in layout/theme.liquid (~1186)
      erzeugt und haengt NICHT in einer Shopify-Sektion. Ein Liquid-Block koennte
      sich nicht darunter setzen. Gemessen am 20.09.
   ⛔ NUR auf Kollektionen, bei denen 2 fuer 1 auch wirklich greift. Die Rabattregeln
      sind auf Standard-Varianten von Bracelet und Walletchain gesetzt — eine gemischte
      Kollektion wie „bewerbbar" bekommt deshalb KEIN Band, sonst verspraeche es etwas,
      das zwischen den Kategorien nicht gilt. */
(function(){
  "use strict";
  if (!document.body || !document.body.classList.contains('template-collection')) return;

  /* Enzo, 20.09.: Variante „mit den Stuecken", und sein Wortlaut:
     „Lege zwei Bracelets in den Warenkorb und bezahle eins."
     ⛔ Satz und Bilder kommen aus snippets/304-kollektion-daten.liquid — die
     Freisteller stecken in einem Metafeld, das der oeffentliche products.json
     NICHT liefert. Ohne Datenblock baut dieser Block nichts. */
  var quelleK = document.getElementById('s304-kol-daten');
  if (!quelleK) return;
  var DK; try { DK = JSON.parse(quelleK.textContent); } catch(e) { return; }
  if (!DK || !DK.satz) return;
  if (document.querySelector('.s304-kb')) return;

  function melde(name){
    try { if (window.clarity) window.clarity('event', name); } catch(e){}
    try { if (window.dataLayer) window.dataLayer.push({event:name}); } catch(e){}
  }

  var kasten = document.createElement('div');
  /* \u2b50 21.09. nachts: eine Kennung je Kollektion, damit jedes Band sein
     eigenes Hintergrundbild bekommt (Enzo: „diese zwei Armb\u00e4nder auf dem
     Schmuckst\u00e4nder hinter dieses zwei kaufen ein bezahlen"). Die Kennung
     kommt aus der Adresse, nicht aus dem Text \u2014 der ist \u00fcbersetzt. */
  var kslug = (location.pathname.match(/\/collections\/([a-z0-9\-]+)/i) || [])[1] || '';
  kasten.className = 's304-kb' + (kslug ? ' s304-kb--' + kslug : '');
  var bs = (DK.bilder || []).slice(0, 2);
  var bilder = bs.length === 2
    ? '<img src="'+bs[0]+'" alt="" loading="lazy" width="34" height="34">'
      + '<span class="s304-duo__plus">+</span>'
      + '<span class="s304-duo__zw"><img src="'+bs[1]+'" alt="" loading="lazy" width="34" height="34">'
      + '<span class="s304-duo__gratis">' + s304T('2 f\u00fcr 1', '2 for 1') + '</span></span>'
    : bs.map(function(u){ return '<img src="'+u+'" alt="" loading="lazy" width="34" height="34">'; }).join('');
  kasten.innerHTML =
      (bilder ? '<span class="s304-kb__b">' + bilder + '</span>' : '')
    + (function(){
        /* ⭐ 21.09.2026 — drei Zeilen statt zwei, Text links.
           „2 FÜR 1" · „Fall Collection" · der Satz. Geteilt wird an dem „·",
           das Liquid schon liefert; ohne „·" bleibt es bei zwei Zeilen. */
        /* ⭐ 21.09.2026 — VARIANTE A: die Rechnung statt des Satzes.
           Enzo: „Die Rechnung finde ich am besten. Zwei kaufen, einen
           bezahlen." Der erklaerende Satz faellt weg; die Kollektion bleibt
           als kleine Zeile darunter. */
        var k = DK.kopf || '';
        var teile = k.split('\u00b7');
        var kollektion = (teile[1] || '').trim();
        return '<span class="s304-kb__tx">'
             +   '<span class="s304-kb__t1">' + /* S304-KOPF-2FUER1 */ s304T('2 F\u00dcR 1', '2 FOR 1') + '</span>'
             +   '<span class="s304-kb__t1b">' + s304T('', '') + '</span>'
             +   '<span class="s304-kb__t2">' + s304T('1 KAUFEN \u00b7 1 GESCHENKT', '1 BOUGHT \u00b7 1 FREE') + '</span>'
             + '</span>';
      })();

  /* ⛔ 20.09.2026 — DER RUECKFALL DARF NICHT SOFORT GREIFEN.
     Erste Fassung setzte das Band sofort vor die Raster-Sektion, wenn
     .wc-trust-header noch fehlte — und das Theme schob die Titelzeile danach
     DAZWISCHEN. Gemessen: Band bei 94 px, Titelzeile bei 169, Kachel bei 248,
     also genau verkehrt herum. Deshalb: zuerst nur auf die Titelzeile warten,
     den Rueckfall erst, wenn sie nach 6 Sekunden nicht gekommen ist. */
  function setzen(erlaubeRueckfall){
    if (document.querySelector('.s304-kb')) return true;
    var kopf = document.querySelector('.wc-trust-header');
    if (kopf && kopf.parentNode) {
      kopf.parentNode.insertBefore(kasten, kopf.nextSibling);
      melde('s304_kollektion_band_gezeigt');
      return true;
    }
    if (!erlaubeRueckfall) return false;
    var raster = document.querySelector('grid-item');
    var abschnitt = raster && raster.closest('.shopify-section, [id^="shopify-section"]');
    if (abschnitt && abschnitt.parentNode) {
      abschnitt.parentNode.insertBefore(kasten, abschnitt);
      melde('s304_kollektion_band_gezeigt_rueckfall');
      return true;
    }
    return false;
  }

  if (!setzen(false)) {
    var beob = new MutationObserver(function(){ if (setzen(false)) beob.disconnect(); });
    beob.observe(document.body, {childList:true, subtree:true});
    setTimeout(function(){ beob.disconnect(); setzen(true); }, 6000);
  }

  /* ================= A/B-TESTS AUF DER KOLLEKTIONSSEITE =================
     Enzo, 20.09.: „lass uns auch einen A/B-Test machen … wenn wir eh schon den
     Preis auf der Kategorieseite machen, können wir auch noch den A/B-Test
     2 für 1 machen."

     ⛔ Die Zuweisung faellt EINMAL pro Geraet und bleibt liegen — sonst sieht
        derselbe Besucher beim zweiten Besuch die andere Fassung und die Messung
        ist wertlos.
     ⛔ Die Gruppe geht als Merkmal an Clarity (`clarity('set', …)`), dort laesst
        sich danach filtern. Ohne Clarity passiert nichts.
     ⭐ Zwei Tests gleichzeitig ergeben vier Zellen. Bei rund 107 Sitzungen am Tag
        reicht das fuer eine RICHTUNG, nicht fuer einen Beweis — die Zahl steht in
        memory/STAND-…, gemessen am 19.09. */
  function gruppe(test){
    var schluessel = 's304_ab_' + test;
    var g = null;
    try { g = localStorage.getItem(schluessel); } catch(e){}
    if (g !== 'A' && g !== 'B') {
      g = Math.random() < 0.5 ? 'A' : 'B';
      try { localStorage.setItem(schluessel, g); } catch(e){}
    }
    try { if (window.clarity) window.clarity('set', schluessel, g); } catch(e){}
    try { if (window.dataLayer) window.dataLayer.push({event:'s304_ab', test:test, gruppe:g}); } catch(e){}
    return g;
  }

  var eur2 = function(n){ return (Math.round(n*100)/100).toString().replace('.',',') + ' €'; };

  /* Test 1 — Preis auf der Kachel. A: kein Preis (wie heute). B: Standardpreis.
     ⭐ WIEDERVERWENDUNG STATT NEUBAU: layout/theme.liquid baut in injectPrices()
        laengst ein Preisraster je Kachel — `.wc-price-standard` (55 €) und
        `.wc-price-ic` (35 €) — und versteckt es nur. Am 20.09. gemessen: beide
        Spans sind auf allen 12 Kacheln da, display:none.
     ⭐ Deshalb nur eine KLASSE an die Wurzel und das Zeigen per CSS. Das loest
        auch das Zeitproblem: injectPrices() holt jedes Produkt einzeln per fetch,
        die Spans entstehen also spaeter als dieser Code laeuft. Eine CSS-Regel
        greift, sobald sie da sind — ganz ohne Beobachter.
     ⛔ `.wc-price-ic` bleibt aus: das ist der zweite Preis, der heute ueberall
        gefallen ist. */
  /* ⛔ 20.09.2026 — DER PREIS-TEST IST BEENDET, BEVOR ER LIEF. Enzos Einwand:
     „wenn wir Leute haben, die ein Bundle sich aussuchen wollen, dann muss man ja
     eigentlich den Preis sehen."
     Nachgerechnet: am Bundle selbst aendert es nichts — es wird immer das
     GUENSTIGERE Stueck gratis, egal in welcher Reihenfolge gewaehlt wird, und der
     Kasten auf der Produktseite bietet ohnehin nur Stuecke bis zum Preis des
     gewaehlten an. Der Schaden liegt woanders: „2 für 1" ist eine Aussage UEBER
     den Preis. Auf der Seite, die das Angebot ankuendigt, den Preis zu verstecken,
     macht die Aussage unbeantwortbar. Ein Arm, der das Angebot unlesbar macht,
     ist kein fairer Testarm.
     ⭐ Nebeneffekt: ein Test statt zwei heisst zwei Zellen statt vier — bei rund
     107 Sitzungen am Tag doppelte Aussagekraft fuer die Frage, die offen ist.
     ⭐ RUECKWEG zum Test: die naechste Zeile wieder durch
        `var gPreis = gruppe('preis_kachel'); if (gPreis === 'B') { … }` ersetzen. */
  document.documentElement.classList.add('s304-ab-preis-b');

  /* Test 2 — „2 FÜR 1" auf der Kachel. A: nur das Band. B: Band + Zeichen.
     ⛔ „2+1" waere falsch — Enzo: „2+1 macht dann ja keinen Sinn, sondern
        2 für 1 muss dann ja da stehen." */
  /* ⛔ 20.09.2026 — DAS „2 FÜR 1"-ZEICHEN AUF DER KACHEL IST RAUS.
     Enzo woertlich: „lasst uns einfach 2 für 1 rausnehmen von dem Bild, da wird
     es auch cleaner. Wir lassen die Preise dort."
     Der Test wandert auf die Frage, die jetzt offen ist: klebt der Kopf oder nicht.

     ⭐ KLEBENDER KOPF (Test B): Titel, Sternzeile und der 2-für-1-Kasten bleiben
     oben stehen, darunter scrollen nur die Produkte. Enzo: „machen wir einfach
     sticky sozusagen und man scrollt danach nur die Produkte."
     ⛔ Der Versatz wird GEMESSEN, nicht geraten — der Shop-Kopf ist selbst klebend
     und seine Hoehe haengt vom Laufband ab. */
  /* ⛔⛔ 20.09.2026 NACHTS — DAS KLEBEN IST ABBESTELLT.
     Enzo woertlich, nachdem er es live gesehen hat: „macht es auf der
     Kategorie Seite doch so, dass oben dieses Walletchain und der Kasten
     einfach weg sind, wenn man runterscrollt, also wie am Anfang."
     Das war SEIN eigener Wunsch von heute frueh („machen wir einfach sticky")
     — am Bildschirm hat er sich gegen ihn entschieden. Der ganze Apparat
     (Versatzmessung, Verlauf, Titel-Einklappen) bleibt stehen und ist
     abgeschaltet; der Rueckweg ist das Loeschen der einen Zeile darunter.
     ⭐ Damit faellt Test B ersatzlos weg: `gruppe()` wird gar nicht erst
     gerufen, also bekommt auch Clarity kein Merkmal mehr dafuer — sonst
     stuenden dort zwei Gruppen, die dasselbe sehen. Test 1 (Kachelpreis)
     laeuft unberuehrt weiter. */
  var gKopf = 'A';   /* <- diese Zeile durch gruppe('kopf_klebt') ersetzen, dann klebt es wieder */
  if (gKopf === 'B') {
    var klebenGesetzt = false;
    function kopfKleben(){
      if (klebenGesetzt) return true;
      var trust = document.querySelector('.wc-trust-header');
      var band  = document.querySelector('.s304-kb');
      if (!trust || !band || band.previousElementSibling !== trust) return false;
      /* ⛔ GEMESSEN, NICHT GERATEN: der Shop-Kopf heisst hier `header.theme__header`
         und steht selbst auf `position: absolute` — die alte Abfrage auf
         sticky/fixed lieferte deshalb 0, und die Titelzeile verschwand unter dem
         Logo-Balken (am 20.09. gemessen: Trustzeile oben 0, Logo deckte 0–52).
         Klebend ist nicht er, sondern ein VORFAHR. Darum den Baum hochlaufen. */
      function versatzMessen(){
        var kand = document.querySelectorAll('header.theme__header, header.header, #shopify-section-header, .site-header');
        var max = 0;
        Array.prototype.forEach.call(kand, function(e){
          if (e.closest('.drawer, cart-drawer, .modal')) return;
          var r = e.getBoundingClientRect();
          if (r.height < 20 || r.height > 220) return;
          if (r.top > 4) return;
          var klebt = false, n = e;
          while (n && n !== document.body) {
            var p = getComputedStyle(n).position;
            if (p === 'fixed' || p === 'sticky') { klebt = true; break; }
            n = n.parentElement;
          }
          if (!klebt) return;
          if (r.bottom > max) max = r.bottom;
        });
        return Math.round(max);
      }
      /* ⛔ ZWEITER FEHLER, live gemessen: der Shop-Kopf ist erst FIXED, wenn man
         gescrollt hat (`header__wrapper.js__header__stuck`). Beim Messen nach
         200/700/1600 ms steht die Seite oben — also kam 0 heraus, und die
         Titelzeile lag unter dem Logo-Balken.
         Darum wird `top` nicht EINMAL gesetzt, sondern bei jedem Scrollen neu:
         `max(Unterkante Shop-Kopf, natuerliche Lage des Platzhalters)`.
         Das ist genau das, was `position: sticky` taete — und das geht hier
         nicht, weil `main-content` `overflow-x: hidden` hat. */
      /* ⛔ `position: sticky` wirkt hier NICHT: `main-content` hat
         `overflow-x: hidden`, und das macht den Block zum eigenen Scroll-Container —
         die Klebe-Referenz ist dann er selbst, nicht das Fenster. Am 20.09. gemessen
         (nach dem Scrollen auf 1400 stand der Kopf bei −1316).
         Deshalb `fixed` plus Platzhalter, statt am Overflow des Themes zu drehen —
         der verhindert waagerechtes Scrollen und soll bleiben. */
      var halter = document.createElement('div');
      halter.className = 's304-kopf-platz';
      var huelle = document.createElement('div');
      huelle.className = 's304-kopf-klebt';
      trust.parentNode.insertBefore(halter, trust);
      halter.appendChild(huelle);
      huelle.appendChild(trust); huelle.appendChild(band);
      function topSetzen(){
        var grenze = versatzMessen();
        var nat = halter.getBoundingClientRect().top;
        huelle.style.top = Math.round(Math.max(grenze, nat)) + 'px';
      }
      function platzSetzen(){
        halter.style.height = Math.round(huelle.getBoundingClientRect().height) + 'px';
        topSetzen();
      }
      platzSetzen();
      [200, 700, 1600].forEach(function(ms){ setTimeout(platzSetzen, ms); });
      window.addEventListener('resize', platzSetzen);
      var tickt = false;
      window.addEventListener('scroll', function(){
        if (tickt) return;
        tickt = true;
        requestAnimationFrame(function(){ tickt = false; topSetzen(); });
      }, {passive: true});
      klebenGesetzt = true;
      melde('s304_ab_kopf_klebt_b');
      return true;
    }
    if (!kopfKleben()) [400, 1200, 2500, 4500].forEach(function(ms){ setTimeout(kopfKleben, ms); });
  }
})();

/* ==== 2 FÜR 1 — der offene Platz im Warenkorb, Stand 20.09.2026 ====
   Das Markup kommt aus snippets/304-bundle-korb.liquid und wird mit der
   Schublade gerendert. Hier steht nur der Klick-Griff.
   ⭐ BEWUSST DELEGIERT auf document: die Warenkorb-Schublade wird vom Theme
      bei jeder Aenderung neu gezeichnet. Ein Horcher am Element waere danach
      weg; einer am Dokument ueberlebt jedes Neuzeichnen — ohne Beobachter,
      ohne Wieder-Einhaengen. */
(function(){
  "use strict";
  function melde(name){
    try { if (window.clarity) window.clarity('event', name); } catch(e){}
    try { if (window.dataLayer) window.dataLayer.push({event:name}); } catch(e){}
  }
  /* ⛔⛔ 20.09.2026 — WARUM DER BLOCK IM WARENKORB FEHLTE.
     Enzo: „ich hab kein Bundle ausgewaehlt gehabt und bin jetzt im Warenkorb und
     jetzt ist kein Vorschlag fuer das Bundle hier drinne."
     Ursache, im Theme gefunden: `updateFooterPrices` (layout/theme.liquid ~862)
     holt die Schublade per `/?sections=<id>` neu — kopiert daraus aber NUR vier
     namentlich bekannte Stellen: Mitgliedersumme, Zwischensumme, Spar-Banner,
     Preishalter. Alles andere bleibt auf dem Stand des Seitenaufrufs.
     Mein Block ist Liquid und haengt am Warenkorb-Inhalt — er erschien also nur,
     wenn die Seite schon mit ungerader Stueckzahl geladen wurde. Wer erst danach
     etwas hineinlegt, sah nichts.
     ⭐ Deshalb frische ich ihn selbst auf, mit derselben Quelle, und schalte den
     Cross-Sell per `hidden` statt ihn zu ersetzen — sonst verliert er seine
     Klick-Griffe. */
  var korbSyncLaeuft = false;
  function korbBlockAuffrischen(){
    if (korbSyncLaeuft) return;
    var schublade = document.querySelector('cart-drawer');
    if (!schublade) return;
    var sec = document.querySelector('[id*="cart-drawer"]');
    var sid = sec ? sec.id.replace('shopify-section-', '') : null;
    if (!sid) return;
    korbSyncLaeuft = true;
    fetch('/?sections=' + encodeURIComponent(sid), {headers: {'Accept': 'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(s){
        var k = Object.keys(s)[0]; if (!k) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = s[k];
        var frisch = tmp.querySelectorAll('[data-s304-korb]');
        Array.prototype.forEach.call(schublade.querySelectorAll('[data-s304-korb]'), function(x){ x.remove(); });
        var cs = schublade.querySelector('[data-cross-sell]');
        if (!frisch.length) { if (cs) cs.hidden = false; return; }
        var anker = cs || schublade.querySelector('.drawer__foot');
        if (!anker || !anker.parentNode) return;
        Array.prototype.forEach.call(frisch, function(b){
          anker.parentNode.insertBefore(b.cloneNode(true), anker);
        });
        if (cs) cs.hidden = true;   /* der guenstigere Vorschlag steht davor */
        melde('s304_korb_block_aufgefrischt');
      })
      .catch(function(){})
      .then(function(){ korbSyncLaeuft = false; });
  }
  ['theme:cart:refresh', 'theme:cart:update', 'theme:cart:add'].forEach(function(n){
    document.addEventListener(n, function(){ setTimeout(korbBlockAuffrischen, 400); });
  });

  document.addEventListener('click', function(e){
    var k = e.target && e.target.closest ? e.target.closest('[data-s304-add]') : null;
    if (!k) return;
    e.preventDefault(); e.stopPropagation();
    if (k.classList.contains('laeuft')) return;
    var id = parseInt(k.getAttribute('data-s304-add'), 10);
    if (!id) return;
    k.classList.add('laeuft');
    melde('s304_korb_zweites_getippt');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: id, quantity: 1}]})
    })
    .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(function(){
      melde('s304_korb_zweites_dazu');
      /* Das Theme zeichnet die Schublade selbst neu — theme.dev.js:1486
         horcht auf genau dieses Ereignis. Kein eigener Neuaufbau. */
      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      setTimeout(korbBlockAuffrischen, 700);
    })
    .catch(function(){
      k.classList.remove('laeuft');
      melde('s304_korb_zweites_fehler');
    });
  }, true);
})();

/* ==== VARIANTE „Schwebender Kauf-Knopf" — nur in dieser Theme-Kopie, 20.09.2026 ====
   Gehoert zum CSS-Block gleichen Namens. Drei Dinge, sonst nichts:
     1. Marke `s304-schwebe` am <html> setzen — nur auf der Produktseite.
     2. Runterscrollen -> Leiste weg. Hochscrollen -> sofort zurueck.
     3. Scrollen hoert auf -> nach 850 ms zurueck („geht KURZ weg").

   ⛔ GEMESSEN, NICHT GERATEN (20.09., live):
   - Der sichtbare Knopf heisst `#cart-bar-custom-atc` und steht in
     snippets/cart-bar.liquid. Sein Klick sucht den ECHTEN Kaufknopf und ruft
     dessen `.click()`. Ein per `display:none` verborgener Knopf nimmt einen
     programmatischen Klick weiterhin an — nur `disabled` wuerde ihn schlucken.
     Deshalb darf der PDP-Knopf verschwinden, ohne den Kaufweg zu kappen.
   - Das `is-visible` der Leiste setzt ein IntersectionObserver auf genau diesen
     Kaufknopf. Ist er `display:none`, meldet der Beobachter dauerhaft
     „nicht im Bild" — die Leiste bliebe also ohnehin stehen. Wir verlassen uns
     NICHT darauf: das CSS erzwingt die Sichtbarkeit zusaetzlich.
   ⛔ KEIN eigener Klick-Griff. Der Kaufweg bleibt exakt der bestehende. */
(function(){
  "use strict";
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;
  /* ⛔ 20.09.2026, nach Enzos Rueckmeldung: NICHT mehr wegnehmen beim Runterscrollen.
     Er woertlich: „wenn ich runter scrolle, ist der direkt weg — ist natuerlich auch nicht gut."
     ⭐ Gemessen war seine Beobachtung der LIVE-Stand, nicht diese Variante: dort sass der
     eingebettete Kaufknopf bei y=830 am unteren Rand des ersten Schirms und sah aus wie ein
     schwebender — beim Runterscrollen wandert er mit der Seite weg, und die echte Leiste kam
     erst ab y≈1400. Beides zusammen ergibt genau „erst richtig, dann weg".
     ⭐ Jetzt: dauerhaft sichtbar. Das Wegnehmen ist EIN Schalter und wieder anschaltbar. */
  var WEG_BEIM_RUNTERSCROLLEN = false;
  var wurzel = document.documentElement;
  /* \u26d4\u26d4 V3, 20.09. 17:40 \u2014 ZURUECKGEDREHT, und das Video sagt warum.
     Aus Enzos KNT-Aufnahme (25 Einzelbilder gerastert): die schwebende Leiste ist dort IMMER
     da \u2014 ausser genau in dem Abschnitt, in dem der ECHTE, eingebettete Kaufknopf im Bild ist.
     Beim Hochscrollen kommt sie wieder. Das ist der IntersectionObserver auf dem echten Knopf,
     also genau das, was dieses Theme von sich aus tut.
     \u2b50 Deshalb: der Inline-Knopf bleibt sichtbar (Enzos Screenshot zeigt ihn), und die
     Sichtbarkeit der Leiste macht wieder das Theme. Was bleibt: der schwarze 60-px-Knopf,
     der mitgeschriebene Text und der Messpunkt. */
  wurzel.classList.add('s304-schwebe-mess');

  function leiste(){ return document.querySelector('cart-bar'); }

  var letzte = window.scrollY || 0;
  var gesammelt = 0;
  var ruheUhr = null;
  var tickt = false;

  function zeigen(){
    var l = leiste(); if (l) l.classList.remove('s304-weg');
  }
  function verstecken(){
    var l = leiste(); if (l) l.classList.add('s304-weg');
  }

  function pruefen(){
    var y = window.scrollY || 0;
    var d = y - letzte;
    letzte = y;
    if (Math.abs(d) < 2) return;

    if (d > 0) {
      /* runter: erst ab 56 px gesammelter Bewegung, damit ein Wackeln beim
         Antippen die Leiste nicht wegblitzen laesst. Und nie im obersten
         Bildschirm — dort waere das Wegnehmen nur nervig. */
      gesammelt = gesammelt > 0 ? gesammelt + d : d;
      if (WEG_BEIM_RUNTERSCROLLEN && gesammelt > 56 && y > 220) verstecken();
    } else {
      gesammelt = gesammelt < 0 ? gesammelt + d : d;
      if (gesammelt < -24) zeigen();
    }

    if (ruheUhr) clearTimeout(ruheUhr);
    ruheUhr = setTimeout(function(){ gesammelt = 0; zeigen(); }, 850);
  }

  window.addEventListener('scroll', function(){
    if (tickt) return;
    tickt = true;
    requestAnimationFrame(function(){ tickt = false; pruefen(); });
  }, {passive: true});

  /* Wird der Warenkorb geoeffnet, hat die Leiste dort nichts zu suchen. */
  ['theme:cart:open','theme:drawer:open'].forEach(function(n){
    document.addEventListener(n, verstecken);
  });

  /* ==== DER FEHLENDE MESSPUNKT, 20.09.2026 ====
     ⛔ Beim Nachpruefen gefunden: `s304_leiste_getippt` haengt an der KOPFZEILE
     der alten Leiste (Produktname + Preis) — die ist per CSS weg, das Ereignis
     kann also nie feuern. Der sichtbare Knopf `#cart-bar-custom-atc` hatte gar
     keinen. Seit der PDP-Kaufknopf verborgen ist, laeuft JEDER Warenkorb-Klick
     ueber ihn.
     ⭐ Drei Groessen, und sie ergeben zusammen eine Warenkorb-Rate:
       s304_pdp_gesehen          — der Nenner, einmal je Seitenaufruf
       s304_schwebeknopf_getippt — der Zaehler
       s304_mit_bundle           — Merkmal, ob das Bundle scharf war (ja/nein)
     ⛔ Delegiert auf document und in der ERFASSUNGS-Phase: der Knopf hat einen
     eigenen Klick-Griff, der die Kette abbricht (`preventDefault`). */
  function melden(name, wert){
    try { if (window.clarity) window.clarity('event', name); } catch(e){}
    try { if (window.clarity && wert) window.clarity('set', name + '_wert', wert); } catch(e){}
    try { if (window.dataLayer) window.dataLayer.push({event: name, wert: wert || null}); } catch(e){}
  }
  melden('s304_pdp_gesehen');

  document.addEventListener('click', function(e){
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;
    var k = ziel.closest('#cart-bar-custom-atc, cart-bar .cart-bar__atc-btn');
    if (!k) return;
    var scharf = false;
    try { scharf = document.documentElement.classList.contains('s304-armiert')
                 || !!document.querySelector('.s304-duo.armiert, .s304-ok.armiert')
                 || /beide/i.test(k.textContent || ''); } catch(_){}
    melden('s304_schwebeknopf_getippt', scharf ? 'bundle' : 'einzeln');
    melden(scharf ? 's304_mit_bundle' : 's304_ohne_bundle');
  }, true);
})();

/* ==== WARENKORB-FUSS: VERSAND UND LIEFERTERMIN — 20.09.2026 ====
   Liest snippets/304-korb-fuss.liquid (#s304-versand-daten) und baut die zwei
   Zeilen unter der Zwischensumme.

   ⛔ NICHT als `.cart__total` bauen. Das Theme hat die Regel
      `.drawer [data-cart-price-holder] .cart__total:not(:has(.cart__total__price--animated))
       { display:none !important }`
      — die alte Versandzeile stand deshalb im DOM und war 0 px hoch. Eigene Klassen.
   ⛔ Die Summe kommt aus /cart.js, nicht aus dem Markup: die Schublade wird vom Theme
      neu gezeichnet, und dabei werden nur vier namentlich bekannte Stellen mitkopiert.
   ⭐ Der Liefertermin nimmt exakt die Abstaende des Zeitstrahls auf der Produktseite
      (heute+3 bis heute+4). Zwei Stellen mit verschiedenen Terminen waeren schlimmer
      als keine. */
(function(){
  "use strict";

  function daten(){
    var q = document.getElementById('s304-versand-daten');
    if (!q) return null;
    try { return JSON.parse(q.textContent); } catch(e){ return null; }
  }

  function eur(c){
    /* 21.09.2026 — war fest 'de-DE'. Auf /en/ stand dadurch „25,00 € to free
       shipping": deutsche Zahl in einem englischen Satz. Das Eurozeichen bleibt
       hinten, damit es zu den Preisen der Zeilen passt („55 €"). */
    var ort = window.s304EN ? 'en-GB' : 'de-DE';
    try { return (c/100).toLocaleString(ort, {minimumFractionDigits:2, maximumFractionDigits:2}) + ' €'; }
    catch(e){ return (c/100).toFixed(2) + ' €'; }
  }

  function melde(name, wert){
    try { if (window.clarity) window.clarity('event', name); } catch(e){}
    try { if (window.clarity && wert) window.clarity('set', name + '_wert', String(wert)); } catch(e){}
    try { if (window.dataLayer) window.dataLayer.push({event:name, wert: wert || null}); } catch(e){}
  }

  function datum(D, tage){
    var d = new Date();
    d.setDate(d.getDate() + tage);
    /* 21.09.2026 — im Englischen steht der Monat vorn und ohne Punkt:
       „Sep 25" statt „25. Sep". */
    if (window.s304EN) return D.monate[d.getMonth()] + ' ' + d.getDate();
    return d.getDate() + '. ' + D.monate[d.getMonth()];
  }

  var laeuft = false;

  function zeichnen(){
    if (laeuft) return;
    var D = daten();
    if (!D) return;
    var halter = document.querySelector('cart-drawer [data-cart-price-holder], .drawer [data-cart-price-holder]');
    if (!halter || !halter.parentNode) return;
    laeuft = true;
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(k){
        var summe = k.total_price || 0;
        if (!k.item_count) {
          var altLeer = document.querySelector('.s304-fuss');
          if (altLeer) altLeer.remove();
          return;
        }
        var frei = summe >= D.grenze;
        var fehlt = Math.max(0, D.grenze - summe);

        var kasten = document.querySelector('.s304-fuss');
        if (!kasten) {
          kasten = document.createElement('div');
          kasten.className = 's304-fuss';
          halter.parentNode.insertBefore(kasten, halter.nextSibling);
        }
        kasten.innerHTML =
            '<div class="s304-fuss__z">'
          +   '<span class="s304-fuss__l">' + D.worte.versand + '</span>'
          +   '<span class="s304-fuss__w' + (frei ? ' frei' : '') + '">'
          +     (frei ? D.worte.gratis : eur(D.satz))
          +   '</span>'
          + '</div>'
          + (frei ? '' :
              '<div class="s304-fuss__z s304-fuss__hin">'
            +   '<span class="s304-fuss__l">' + eur(fehlt) + ' ' + D.worte.noch + '</span>'
            +   '<span class="s304-fuss__w"></span>'
            + '</div>')
          + '<div class="s304-fuss__z">'
          +   '<span class="s304-fuss__l">' + D.worte.lieferung + '</span>'
          +   '<span class="s304-fuss__w">' + datum(D, 3) + D.worte.bis + datum(D, 4) + '</span>'
          + '</div>';
        melde('s304_korbfuss_gezeigt', frei ? 'gratis' : 'bezahlt');
      })
      .catch(function(){})
      .then(function(){ laeuft = false; });
  }

  ['theme:cart:refresh','theme:cart:update','theme:cart:add','theme:cart:open','theme:drawer:open']
    .forEach(function(n){ document.addEventListener(n, function(){ setTimeout(zeichnen, 350); }); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zeichnen);
  else zeichnen();
  [600, 1800, 4000].forEach(function(ms){ setTimeout(zeichnen, ms); });
  /* Nach einem AJAX-Kauf baut das Theme das Schubfach neu auf und wirft diesen
     Fuss mit weg — Versandkosten und Lieferdatum fehlten dann, obwohl sie beim
     vollen Seitenaufbau da waren (Enzos Screenshot 21:29: nur
     "ZWISCHENSUMME 55 EUR", keine Versandzeile). Die festen Zeitpunkte oben
     greifen nicht, weil der Kauf spaeter passiert als 4 s nach dem Laden.
     Deshalb von aussen aufrufbar: der Warenkorb-Block ruft ihn in seiner
     Nachfass-Serie mit. Kein zweiter Rechenweg, dieselbe Funktion. */
  window.s304Fuss = zeichnen;
})();

/* ==== Das Schwarz unter dem Kaufknopf, 20.09.2026 ====
   Enzo, dreimal: \u201eunten ist das wieder schwarz."
   \u26d4 GEMESSEN, WO ES NICHT HERKOMMT: unter dem Knopf liegt weisse Seite
   (SECTION.s304-community, rgb(255,255,255)). Die Leiste selbst ist durchsichtig.
   \u2b50 Es sind zwei andere Quellen:
     1. <meta name="theme-color" content="#000"> \u2014 damit faerbt Safari SEINE eigene
        untere Leiste schwarz. Das sieht aus wie ein schwarzer Balken unter dem Knopf.
     2. html/body sind auf allen Nicht-Startseiten schwarz; beim Ueberziehen blitzt das durch.
   \u26d4 Nur auf Produkt- und Kategorieseiten umgestellt \u2014 die Startseite bleibt schwarz,
   dort ist es Absicht. Rueckweg: diesen Block entfernen. */
(function(){
  "use strict";
  var s304_themecolor = true;
  function hell(){
    var b = document.body;
    if (!b) return;
    var cls = b.className || '';
    if (cls.indexOf('template-product') === -1 && cls.indexOf('template-collection') === -1) return;
    var m = document.querySelector('meta[name="theme-color"]');
    if (!m) { m = document.createElement('meta'); m.setAttribute('name','theme-color'); document.head.appendChild(m); }
    if (m.getAttribute('content') !== '#ffffff') m.setAttribute('content', '#ffffff');
    document.documentElement.classList.add('s304-heller-grund');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hell);
  else hell();
  [300, 1200, 3000].forEach(function(ms){ setTimeout(hell, ms); });
})();

/* ==== MARKE s304-wc: wo der 1,85×-Zoom gelten darf, 20.09.2026 (abends) ====
   Gehoert zum CSS-Block „REPARATUR: der Zoom lief ueber den Text".
   Der Zoom wurde an den WALLETCHAIN-Freistellern gemessen (5,4–9,6 % Bildflaeche)
   und galt versehentlich auch fuer die Bracelets, die ihren Rahmen gut ausfuellen —
   die wurden dadurch angeschnitten. Diese Marke grenzt ihn auf das ein, wofuer er
   gemessen wurde. Rein additiv: setzt eine Klasse, veraendert nichts Bestehendes. */
(function(){
  "use strict";
  var wurzel = document.documentElement;
  function marke(){
    var wc = false;
    /* 1. Produktseite: der Typ steht in den Bundle-Daten. */
    try {
      var el = document.getElementById('s304-bundle-daten');
      if (el) { var d = JSON.parse(el.textContent || '{}');
        if (d && d.haupt && d.haupt.typ === 'Walletchain') wc = true; }
    } catch(e){}
    /* 2. Kategorieseite: der Pfad sagt es. Gegenprobe /collections/bracelets → false. */
    if (/^\/collections\/walletchains(\/|$)/.test(location.pathname)) wc = true;
    if (wc) wurzel.classList.add('s304-wc'); else wurzel.classList.remove('s304-wc');
    return wc;
  }
  marke();
  /* Die Bundle-Daten stehen im Markup, koennen aber nach einem Variantenwechsel
     neu geschrieben werden — deshalb einmal nachfassen, wenn das DOM steht. */
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', marke, {once:true});
  window.s304MarkeWc = marke;
})();

/* ==== RIEGEL: keine Schwebeleiste, bevor man am Kaufknopf vorbei ist ====
   Gehoert zum CSS-Block „DIE LEISTE KAM, BEVOR MAN AM KNOPF WAR".
   Rein additiv: setzt/entfernt EINE Klasse am <html>, fasst nichts vom Theme an. */
(function(){
  "use strict";
  if (document.body && document.body.className.indexOf('template-product') === -1) return;
  var wurzel = document.documentElement;
  var tickt = false;

  function knopf(){
    /* Der echte, eingebettete Kaufknopf — nicht der in der Leiste. */
    var alle = document.querySelectorAll('button[name="add"], [name="add"]');
    for (var i = 0; i < alle.length; i++){
      var k = alle[i];
      if (k.closest && k.closest('cart-bar')) continue;
      if (k.closest && k.closest('.cart-bar')) continue;
      var r = k.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) continue;   /* verborgene ueberspringen */
      return k;
    }
    return null;
  }

  function pruefen(){
    tickt = false;
    var k = knopf();
    if (!k){
      /* ⛔ Kein messbarer Knopf: NICHT stillschweigend die Leiste sperren —
         dann waere der einzige Kaufweg weg. Im Zweifel Leiste zulassen. */
      wurzel.classList.remove('s304-vor-dem-knopf');
      return;
    }
    var r = k.getBoundingClientRect();
    /* r.bottom > 0  =  der Knopf ist im Bild oder noch darunter → Leiste aus. */
    if (r.bottom > 0) wurzel.classList.add('s304-vor-dem-knopf');
    else              wurzel.classList.remove('s304-vor-dem-knopf');
    fussPruefen();
  }

  /* ⛔ 21.09.2026 — SCHWARZ AUF SCHWARZ AM SEITENENDE.
     Gemessen bei 402×812 ganz unten: Footer 402×390 in `rgb(0,0,0)`, die
     Leiste 374×60 in `rgb(10,10,10)` DARAUF. Beide Flaechen sind je fuer sich
     richtig; zusammen sind sie ein schwarzer Block, in dem der Knopf
     verschwindet. Enzo: „unten ist wieder auch schwarz".
     ⭐ Die Leiste endet, sobald der Footer das untere Drittel erreicht — so
     macht es jeder Shop mit klebendem Kaufknopf. `--s304-leistenhoehe`
     braucht es nicht: gemessen wird gegen die echte Hoehe der Leiste. */
  function fussPruefen(){
    var fuss = document.querySelector('footer, .footer-sections, .site-footer');
    if (!fuss) { wurzel.classList.remove('s304-am-fuss'); return; }
    var leiste = document.querySelector('cart-bar, .cart-bar');
    var hoehe = leiste ? Math.max(leiste.getBoundingClientRect().height, 60) : 60;
    /* ⛔ 21.09., zweiter Anlauf — der erste hatte das Vorzeichen verkehrt.
       GEMESSEN (402×812, Seite vorher setzen lassen): der Footer beginnt im
       Dokument bei y 3638, also footer.top = 3638 − scrollY, und betritt das
       Bild bei scrollY 2826. Die alte Schwelle (innerHeight − hoehe + 8 = 760)
       feuerte erst bei 2878, meine erste Korrektur (− luecke = 746) sogar erst
       bei 2892 — beide, NACHDEM der schwarze Footer schon im Bild steht. Genau
       die 14 px Luft unter der Leiste (`bottom:14px`) und die 14 px links und
       rechts daneben sind dann schwarz: Enzos „unten ist wieder schwarz".
       ⭐ Eine KLEINERE Schwelle heisst SPAETER, nicht frueher — richtig ist
       eine groessere: `innerHeight + vorlauf`. Der Vorlauf deckt die
       0,5-s-Blende ab (gemessen: `opacity .5s, transform .5s`), damit die
       Leiste weg ist, BEVOR der Footer die Unterkante beruehrt. */
    var vorlauf = 140;
    var rf = fuss.getBoundingClientRect();
    if (rf.top < window.innerHeight + vorlauf) wurzel.classList.add('s304-am-fuss');
    else                                       wurzel.classList.remove('s304-am-fuss');
  }

  function takt(){ if (!tickt){ tickt = true; requestAnimationFrame(pruefen); } }

  pruefen();
  addEventListener('scroll', takt, {passive:true});
  addEventListener('resize', takt, {passive:true});
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', pruefen, {once:true});
  /* Der Kasten aendert seine Hoehe beim Auf-/Zuklappen — dann neu messen. */
  document.addEventListener('click', function(){ setTimeout(pruefen, 60); }, true);
  window.s304LeisteRiegel = pruefen;
})();

/* ==== DER GOLD-SCHIMMER AM „INNER CIRCLE MEMBER"-ABZEICHEN, 20.09.2026 ====
   ⛔ CSS kann das nicht: der Ton kommt aus einem per JS gesetzten INLINE-Stil mit
   !important — gemessen am Element:
     background-clip: text !important
     -webkit-text-fill-color: transparent !important
     animation: ic-goldShimmer !important
   Ein Inline-!important schlaegt jedes Stylesheet-!important. Mein CSS-Riegel
   greift korrekt (die Regel steht im ausgelieferten CSS), er verliert nur den
   Wettstreit. Deshalb hier: die drei Inline-Eigenschaften abraeumen.

   ⛔⛔ AUSDRUECKLICH OHNE MutationObserver. Genau so ist am 20.09. der ganze Shop
   eingefroren: Beobachter auf document.body + Schreiben im Rueckruf → neuer
   Datensatz → Rueckruf → Mikrotask-Schleife, der Hauptthread gab nie wieder ab.
   Stattdessen eine ENDLICHE Zahl Durchlaeufe: die Bewertungen kommen aus einem
   Slider, der nachlaedt, also mehrere Zeitpunkte statt Dauerbeobachtung.
   Jeder Durchlauf schreibt nur, wenn wirklich etwas zu entfernen ist. */
(function(){
  "use strict";
  var LAEUFE = [0, 400, 1200, 2500, 5000];   /* endlich, nicht endlos */
  var WEG = ['background-clip', '-webkit-background-clip',
             '-webkit-text-fill-color', 'background-image', 'animation'];

  /* ⛔ ERSTE FASSUNG WAR FALSCH, und der Fehler ist lehrreich: sie merkte sich je
     Element „schon erledigt". Der fremde Inline-Stil wird aber ERST NACH dem
     ersten Durchlauf gesetzt — das Abzeichen war da, der Goldstil noch nicht,
     also wurde es als sauber abgehakt und nie wieder angefasst.
     Gemessen: `entgoldet 1` am Element UND trotzdem `fill rgba(0,0,0,0)`.
     ⭐ Jetzt wird bei JEDEM der endlich vielen Durchlaeufe abgeraeumt. Das
     Entfernen einer Eigenschaft, die gar nicht gesetzt ist, kostet nichts. */
  function abraeumen(){
    var alle = document.querySelectorAll('.rev-slider-card__verified');
    for (var i = 0; i < alle.length; i++){
      var s = alle[i].style;
      for (var j = 0; j < WEG.length; j++) s.removeProperty(WEG[j]);
    }
    return alle.length;
  }

  LAEUFE.forEach(function(ms){
    if (ms === 0) abraeumen(); else setTimeout(abraeumen, ms);
  });
  /* Wenn der Slider weiterblaettert, koennen Karten nachkommen — ein Klick ist
     ein endliches Ereignis, keine Schleife. */
  document.addEventListener('click', function(){ setTimeout(abraeumen, 120); }, true);
  window.s304Entgolden = abraeumen;
})();
/* ==== DER KAUFKNOPF RUTSCHTE BEIM OEFFNEN AUS DEM BILD, 20.09.2026 ====
   Enzo: „es ist wieder abgeschnitten, der CTA und das Bundle, wenn man auf
   dem Bundle drueckt."

   ⛔ GEMESSEN bei 402×812, scrollY 0:
       zu:              Kasten 606→683 · CTA 704→762   (ganz im Bild)
       nach dem Klick:  Kasten 606→683 · Liste 683→914 · CTA 933→991
   Die Auswahlliste ist 231 px hoch und schiebt den Kaufknopf 229 px nach
   unten — also 179 px unter die Schirmkante. Der Kunde oeffnet das Bundle
   und der Kaufknopf ist weg.

   ⭐ Die Seite geht jetzt mit: nach dem Aufklappen wird so weit gescrollt,
   dass der Kaufknopf wieder vollstaendig steht, mit etwas Luft darunter.
   ⛔ Nur nach UNTEN und nur wenn noetig — ein Sprung nach oben waere fuer den
   Kunden ein Ortswechsel, den er nicht ausgeloest hat. */
(function(){
  "use strict";
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;
  var LUFT = 24;

  function knopf(){
    var alle = document.querySelectorAll('button[name="add"]');
    for (var i = 0; i < alle.length; i++){
      var k = alle[i];
      if (k.closest && (k.closest('cart-bar') || k.closest('.cart-bar'))) continue;
      var r = k.getBoundingClientRect();
      if (r.width || r.height) return k;
    }
    return null;
  }

  function mitgehen(){
    var k = knopf(); if (!k) return;
    var r = k.getBoundingClientRect();
    var fehlt = Math.round(r.bottom - (innerHeight - LUFT));
    if (fehlt <= 0) return;                       /* steht schon */
    var moeglich = document.documentElement.scrollHeight - innerHeight - window.scrollY;
    var weit = Math.min(fehlt, Math.max(0, moeglich));
    if (weit <= 0) return;
    try { window.scrollBy({ top: weit, behavior: 'smooth' }); }
    catch(e){ window.scrollBy(0, weit); }
  }

  /* Die Liste baut sich nach dem Klick auf, deshalb zweimal nachfassen statt
     einmal zu raten — endlich, kein Beobachter. */
  function nachfassen(){ setTimeout(mitgehen, 260); setTimeout(mitgehen, 640); }

  document.addEventListener('click', function(e){
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;
    /* Aufklappen des Kastens, Wahl einer Zeile, und „gratis hinzufuegen" im
       Modal — alle drei veraendern die Hoehe unter dem Kasten. */
    if (ziel.closest('.s304-duo') ||
        ziel.closest('.s304-sel__o, .s304-sel__d') ||
        /gratis hinzuf/i.test(ziel.textContent || '')) nachfassen();
  }, true);

  window.s304Mitgehen = mitgehen;
})();
/* ==== BEIM SCROLLEN BLEIBT NUR DER KASTEN (Kategorieseite), 20.09.2026 ====
   Gehoert zum CSS-Block „KATEGORIEBAND, Enzos Runde vom 20.09. spaetabends".
   Setzt eine Marke am <html>, sobald der Kunde den Kopfbereich verlassen hat —
   dann faehrt die Titelzeile mit den Sternen zusammen und das 2-fuer-1-Band
   rueckt an ihre Stelle.
   ⛔ Kein Beobachter: ein Scroll-Ereignis mit requestAnimationFrame, wie beim
   Leisten-Riegel. Eine Hysterese verhindert das Flattern genau an der Grenze. */
(function(){
  "use strict";
  var klebe = null, tickt = false, eng = false;
  var AN = 90, AUS = 40;          /* Hysterese: zu bei >90, wieder auf bei <40 */

  function pruefen(){
    tickt = false;
    if (!klebe) klebe = document.querySelector('.s304-kopf-klebt');
    if (!klebe) return;
    var y = window.scrollY || 0;
    if (!eng && y > AN)  { eng = true;  document.documentElement.classList.add('s304-kopf-eng'); }
    else if (eng && y < AUS) { eng = false; document.documentElement.classList.remove('s304-kopf-eng'); }
  }
  function takt(){ if (!tickt){ tickt = true; requestAnimationFrame(pruefen); } }

  pruefen();
  addEventListener('scroll', takt, {passive:true});
  addEventListener('resize', takt, {passive:true});
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', pruefen, {once:true});
  window.s304KopfEng = pruefen;
})();
/* ==== OBEN MUSS DAS GESTACKTE BILD STEHEN, 20.09.2026 (3. Fassung) ====
   Enzo: „das Bild, was dann oben angezeigt wird, muss genau das sein, wo die
   beiden Bracelets aus dem Bundle aneinander gestacked sind, also an einem Arm."

   ⛔ FASSUNG 2 WAR FALSCH: sie zeigte bei fehlendem Paarfoto das
   Lifestyle-Foto des GEWAEHLTEN zweiten Stuecks — also EIN Armband allein.
   Genau das ist auf Enzos Screenshot 21:28 zu sehen: er waehlt OCEAN LINK,
   oben steht ein einzelnes hellblaues Kordelband, obwohl im Kasten
   „ICY STELLAR + OCEAN LINK" steht. Ein Einzelbild an der Stelle, an der das
   Bundle gezeigt werden soll, ist irrefuehrend.

   ⭐ NEUE REIHENFOLGE — es wird nur noch GESPRUNGEN, nie ueberlagert:
     1. Gibt es ein echtes Paarfoto fuer GENAU diese Kombination (`pb` aus
        `custom.paar_bilder`)? Dann dorthin. Das ist der Idealfall.
     2. Sonst auf das STAPEL-Foto des Hauptprodukts. Jeder `pb`-Wert auf dieser
        Seite zeigt auf die Galerie des HAUPTprodukts — also ist der erste
        gefundene Wert genau das Bild, auf dem das Hauptprodukt gestackt zu
        sehen ist. Es zeigt damit immer das richtige Hauptstueck am Arm,
        gestapelt.
     3. Gibt es beides nicht (alle Walletchains), passiert NICHTS. Lieber kein
        Wechsel als ein falscher.

   ⛔ EHRLICH: in Fall 2 ist das zweite Armband im Bild nicht zwingend das
   gewaehlte — es gibt heute nur EIN echtes Paarfoto je Produktseite. Die
   restlichen Kombinationen brauchen Renderings; solange die fehlen, ist „das
   Hauptstueck gestackt" die naechstbeste wahre Aussage. */
(function(){
  "use strict";
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  var daten = null;
  try { daten = JSON.parse((document.getElementById('s304-bundle-daten')||{}).textContent || 'null'); } catch(e){}
  if (!daten || !daten.haupt) return;

  /* Das Stapel-Foto des Hauptprodukts: der erste belegte pb-Wert der Seite. */
  var stapel = null;
  (daten.liste || []).some(function(p){
    if (typeof p.pb === 'number') { stapel = p.pb; return true; }
    return false;
  });

  var letzter = null;

  function springen(index){
    if (index === null || index === undefined) return false;
    var thumbs = document.querySelectorAll('a.product__thumb__link[data-media-id]');
    if (!thumbs.length || index < 0 || index >= thumbs.length) return false;
    try { thumbs[index].click(); } catch(e){ return false; }
    return true;
  }

  function entscheiden(k){
    if (!k) return;
    letzter = k;
    if (typeof k.pb === 'number') { springen(k.pb); return; }   /* echtes Paarfoto */
    if (stapel !== null) springen(stapel);                       /* Hauptstueck gestackt */
    /* sonst: bewusst nichts */
  }

  function kandidatAusText(txt){
    if (!txt) return null;
    var t = txt.trim().toUpperCase(), liste = daten.liste || [];
    for (var i = 0; i < liste.length; i++)
      if (t.indexOf(String(liste[i].n || '').toUpperCase()) === 0) return liste[i];
    for (var j = 0; j < liste.length; j++)
      if (t.indexOf(String(liste[j].n || '').toUpperCase()) !== -1) return liste[j];
    return null;
  }

  function wiederherstellen(){
    if (letzter) { entscheiden(letzter); return; }
    var erste = document.querySelector('.s304-sel__d');
    if (erste) entscheiden(kandidatAusText(erste.textContent));
  }

  document.addEventListener('click', function(e){
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;
    if (ziel.closest('a.product__thumb__link')) return;   /* eigener Bildwechsel bleibt */
    var eigen = (ziel.textContent || '').trim();
    if (ziel.closest('.s304-duo__weg') || (!ziel.firstElementChild && /^entfernen$/i.test(eigen))) {
      letzter = null; return;
    }
    var zeile = ziel.closest('.s304-sel__o, .s304-sel__d, [data-s304-add]');
    if (zeile) { setTimeout(function(){
      /* \u26d4 Wie beim Klick auf `.s304-duo`: der Galerie-Sprung schliesst das
         Auswahl-Blatt. Solange es offen ist, bleibt die Galerie stehen. */
      if (document.documentElement.classList.contains('s304-blatt-auf')) return;
      entscheiden(kandidatAusText(zeile.textContent));
    }, 140); return; }
    if (ziel.closest('.s304-duo')) setTimeout(function(){
      /* \u26d4 21.09.: dieser Sprung schloss das Auswahl-Blatt wieder.
         Belegt ueber den Aufrufstapel: wiederherstellen \u2192 entscheiden \u2192
         springen \u2192 (Theme-Knopf) \u2192 zu(). Solange das Blatt offen ist,
         bleibt die Galerie, wo sie ist. Die Pruefung MUSS hier drin stehen:
         beim Klick ist das Blatt noch nicht offen. */
      if (document.documentElement.classList.contains('s304-blatt-auf')) return;
      wiederherstellen();
    }, 280);
  }, true);

  /* Die alte Ueberlagerung wird nicht mehr benutzt — falls eine im DOM haengt,
     abraeumen, damit sie kein altes Bild ueber der Galerie stehen laesst. */
  (function(){ var s = document.querySelector('.s304-paarbild'); if (s) s.classList.remove('da'); })();

  window.s304Paarbild = { entscheiden: entscheiden, wiederherstellen: wiederherstellen, stapel: function(){ return stapel; } };
})();
/* ==== WARENKORB: BLOCK AN DIE RICHTIGE STELLE + GESAMTPREIS IM KNOPF ====
   20.09.2026 spaetabends. Zwei Punkte aus Enzos Ansage.

   1 · DIE LUECKE.
   ⛔ GEMESSEN: zwischen dem Warenkorbposten und meinem Bundle-Block lagen
   **167 px** Leerraum. Ursache ist nicht mein Block, sondern `.drawer__body`
   mit `flex-grow: 1` — der Bereich dehnt sich, damit die Kasse unten klebt,
   und schiebt alles, was danach kommt, nach unten. Mein Block stand als
   GESCHWISTER dahinter.
   ⭐ Er wandert in den Koerper hinein, direkt hinter die Posten. Dann traegt
   ihn die Dehnung nicht mehr.

   2 · DER GESAMTPREIS IM KASSEN-KNOPF.
   Enzo: „ich wollte ja jetzt, wenn wir nicht gratis versandt haben, jetzt
   ,sicher zur Kasse‘, so einen Punkt, und dann den Gesamtpreis … damit die
   Leute wissen, wie viel das dann kostet."
   ⭐ Der Betrag wird aus dem gerechnet, was im Korb WIRKLICH steht
   (`/cart.js`) plus der Versandzeile, die die Seite selbst anzeigt — nicht aus
   einer zweiten, eigenen Rechnung. Zwei Quellen fuer dieselbe Zahl waren hier
   heute schon einmal der Fehler.
   ⛔ Kein Beobachter. */
(function(){
  "use strict";

  function eur(c){
    /* 21.09.2026 — war fest 'de-DE' und hat den Preis am Kassenknopf auf /en/
       deutsch geschrieben, waehrend der Fuss daneben englisch formatierte. */
    return (c/100).toLocaleString(window.s304EN ? 'en-GB' : 'de-DE',
             {minimumFractionDigits:2, maximumFractionDigits:2}) + ' €';
  }

  /* ⛔⛔ ERSTE FASSUNG LEGTE DEN BLOCK INS MENUE.
     `document.querySelector('.drawer__body')` trifft das ERSTE Schubfach im
     Dokument — und das ist das Menue, nicht der Warenkorb. Gemessen nach dem
     Ausspielen: `.s304-korb` lag unter `mobile-menu` und war
     `visibility: hidden`, also fuer den Kunden restlos verschwunden.
     ⭐ Alles wird ab jetzt am Warenkorb-Schubfach verankert (`.drawer--cart`),
     nie an einer Klasse, die mehrfach vorkommt. */
  function korbSchub(){
    return document.querySelector('.drawer--cart') ||
           document.querySelector('[class*="drawer--cart"]');
  }

  /* --- 1 · Block holen und einruecken ---
     ⛔⛔ DER BLOCK WAR NACH EINEM AJAX-KAUF NICHT VERSCHOBEN, SONDERN WEG.
     Gemessen: nach vollem Seitenaufbau mit 1 Walletchain im Korb ist
     `.s304-korb` da (195 px, 4 Karten). Nach einem Klick auf „In den Warenkorb
     legen" ist er im GANZEN Dokument 0-mal vorhanden. Das Theme ersetzt den
     Schubfach-Koerper durch frisches Server-HTML, und darin steckt das Snippet
     nicht. Verschieben half deshalb nichts — es gab nichts zu verschieben.
     ⭐ Loesung: den Block ueber die Section-Rendering-API NACHLADEN. Gemessen:
     `/?sections=<id>` liefert 47 kB in 168 ms und enthaelt `s304-korb`.
     Die Sektions-Kennung wird aus dem lebenden DOM gelesen, nie verdrahtet.
     ⛔ Der Server rendert den Block mit dem AKTUELLEN Korbzustand — deshalb
     wird nachgeladen statt eine alte Kopie aufzubewahren. Eine Kopie waere
     nach der naechsten Mengenaenderung falsch. */
  function sektionsKennung(){
    var schub = korbSchub(); if (!schub) return null;
    var sec = schub.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }

  var holtGerade = false;
  /* ⛔ 21.09.2026 — DIESE FUNKTION HAT NUR EINEN BLOCK GEKANNT.
     `querySelector('.s304-korb')` ist Einzahl. Liegt aber eine Walletchain UND
     ein Bracelet im Korb, rendert `304-bundle-korb.liquid` ZWEI Blöcke. Der
     erste wurde in `.drawer__content` eingerückt, der zweite blieb dort
     stehen, wo Liquid ihn abgelegt hatte — gemessen im offenen Schubfach bei
     402 px: Bracelet 321–515, Walletchain 434–628, also 81 px Überlappung.
     Auf dem Bild sah es aus, als sei die Bracelet-Reihe „abgeschnitten"; in
     Wahrheit lag der zweite Block darüber.
     ⭐ Ab hier Mehrzahl: alle Blöcke werden eingerückt, alle alten entfernt. */
  function einruecken(){
    var schub = korbSchub(); if (!schub) return false;
    var koerper = schub.querySelector('.drawer__body');
    if (!koerper) return false;
    var ziel = koerper.querySelector('.drawer__content') || koerper;

    var bloecke = schub.querySelectorAll('[data-s304-korb]');
    if (bloecke.length) {                 /* schon da — nur an die richtige Stelle */
      var bewegt = false;
      Array.prototype.forEach.call(bloecke, function(b){
        if (b.parentElement !== ziel){ ziel.appendChild(b); bewegt = true; }
      });
      return bewegt;
    }

    if (holtGerade) return false;
    var kennung = sektionsKennung(); if (!kennung) return false;
    holtGerade = true;
    fetch('/?sections=' + encodeURIComponent(kennung), {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(d){
        var html = d[kennung]; if (!html) return;
        var h = document.createElement('div');
        h.innerHTML = html;
        var frisch = h.querySelectorAll('[data-s304-korb]');
        if (!frisch.length) return;          /* Server sagt: hier gehoert keiner hin */
        var s2 = korbSchub(); if (!s2) return;
        Array.prototype.forEach.call(s2.querySelectorAll('[data-s304-korb]'), function(x){ x.remove(); });
        var k2 = s2.querySelector('.drawer__body'); if (!k2) return;
        var ziel2 = k2.querySelector('.drawer__content') || k2;
        Array.prototype.forEach.call(frisch, function(f){ ziel2.appendChild(f); });
      })
      .catch(function(){})
      .then(function(){ holtGerade = false; });
    return true;
  }

  /* --- 2 · Gesamtpreis --- */
  function versandCent(){
    /* Die Versandzeile, die die Seite selbst zeigt — kein zweiter Rechenweg. */
    var schub = korbSchub(); if (!schub) return null;
    var knoten = schub.querySelectorAll('*');
    for (var i = 0; i < knoten.length; i++){
      var e = knoten[i];
      if (e.children.length) continue;
      var t = (e.textContent || '').trim();
      if (!/^\s*\d{1,3}(?:[.,]\d{2})?\s*€\s*$/.test(t)) continue;
      var zeile = e.closest('div, li, tr');
      var txt = zeile ? (zeile.textContent || '') : '';
      if (!/versand|shipping/i.test(txt)) continue;
      if (/gratis|kostenlos|free/i.test(txt)) return 0;
      /* ⛔ 21.09.2026 — war reine Deutsch-Logik und hat auf /en/ aus „4.99 €"
         die Zahl 499 gemacht: der Kassenknopf zeigte „554,00 €" bei einem
         55-€-Korb. Jetzt entscheidet die LETZTE Trennstelle: stehen dahinter
         genau zwei Ziffern bis zum Ende, ist sie das Dezimalzeichen.
         Haelt „4,99", „4.99", „1.234,56" und „1,234.56".
         Siehe umbau-2fuer1/betrag_und_knopf.py */
      var roh = t.replace(/[^\d,.]/g, '');
      var letzte = Math.max(roh.lastIndexOf(','), roh.lastIndexOf('.'));
      var zahl = (letzte > -1 && roh.length - letzte === 3)
        ? roh.slice(0, letzte).replace(/[.,]/g, '') + '.' + roh.slice(letzte + 1)
        : roh.replace(/[.,]/g, '');
      var c = Math.round(parseFloat(zahl) * 100);
      return isFinite(c) ? c : null;
    }
    return null;
  }

  /* ⛔⛔ ERSTE FASSUNG HOLTE DEN BETRAG PER `fetch('/cart.js')` UND KAM NIE AN.
     Gemessen ueber 8 Sekunden: `data-s304-alt` wurde NIE gesetzt, die Funktion
     brach also vor der ersten Zuweisung ab — obwohl derselbe Code von Hand
     ausgefuehrt sofort „Jetzt sicher zur Kasse · 54,99 €" erzeugte. Statt den
     Grund weiter zu suchen, faellt der Netzabruf ganz weg:
     ⭐ Zwischensumme und Versand stehen SICHTBAR im Schubfach. Das sind genau
     die Zahlen, die der Kunde liest — eine zweite Quelle fuer dieselbe Summe
     war hier heute schon einmal der Fehler. */
  function betragAusZeile(muster){
    var schub = korbSchub(); if (!schub) return null;
    var alle = schub.querySelectorAll('*');
    for (var i = 0; i < alle.length; i++){
      var e = alle[i];
      if (e.children.length) continue;
      var t = (e.textContent || '').trim();
      if (!/^\s*\d{1,4}(?:[.,]\d{2})?\s*\u20ac\s*$/.test(t)) continue;
      var zeile = e.closest('div, li, tr');
      var txt = zeile ? (zeile.textContent || '') : '';
      if (!muster.test(txt)) continue;
      if (/gratis|kostenlos|free/i.test(txt)) return 0;
      /* ⛔ 21.09.2026 — war reine Deutsch-Logik und hat auf /en/ aus „4.99 €"
         die Zahl 499 gemacht: der Kassenknopf zeigte „554,00 €" bei einem
         55-€-Korb. Jetzt entscheidet die LETZTE Trennstelle: stehen dahinter
         genau zwei Ziffern bis zum Ende, ist sie das Dezimalzeichen.
         Haelt „4,99", „4.99", „1.234,56" und „1,234.56".
         Siehe umbau-2fuer1/betrag_und_knopf.py */
      var roh = t.replace(/[^\d,.]/g, '');
      var letzte = Math.max(roh.lastIndexOf(','), roh.lastIndexOf('.'));
      var zahl = (letzte > -1 && roh.length - letzte === 3)
        ? roh.slice(0, letzte).replace(/[.,]/g, '') + '.' + roh.slice(letzte + 1)
        : roh.replace(/[.,]/g, '');
      var c = Math.round(parseFloat(zahl) * 100);
      return isFinite(c) ? c : null;
    }
    return null;
  }

  /* Grenze und Satz stehen im Datenblock, den der Warenkorb-Fuss ausspielt.
     Unter der Grenze kostet der Versand `satz`, ab der Grenze ist er frei. */
  function versandAusDaten(zwischen){
    if (zwischen === null) return null;
    var el = document.getElementById('s304-versand-daten');
    if (!el) return null;
    try {
      var d = JSON.parse(el.textContent || '{}');
      var grenze = Number(d.grenze), satz = Number(d.satz);
      if (!isFinite(grenze) || !isFinite(satz)) return null;
      return zwischen >= grenze ? 0 : satz;
    } catch(e){ return null; }
  }

  /* Gibt true zurueck, wenn wirklich geschrieben wurde — die Serie unten
     hoert erst dann auf zu fragen. */
  function preisSetzen(){
    var schub = korbSchub(); if (!schub) return false;
    var knopf = null, alle = schub.querySelectorAll('button, a');
    for (var i = 0; i < alle.length; i++)
      if (/zur kasse|checkout/i.test(alle[i].textContent || '')) { knopf = alle[i]; break; }
    if (!knopf) return false;
    var ziel = knopf.querySelector('.btn__text') || knopf;
    if (!ziel.hasAttribute('data-s304-alt')) {
      /* 21.09.2026 — auf /en/ rendert das Theme hier trotzdem „JETZT SICHER ZUR
         KASSE" (Luecke in Shopifys Uebersetzung). Wir lesen den Knopftext und
         ersetzen ihn NUR, wenn er wirklich deutsch aussieht — wird die
         Uebersetzung nachgetragen, gewinnt sie wieder von selbst. */
      var roh = (ziel.textContent || '').trim();
      if (window.s304EN && /kasse|warenkorb|jetzt|sicher/i.test(roh)) roh = 'SECURE CHECKOUT';
      ziel.setAttribute('data-s304-alt', roh);
    }
    var grund = ziel.getAttribute('data-s304-alt') || 'Jetzt sicher zur Kasse';
    grund = grund.replace(/\s*\u00b7.*$/, '').trim();

    var zwischen = betragAusZeile(/zwischensumme|subtotal/i);
    var versand  = betragAusZeile(/versand|shipping/i);
    /* ⛔ NACH EINEM AJAX-KAUF GIBT ES DIE VERSANDZEILE NICHT.
       Gemessen ueber 8 Sekunden nach einem Klick auf „In den Warenkorb legen":
       die Zeile erscheint NIE — sie wird nur beim vollen Seitenaufbau gerendert.
       Der Riegel hat dann korrekt keine Zahl erfunden, aber genau in dem
       Moment, in dem der Kunde den Knopf sieht, fehlte der Preis.
       ⭐ Ersatz ist KEINE zweite Quelle: `#s304-versand-daten` ist die Quelle,
       aus der die Zeile selbst gebaut wird — nur eine Stufe weiter oben. */
    if (versand === null) versand = versandAusDaten(zwischen);
    /* ⛔ Faellt eine der beiden Zahlen aus, wird KEINE Summe erfunden — dann
       bleibt der Knopf, wie er war. Eine falsche Gesamtsumme im Kaufknopf
       waere schlimmer als gar keine. */
    /* ⭐ 21.09.2026 — der Betrag wird nicht mehr in den Knopf GESCHRIEBEN,
       sondern als CSS-Variable gesetzt und per `::after` dargestellt. Siehe
       umbau-2fuer1/kein_flackern.py. Damit kann das Theme ihn beim Neuaufbau
       nicht mehr entfernen, und die Wache erzeugt kein Flackern. */
    var betrag = (zwischen === null || versand === null)
               ? ''
               : ' \u00b7 ' + eur(zwischen + versand);
    ziel.classList.add('s304-kassenpreis');
    document.documentElement.style.setProperty(
      '--s304-kassenpreis', betrag ? JSON.stringify(betrag) : '""');
    return !!betrag;
  }

  /* ⛔ `ziel.textContent = …` LOESCHT ALLE KINDER. Beim Kassenknopf war das
     das Schloss-Symbol — nach der ersten Fassung war es weg. Gemessen an der
     Schwebeleiste ist derselbe Fehler heute schon einmal passiert („der
     Kaufknopf hat drei Kinder, wer ihn selbst beschreibt, wirft den
     Lade-Indikator weg").
     ⭐ Deshalb wird nur der TEXTKNOTEN ersetzt. Gibt es keinen, wird einer
     angehaengt — die Symbole bleiben in jedem Fall stehen. */
  function schreibeText(el, text){
    for (var i = 0; i < el.childNodes.length; i++){
      var k = el.childNodes[i];
      if (k.nodeType === 3 && (k.nodeValue || '').trim()){ k.nodeValue = text; return; }
    }
    el.appendChild(document.createTextNode(text));
  }

  /* ⛔⛔ EIN FEHLER IN EINEM TEIL HAT ALLE DANACH MITGERISSEN.
     Gemessen: nach dem AJAX-Kauf stand am Kassenknopf `data-s304-alt` NICHT
     GESETZT — `preisSetzen()` war also nie bis zur ersten Zuweisung gekommen,
     obwohl derselbe Schreibvorgang von Hand sofort funktionierte. Ursache ist
     nicht die Preislogik, sondern die Reihenfolge: `alles()` rief die drei
     Teile nackt hintereinander auf. Wirft der erste, laufen der zweite und
     dritte nie — und zwar lautlos, weil niemand den Fehler faengt.
     ⭐ Jede Aufgabe bekommt ihre eigene Kapsel. Ein kaputter Teil darf die
     anderen nicht mit in den Abgrund ziehen. Und der Fehler wird gemerkt,
     damit er beim Nachsehen auffindbar ist statt spurlos zu verschwinden. */
  window.s304KorbFehler = window.s304KorbFehler || [];
  function sicher(name, fn){
    try { fn(); }
    catch(e){
      window.s304KorbFehler.push(name + ': ' + (e && e.message ? e.message : String(e)));
      if (window.s304KorbFehler.length > 20) window.s304KorbFehler.shift();
    }
  }

  function alles(){
    sicher('einruecken', einruecken);
    sicher('preisSetzen', preisSetzen);
    /* ⭐ Enzo: „da soll auch Versandkosten stehen als Punkt und auch
       Versanddatum." Die Zeilen baut der Warenkorb-Fuss-Block — der lief nur
       bei 600/1800/4000 ms nach dem Seitenaufbau und war nach einem AJAX-Kauf
       laengst durch. Hier wird SEINE Funktion mitgerufen, keine zweite
       Rechnung. */
    sicher('fuss', function(){
      if (typeof window.s304Fuss === 'function') window.s304Fuss();
    });
  }

  /* Das Schubfach wird erst beim Oeffnen gefuellt — deshalb mehrere
     Zeitpunkte UND die Ereignisse des Themes. Endlich, kein Beobachter. */
  [0, 400, 1000, 2000, 3500, 5500].forEach(function(ms){ ms ? setTimeout(alles, ms) : alles(); });
  /* ⛔ EINE EINZELNE NACHFASSUNG REICHTE NICHT.
     Gemessen: nach einem Klick auf „In den Warenkorb legen" baut das Theme das
     Schubfach per AJAX neu auf — und zwar LANGSAMER als die 420 ms. Der Knopf
     blieb deshalb ohne Preis, obwohl derselbe Aufruf von Hand sofort
     „· 54,99 €" erzeugte. Die festen Zeitpunkte ab Seitenstart helfen nicht,
     weil der Kauf spaeter passiert als 5,5 s nach dem Laden.
     ⭐ Nach JEDEM Klick eine kurze, ENDLICHE Serie — kein Beobachter, keine
     Schleife. Das Schreiben ist zustandslos, ein Durchlauf zu viel kostet
     nichts. */
  /* ⛔⛔ FESTE ZEITPUNKTE HABEN DAS THEME NICHT EINGEHOLT.
     Gemessen nach einem Kauf auf der Walletchain-PDP: `data-s304-alt` war nach
     allen fuenf Versuchen NICHT gesetzt, und es wurde kein Fehler gefangen —
     `preisSetzen()` lief also sauber durch und fand den Kassenknopf nur
     schlicht noch nicht. Bei 7 s war er da. Die Serie endete bei 5 s.
     ⭐ Statt die Zeitpunkte weiter zu raten: fragen, BIS es sitzt — hoechstens
     20-mal alle 400 ms, also maximal 8 s. Danach hoert es auf; eine Schleife
     ohne Ende waere schlimmer als ein fehlender Preis. */
  var serieLaeuft = null;
  function serie(){
    if (serieLaeuft) clearInterval(serieLaeuft);
    var versuche = 0;
    alles();
    serieLaeuft = setInterval(function(){
      versuche++;
      /* ⛔⛔ BEIM ERSTEN ERFOLG AUFZUHOEREN WAR DER FEHLER.
         Aufgezeichnet alle 300 ms nach einem Kauf:
             331 ms  „JETZT SICHER ZUR KASSE · 95,00 €"   ← gesetzt
            1232 ms  „JETZT SICHER ZUR KASSE"             ← weg
         Das Theme baut das Schubfach NACH dem ersten Erfolg noch einmal neu
         und ersetzt den Knopf samt Text und Merkattribut. Die Serie hatte da
         schon abgeschaltet, weil sie einmal erfolgreich war.
         ⭐ Jetzt laeuft sie ihre volle, begrenzte Runde durch (20 × 400 ms =
         8 s) und schreibt bei jedem Durchgang neu. Das Schreiben ist
         zustandslos — ein Durchgang zu viel kostet nichts, ein Durchgang zu
         wenig kostet den Preis. */
      sicher('preisSetzen', preisSetzen);
      sicher('einruecken', einruecken);
      sicher('fuss', function(){ if (typeof window.s304Fuss === 'function') window.s304Fuss(); });
      if (versuche >= 20) { clearInterval(serieLaeuft); serieLaeuft = null; wacheAn(); }
    }, 400);
  }

  /* ⛔⛔ AUCH 8 SEKUNDEN WAREN ZU KURZ.
     Gemessen nach einem Kauf, an vier Zeitpunkten abgelesen:
        3 s  „… · 95,00 €"      ← da
        6 s  „… · 95,00 €"      ← da
       10 s  „JETZT SICHER ZUR KASSE"   ← weg
       15 s  „JETZT SICHER ZUR KASSE"   ← weg
     Zwischen 6 und 10 Sekunden baut das Theme das Schubfach ein WEITERES Mal
     neu — genau dann, wenn die schnelle Serie ausgelaufen ist. Die Zeitpunkte
     weiter hochzuschrauben waere Raten; die naechste Wartezeit koennte wieder
     danebenliegen.
     ⭐ Deshalb eine WACHE statt eines Timers: sie tickt ruhig alle 1,5 s und
     nur, SOLANGE das Schubfach offen ist. Ist es zu, schaltet sie sich selbst
     ab. Die Laufzeit haengt damit am Verhalten des Kunden, nicht an einer
     geratenen Zahl — und eine geschlossene Schublade kostet null.
     ⛔ Bewusst kein MutationObserver: ein Beobachter auf dem Schubfach, der im
     Rueckruf schreibt, hat in diesem Haus schon einmal den ganzen Shop
     eingefroren. */
  var wacheLaeuft = null;
  function schubOffen(){
    var s = korbSchub();
    if (!s) return false;
    if (/is-open|is-active/.test(s.className)) return true;
    var r = s.getBoundingClientRect();
    return r.width > 40 && r.height > 40 && getComputedStyle(s).visibility !== 'hidden';
  }
  function wacheAn(){
    if (wacheLaeuft) return;
    wacheLaeuft = setInterval(function(){
      if (!schubOffen()) { clearInterval(wacheLaeuft); wacheLaeuft = null; return; }
      sicher('preisSetzen', preisSetzen);
      sicher('einruecken', einruecken);
    }, 700);
  }
  /* ⛔ 1500 ms waren messbar zu traege: bei 10 s fiel eine Probe in die Luecke
     zwischen dem Neuaufbau des Themes und dem naechsten Tick — der Preis fehlte
     kurz. Mit 700 ms ist die schlimmste Luecke unter einer Sekunde. Der Tick
     liest drei Knoten und schreibt einen Text; das kostet nichts. */
  document.addEventListener('click', serie, true);
  ['theme:cart:refresh','theme:cart:change','theme:cart:added','theme:cart:open','cart:updated']
    .forEach(function(n){ document.addEventListener(n, serie); });
  ['theme:cart-drawer:open','theme:cart:change','theme:product:added']
    .forEach(function(n){ document.addEventListener(n, function(){ setTimeout(wacheAn, 600); }); });
  window.s304Korb = alles;
})();

/* ==== IM POPUP WEITERWISCHEN, 20.09.2026 ====
   Enzo: „bei dem Produkt-Popup, wenn man ein anderes Produkt auswählt, da soll
   man auch die Produkte weiterswipen können. Also in dem Popup."

   ⭐ Bewusst OHNE Eingriff in den Popup-Bauer: der liegt in einer fremden
   Kapsel, und ihn aufzubrechen waere die groessere Aenderung. Stattdessen
   benutzt das Wischen den Weg, den es ohnehin gibt — es klickt die Zeile des
   naechsten Kandidaten in der Auswahlliste an, und die oeffnet das Popup neu.
   Dadurch laeuft ALLES weiter durch dieselbe Logik: Preisdeckel, Paarbild,
   Messpunkte. Kein zweiter Weg, der auseinanderlaufen kann.

   ⛔ Kein MutationObserver. Die Griffe haengen delegiert am `document`, das
   Popup darf also beliebig neu gebaut werden. */
(function(){
  "use strict";
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  function karte(){ return document.querySelector('.s304-mod.da .s304-mod__k, .s304-mod__k'); }
  /* ⛔ ERSTE FASSUNG FRAGTE DIE FALSCHE KLASSE AB.
     Ich hatte `.s304-mod.da` angenommen — der Offen-Zustand steht aber am
     <html> (`s304-mod-offen`). Gemessen: `.s304-mod` trug nur `s304-mod`,
     `classList.contains('da')` war false, also brach `blaettern()` in der
     ERSTEN Zeile ab und das Wischen tat nie etwas. Dreimal gewischt, dreimal
     blieb derselbe Name stehen — ohne Fehler in der Konsole, weil ein
     stilles `return false` keinen Fehler wirft.
     ⭐ Jetzt beides: die Marke am <html> ODER ein wirklich sichtbares Modal. */
  function offen(){
    if (document.documentElement.classList.contains('s304-mod-offen')) return true;
    var m = document.querySelector('.s304-mod');
    if (!m) return false;
    var cs = getComputedStyle(m);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    return !!document.querySelector('.s304-mod__n');
  }

  function zeilen(){
    return [].slice.call(document.querySelectorAll('.s304-sel__d, .s304-sel__o'));
  }
  function name(el){ return (el.textContent || '').trim().toUpperCase(); }

  /* Welcher Kandidat steht gerade im Popup? Ueber den Namen im Popup-Kopf. */
  function jetzt(){
    var n = document.querySelector('.s304-mod__n');
    return n ? (n.textContent || '').trim().toUpperCase() : null;
  }

  /* ⛔ DIE DOM-REIHENFOLGE TAUGT NICHT ALS GRUNDLAGE.
     Erste lauffaehige Fassung blaetterte ueber die Zeilen der Auswahlliste —
     und sprang zwischen zwei Produkten hin und her: gemessen
     „→ MIDNIGHT → SNOW → MIDNIGHT". Ursache: das gewaehlte Stueck rutscht als
     `.s304-sel__d` an die ERSTE Stelle, die Liste sortiert sich also bei jedem
     Schritt neu. „Der naechste nach Position 1" ist damit jedes Mal ein
     anderer.
     ⭐ Grundlage ist jetzt die feste Reihenfolge aus `#s304-bundle-daten` —
     die aendert sich nie. Gesucht wird die Zeile danach nur noch ueber den
     Namen. */
  var reihenfolge = (function(){
    try {
      var d = JSON.parse((document.getElementById('s304-bundle-daten')||{}).textContent || 'null');
      return ((d && d.liste) || []).map(function(p){ return String(p.n || '').toUpperCase(); });
    } catch(e){ return []; }
  })();

  function blaettern(richtung){
    if (!offen()) return false;
    var akt = jetzt();
    if (!akt) return false;
    /* Nur die Stuecke, die heute wirklich in der Liste stehen (Preisdeckel). */
    var sichtbar = zeilen().map(name);
    var folge = reihenfolge.filter(function(n){
      for (var q = 0; q < sichtbar.length; q++) if (sichtbar[q].indexOf(n) === 0) return true;
      return false;
    });
    if (folge.length < 2) return false;
    var i = folge.indexOf(akt);
    if (i < 0) return false;
    var j = i + richtung;
    if (j < 0) j = folge.length - 1;
    if (j >= folge.length) j = 0;
    var alle = zeilen();
    /* ⛔ ERSTE FASSUNG MERKTE SICH DAS ELEMENT — und das war falsch.
       Beim Schliessen des Popups baut die Auswahlliste sich neu auf; das
       gemerkte Element ist danach abgeloest, sein Klick geht ins Leere.
       Gemessen: dreimal gewischt, dreimal blieb „FOREST LINK" stehen.
       ⭐ Deshalb wird der NAME gemerkt und die Zeile nach dem Schliessen neu
       gesucht. Dieselbe Falle hatte vorher schon meinen eigenen Testlauf
       genarrt — ein abgeloester Knoten sieht im Code genauso aus wie ein
       lebender. */
    var zielName = folge[j];
    var x = document.querySelector('.s304-mod__x');
    if (x) x.click();
    setTimeout(function(){
      var frisch = zeilen();
      for (var q = 0; q < frisch.length; q++){
        if (name(frisch[q]).indexOf(zielName) === 0) { frisch[q].click(); return; }
      }
      /* Liste zugeklappt? Erst aufklappen, dann noch einmal suchen. */
      var kasten = document.querySelector('.s304-duo');
      if (!kasten) return;
      kasten.click();
      setTimeout(function(){
        var f2 = zeilen();
        for (var q2 = 0; q2 < f2.length; q2++)
          if (name(f2[q2]).indexOf(zielName) === 0) { f2[q2].click(); return; }
      }, 260);
    }, 140);
    return true;
  }

  /* ---- Wischen ---- */
  var x0 = null, y0 = null, t0 = 0;
  document.addEventListener('touchstart', function(e){
    /* ⛔⛔ 21.09.2026 — WISCHEN WECHSELT KEIN PRODUKT MEHR.
       Enzo: „Wenn ich die Produktbilder swipen will, swipe ich aus Versehen
       manchmal schon zur nächsten Walletchain. Das soll gar nicht möglich
       sein." Rueckweg: diese eine `return;`-Zeile loeschen. */
    return;
    if (!offen() || !e.touches || e.touches.length !== 1) { x0 = null; return; }
    var k = karte(); if (!k || !k.contains(e.target)) { x0 = null; return; }
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now();
  }, {passive:true});

  document.addEventListener('touchend', function(e){
    if (x0 === null) return;
    var t = (e.changedTouches && e.changedTouches[0]) || null;
    if (!t) { x0 = null; return; }
    var dx = t.clientX - x0, dy = t.clientY - y0, dt = Date.now() - t0;
    x0 = null;
    /* Waagerecht, deutlich, und nicht aus Versehen beim Scrollen. */
    if (dt > 700) return;
    if (Math.abs(dx) < 45) return;
    if (Math.abs(dy) > Math.abs(dx) * 0.8) return;
    blaettern(dx < 0 ? 1 : -1);
  }, {passive:true});

  /* Maus/Trackpad und Tastatur, damit es nicht nur auf dem Telefon geht. */
  var mx = null, my = null;
  document.addEventListener('pointerdown', function(e){
    /* ⛔⛔ 21.09.2026 — WISCHEN WECHSELT KEIN PRODUKT MEHR.
       Enzo: „Wenn ich die Produktbilder swipen will, swipe ich aus Versehen
       manchmal schon zur nächsten Walletchain. Das soll gar nicht möglich
       sein." Rueckweg: diese eine `return;`-Zeile loeschen. */
    return;
    if (e.pointerType === 'touch') return;
    if (!offen()) { mx = null; return; }
    var k = karte(); if (!k || !k.contains(e.target)) { mx = null; return; }
    mx = e.clientX; my = e.clientY;
  });
  document.addEventListener('pointerup', function(e){
    if (mx === null || e.pointerType === 'touch') return;
    var dx = e.clientX - mx, dy = e.clientY - my; mx = null;
    if (Math.abs(dx) < 60 || Math.abs(dy) > Math.abs(dx) * 0.8) return;
    blaettern(dx < 0 ? 1 : -1);
  });
  document.addEventListener('keydown', function(e){
    if (!offen()) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); blaettern(1); }
    if (e.key === 'ArrowLeft')  { e.preventDefault(); blaettern(-1); }
  });

  /* ==== DIE WISCH-LEISTE ====
     Enzo: „mach unten so eine Swipeleiste rein, dass man so sieht, okay man
     kann weiter swipen, zusaetzlich zu diesen Pfeilen."
     ⛔ Ein Wisch, den niemand sieht, wird nicht benutzt — und schlimmer: wenn
     er unangekuendigt zum naechsten Produkt springt, wirkt er wie ein Fehler.
     Die Leiste macht sichtbar, wo man steht und dass es weitergeht.
     ⭐ Sie wird bei JEDEM Oeffnen neu gezeichnet, weil das Popup neu gebaut
     wird — kein Beobachter, nur ein Nachfassen nach dem Klick. */
  function leisteZeichnen(){
    if (!offen()) return;
    var karte = karte_(); if (!karte) return;
    /* ⭐ 21.09.2026 — die Leiste zaehlt BILDER, nicht Produkte.
       Gemessen: 5 Punkte fuer 4 Bilder, weil `reihenfolge` die Produktliste
       ist. Enzo will, dass das Wischen die Bilder des aktuellen Produkts
       bewegt — also gehoert die Leiste zur Galerie. */
    var gal = karte.querySelector('.s304-mod__gal');
    if (gal) {
      var bilder = gal.querySelectorAll('img');
      if (bilder.length > 1) {
        /* ⭐ 21.09.2026 — die Leiste sitzt UEBER dem Titel, nicht unten.
           Enzo: „über den Titel … so eine Leiste, dass ich weiß, okay ich
           kann da swipen." Punkte unten sieht man erst, wenn man schon
           gescrollt hat. */
        var leiste = karte.querySelector('.s304-mod__leiste');
        var name = karte.querySelector('.s304-mod__n');
        if (!leiste) {
          leiste = document.createElement('div');
          leiste.className = 's304-mod__leiste';
        }
        if (name && leiste.parentElement !== name.parentElement) {
          name.parentElement.insertBefore(leiste, name);
        } else if (!leiste.parentElement) {
          karte.appendChild(leiste);
        }
        var breite = gal.clientWidth || 1;
        var aktiv = Math.round(gal.scrollLeft / breite);
        var html = '';
        for (var bi = 0; bi < bilder.length; bi++)
          html += '<span class="s304-mod__seg' + (bi === aktiv ? ' da' : '') + '"></span>';
        leiste.innerHTML = '<div class="s304-mod__segs">' + html + '</div>';
        if (!gal.getAttribute('data-s304-wisch')) {
          gal.setAttribute('data-s304-wisch', '1');
          gal.addEventListener('scroll', function(){
            clearTimeout(gal._s304t);
            gal._s304t = setTimeout(leisteZeichnen, 90);
          }, {passive:true});
        }
      }
      return;
    }
    var akt = jetzt(); if (!akt) return;
    var sichtbar = zeilen().map(name);
    var folge = reihenfolge.filter(function(n){
      for (var q = 0; q < sichtbar.length; q++) if (sichtbar[q].indexOf(n) === 0) return true;
      return false;
    });
    if (folge.length < 2) return;
    var i = folge.indexOf(akt);
    var alt = karte.querySelector('.s304-mod__leiste');
    if (alt) alt.remove();
    var leiste = document.createElement('div');
    leiste.className = 's304-mod__leiste';
    var html = '';
    for (var k = 0; k < folge.length; k++)
      html += '<span class="s304-mod__pkt' + (k === i ? ' da' : '') + '"></span>';
    leiste.innerHTML = '<div class="s304-mod__pkte">' + html + '</div>'
    leiste.innerHTML = '<div class="s304-mod__pkte">' + html + '</div>';
    karte.appendChild(leiste);
  }
  function karte_(){ return document.querySelector('.s304-mod__k'); }

  /* Nach jedem Klick, der das Popup oeffnen oder wechseln kann, neu zeichnen. */
  document.addEventListener('click', function(){
    setTimeout(leisteZeichnen, 260);
    setTimeout(leisteZeichnen, 900);
  }, true);

  window.s304Wischen = blaettern;
  window.s304WischLeiste = leisteZeichnen;
})();


/* ==== DIE SCHWEBELEISTE ZIEHT DEN PREIS NACH, 21.09.2026 ====
   Gemessen: `#cart-bar-custom-atc` hatte kein `data-s304-alt`, die
   Schreibfunktion war also nie gelaufen — sie haengt nur an Bundle-Aktionen.
   ⛔ Bewusst KEIN MutationObserver (einer hat am 20.09. den ganzen Shop
      eingefroren) und kein Dauertakt: ein kurzer Anlauf, der sich selbst
      beendet, sobald der Knopf beschriftet ist. */
(function(){
  var versuche = 0;
  function nachziehen(){
    versuche++;
    var b = document.querySelector('#cart-bar-custom-atc, cart-bar .cart-bar__atc-btn');
    if (b && !b.hasAttribute('data-s304-alt') && typeof window.s304Kaufknopf === 'function') {
      window.s304Kaufknopf();
    }
    if (versuche >= 12 || (b && b.hasAttribute('data-s304-alt'))) {
      clearInterval(iv);
    }
  }
  var iv = setInterval(nachziehen, 500);
  nachziehen();
  addEventListener('scroll', function einmal(){
    nachziehen();
    if (versuche > 14) removeEventListener('scroll', einmal);
  }, {passive:true});
})();

/* ==== ZWEI ANIMATIONEN AUF DER KATEGORIESEITE — RUHIGE FASSUNG, 21.09.2026 ====

   Enzo nach dem Sehen der ersten Fassung: „jetzt springt mir das alles gefuehlt
   in die Fresse." Vier Korrekturen, alle von ihm benannt:
     1. BEIM ERSTEN LADEN PASSIERT NICHTS. Was schon im Bild steht, bleibt
        stehen — „dann soll es einfach so aussehen wie immer".
     2. Der Stups ist 1,5 % statt 13 %. („so ein bis zwei Prozent")
     3. Einblenden und Stups treffen nie dasselbe Element gleichzeitig.
     4. Einblenden: 10 px in 0,7 s statt 22 px in 0,55 s — ruhiger.

   ⭐ „Nur dort, wo ich gerade mit dem Finger bin" ist messbar: die Kachel,
      deren Mitte der Schirmmitte am naechsten liegt. Sie bekommt den Stups,
      einmal je Vorbeiziehen.
   ⛔ Fail-safe unveraendert: der versteckte Zustand haengt an `html.s304-rev-an`,
      und diese Klasse setzt nur das JS. Ohne JS ist nichts versteckt.
   ⛔ KEIN MutationObserver. */
(function(){
  if (!/\/collections\//.test(location.pathname)) return;
  if (!('IntersectionObserver' in window)) return;
  try { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch(e){}

  var wurzel = document.documentElement;

  function kacheln(){
    return Array.prototype.filter.call(
      document.querySelectorAll('.grid-item.product-item'),
      function(e){ return e.getBoundingClientRect().width > 80; });
  }

  var gestartet = false;
  function start(){
    var liste = kacheln();
    if (!liste.length) return false;
    gestartet = true;

    /* ⭐ 1 · BEIM ERSTEN LADEN NICHTS. Alles, was jetzt schon (auch nur zum
       Teil) im Bild steht, gilt als fertig — kein Verstecken, kein Einblenden.
       Nur was darunter liegt, bekommt spaeter die ruhige Einblendung. */
    var spaeter = [];
    liste.forEach(function(el){
      var r = el.getBoundingClientRect();
      /* ⛔ KORREKTUR 21.09.: vorher galt `r.top < innerHeight` als „schon im
         Bild". Gemessen auf /collections/walletchains (402×812): Kacheln bei
         y 238, 519, 799, 1080 — die Reihe bei 799 ragt mit 13 von 280 px
         herein, also zu 95 % unsichtbar, und galt trotzdem als fertig.
         Ergebnis: 1 von 7 Kacheln animiert, der Effekt praktisch weg.
         ⭐ Jetzt zaehlt eine Kachel nur als „schon da", wenn mindestens ein
         Viertel von ihr im Bild steht. Beim ersten Laden passiert damit
         weiterhin nichts Sichtbares — aber was unten nur anschneidet, fliegt
         beim Scrollen ein. */
      var drin = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
      if (drin > r.height * 0.25) return;
      spaeter.push(el);
    });
    if (spaeter.length) {
      wurzel.classList.add('s304-rev-an');
      spaeter.forEach(function(e){ e.classList.add('s304-rev'); });
      /* ⭐ Lebensbeweis: der Rueckruf feuert nach `observe()` fuer JEDES
         Element einmal, auch ausserhalb des Bildes. Kommt er nie, ist der
         Beobachter tot — nur dann greift das Netz unten. */
      var beobachterLebt = false;
      var beob = new IntersectionObserver(function(eintraege){
        beobachterLebt = true;
        eintraege.forEach(function(ein){
          if (!ein.isIntersecting) return;
          beob.unobserve(ein.target);
          ein.target.classList.add('da');
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
      spaeter.forEach(function(e){ beob.observe(e); });

      /* Netz: greift NUR, wenn nach 2,5 s keine einzige Kachel aufgedeckt ist,
         der Beobachter also nachweislich nicht arbeitet. */
      /* ⛔ KORREKTUR 21.09.: hier stand „gibt es eine aufgedeckte Kachel?".
         Alle markierten Kacheln liegen unter der Falz — es KANN keine
         aufgedeckt sein, solange niemand scrollt. Das Netz schlug damit
         jedes Mal zu und schaltete die Animation ab.
         ⭐ Jetzt zaehlt der Lebensbeweis des Beobachters. */
      setTimeout(function(){
        if (beobachterLebt) return;
        wurzel.classList.remove('s304-rev-an');
        spaeter.forEach(function(e){ e.classList.add('da'); });
      }, 2500);
    }

    /* ⭐ 2 · DER STUPS: nur die Kachel in der Schirmmitte, 1,5 %, einmal je
       Vorbeiziehen. Kein eigener Takt — derselbe rAF-Rhythmus wie ueberall. */
    var zuletzt = null, tickt = false;
    function mitte(){
      tickt = false;
      var m = window.innerHeight / 2, beste = null, abstand = 1e9;
      for (var i = 0; i < liste.length; i++){
        var r = liste[i].getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) continue;
        var d = Math.abs((r.top + r.bottom) / 2 - m);
        if (d < abstand){ abstand = d; beste = liste[i]; }
      }
      if (!beste || beste === zuletzt) return;
      zuletzt = beste;
      var bild = beste.querySelector('.product-item__image, img');
      if (!bild) return;
      bild.classList.remove('s304-stups');
      void bild.offsetWidth;                 /* Neustart der Animation erzwingen */
      bild.classList.add('s304-stups');
      setTimeout(function(){ bild.classList.remove('s304-stups'); }, 820);
    }
    addEventListener('scroll', function(){
      if (!tickt){ tickt = true; requestAnimationFrame(mitte); }
    }, {passive:true});

    return true;
  }

  /* ⭐ 21.09.2026, KORREKTUR — ERST MESSEN, WENN DIE HOEHEN STEHEN.
     Die erste Fassung entschied 350 ms nach dem Skript, welche Kachel im
     ersten Schirm liegt. Zu dem Zeitpunkt waren die Produktbilder noch nicht
     geladen, die Seite war kuerzer, und fast alles galt als „schon im Bild" —
     gemessen: 1 von 7 Kacheln markiert. Nach `load` stimmen die Hoehen. */
  function anwerfen(){
    if (gestartet) return;
    setTimeout(function(){
      if (gestartet) return;
      var versuche = 0;
      var iv = setInterval(function(){
        versuche++;
        if (gestartet || start() || versuche >= 8) clearInterval(iv);
      }, 300);
      start();
    }, 250);
  }
  if (document.readyState === 'complete') anwerfen();
  else addEventListener('load', anwerfen, {once:true});
})();

/* ==== JEDE FLAECHE BEKOMMT IHRE EIGENE HEATMAP — 21.09.2026 ====

   Enzo woertlich: „ich will ja auch wirklich die Heatmap genau im Warenkorb,
   auf jeder Seite, auf jedem Popup und so weiter haben. Das muss gehen, das
   machen ja grosse, grosse, grosse Brands auch."

   ⛔ ER HAT RECHT, UND ES GING BISHER NICHT. Clarity baut Heatmaps pro URL.
      Das Warenkorb-Schubfach und die Popups sind Schichten im selben Dokument
      ohne eigenen Seitenaufruf — ihre Klicks landeten deshalb ALLE in der
      Heatmap der Produktseite und waren dort nicht zu trennen.

   ⛔ JARVIS' VORSCHLAG WAR FALSCH und ich habe ihn nicht uebernommen: er nannte
      `clarity('set','page',url)`. Diesen Aufruf gibt es nicht. Die offizielle
      Liste kennt genau fuenf: `consent`, `identify`, `set`, `event`, `upgrade`.

   ⭐ WAS WIRKLICH GREIFT, live gemessen am 21.09. auf /products/big-steel:
      nach `history.replaceState(…, '?ansicht=warenkorb')` feuert Clarity einen
      NEUEN `/collect`-Beacon, und dessen Nutzlast traegt die neue Adresse:
        {"e":["0.8.70",…,"x42gsqc8st",…,"https://304supply.de/products/big-steel?ansicht=popup"]}
      Damit ist die Schicht eine eigene Flaeche im Heatmap-Waehler.
   ⭐ `replaceState` statt `pushState`: beides funktioniert (beides gemessen),
      aber `replaceState` legt KEINEN Verlaufseintrag an — der Zurueck-Knopf
      verhaelt sich also genau wie vorher. Kein Risiko fuer den Kaufweg.
   ⭐ `upgrade` ist die dokumentierte Art, eine Sitzung vor dem Wegsampeln zu
      schuetzen — gedacht fuer „interactions with specific parts of your
      website (such as a shopping cart)". Genau unser Fall.

   ⛔ KEIN MutationObserver auf `document.body` — der hat am 20.09. den ganzen
      Shop eingefroren. Hier laeuft ein Takt von 250 ms, der NUR liest
      (vier `querySelector` + `getComputedStyle`), nie schreibt.
   ⛔ Erkannt wird ueber `is-open` (die Marke, die das Theme selbst setzt) und
      ueber die tatsaechliche Sichtbarkeit — nicht ueber geratene Klassennamen. */
(function(){
  "use strict";
  if (window.__s304Flaechen) return;
  window.__s304Flaechen = true;

  var URSPRUNG = location.pathname + location.search;

  var FLAECHEN = [
    { name: 'zweitstueck',    wahl: '.s304-mod' },
    { name: 'warenkorb',      wahl: '#cart-drawer.is-open, .drawer--cart.is-open' },
    { name: 'menue',          wahl: '.drawer--header.is-open' },
    { name: 'produktfenster', wahl: '.product-modal.is-open, .product-modal.is-active' },
    { name: 'inner_circle',   wahl: '.ic-modal.is-open, [data-ic-modal].is-open' }
  ];

  var aktiv = null;

  function clr(){
    try { if (typeof window.clarity === 'function') window.clarity.apply(null, arguments); } catch(e){}
  }
  function sichtbar(el){
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    if (parseFloat(s.opacity) < 0.05) return false;
    return true;
  }

  function pruefen(){
    var jetzt = null;
    for (var i = 0; i < FLAECHEN.length; i++){
      if (sichtbar(document.querySelector(FLAECHEN[i].wahl))) { jetzt = FLAECHEN[i].name; break; }
    }
    if (jetzt === aktiv) return;
    var vorher = aktiv;
    aktiv = jetzt;
    try {
      history.replaceState(history.state, '',
        jetzt ? (location.pathname + '?ansicht=' + jetzt) : URSPRUNG);
    } catch(e){}
    if (jetzt){
      clr('set', 'flaeche', jetzt);
      clr('event', 'flaeche_' + jetzt);
      clr('upgrade', jetzt);          /* schuetzt die Aufzeichnung vor dem Wegsampeln */
    } else if (vorher){
      clr('event', 'flaeche_' + vorher + '_zu');
    }
  }

  /* Der Takt laeuft erst, wenn die Seite steht — vorher gibt es nichts zu sehen. */
  function start(){ pruefen(); setInterval(pruefen, 250); }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);

  /* Ein echter Seitenwechsel setzt den Ursprung neu, sonst zeigt das
     Zuruecksetzen auf die alte Adresse. */
  window.addEventListener('popstate', function(){
    if (!aktiv) URSPRUNG = location.pathname + location.search;
  });
})();

/* ==== DIE AUSWAHL WIRD EIN BLATT VON UNTEN — 21.09.2026, 04:30 ====

   Enzo woertlich: „wenn man auf Aendern drueckt, dass da dann steht Big Steel,
   120 €, also das Produkt, das man auswaehlt, und darunter: plus deine zweite
   Walletchain geht auf uns … unten steht dann nochmal aufgelistet, was man
   bezahlt, was man umsonst bekommt, und dann steht der Gesamtpreis, jetzt in
   den Warenkorb legen. Und Gesamtpreis ist beim CTA auch unten rechts."

   ⛔ WIEDERVERWENDUNG VOR BAU — hier wird NICHTS neu gebaut, was es schon gibt:
      · die Auswahl-Logik bleibt `.s304-sel__d` / `.s304-sel__o` (unveraendert),
      · „Mehr erfahren" klickt den vorhandenen `.lnk[data-h]`, der das
        vorhandene Produktfenster `.s304-mod` oeffnet — genau das Popup, das
        Enzo meint („ich will halt wirklich genau den Pop-Up haben, den ich da
        jetzt aktuell auch schon hab"),
      · der Kaufknopf klickt den ECHTEN Kaufknopf der Seite
        (`#ProductSubmitButton-…`), damit der Warenkorb so oeffnet wie immer.
      Neu sind nur: die Huelle als Blatt, der Kopf und der Kassenzettel.

   ⛔ GEMESSEN vorher (402×812): `.s304-pop` lag INLINE bei y 452 und war
      370 × 259 gross — es schob den Kaufknopf nach unten aus dem Bild. Als
      Blatt liegt es ueber der Seite und schiebt nichts mehr.
   ⛔ KEIN MutationObserver auf `document.body` (der hat am 20.09. den Shop
      eingefroren) — der Beobachter haengt NUR an `.s304-pop` und filtert auf
      `class`. Im Rueckruf wird nichts geschrieben, was er selbst beobachtet. */
(function(){
  "use strict";
  if (window.__s304Blatt) return;
  window.__s304Blatt = true;
  if (!document.body || !document.body.classList.contains('template-product')) return;

  var T = window.s304T || function(de){ return de; };

  function eur(n){
    return (Math.round(n * 100) / 100).toLocaleString(window.s304EN ? 'en-GB' : 'de-DE',
      {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
  }

  function daten(){ return (window.S304_BUNDLE && window.S304_BUNDLE.daten) || null; }

  /* ---------- Kopf: Hauptprodukt, darunter die Zusage ---------- */
  function kopfSetzen(){
    var D = daten(); if (!D) return;
    var l = document.querySelector('.s304-sel__l');
    /* \u26d4 Derselbe Grund wie oben: kein Substantiv, kein Artikel-Problem. */
    if (l) l.textContent = T('+ Das zweite St\u00fcck geht auf uns',
                             '+ The second one is on us');
  }

  /* ---------- „Mehr erfahren" je Zeile ---------- */
  function mehrSetzen(){
    document.querySelectorAll('.s304-sel__d, .s304-sel__o').forEach(function(zeile){
      if (zeile.querySelector('.s304-mehr')) return;
      var lnk = zeile.querySelector('.lnk[data-h]');
      if (!lnk) return;
      var s = document.createElement('span');
      s.className = 's304-mehr';
      s.textContent = T('MEHR ERFAHREN', 'LEARN MORE');
      /* ⛔ Der Klick darf die Zeilenauswahl NICHT ausloesen. */
      s.addEventListener('click', function(ev){
        ev.preventDefault(); ev.stopPropagation();
        var h = lnk.getAttribute('data-h');
        if (window.S304_BUNDLE && window.S304_BUNDLE.zeigen && h) window.S304_BUNDLE.zeigen(h);
        else lnk.click();
      }, true);
      lnk.parentNode.appendChild(s);
    });
  }

  /* ---------- Der kleine Kassenzettel + der Kaufknopf ---------- */
  var fuss = null;
  function fussBauen(){
    var pop = document.querySelector('.s304-pop'); if (!pop) return null;
    if (fuss && fuss.parentNode === pop) return fuss;
    fuss = document.createElement('div');
    fuss.className = 's304-blatt__f';
    fuss.innerHTML =
        '<div class="s304-zettel"></div>'
      + '<button type="button" class="s304-blatt__cta">'
      +   '<span class="tx"></span><span class="pr"></span></button>';
    pop.appendChild(fuss);
    fuss.querySelector('.s304-blatt__cta').addEventListener('click', function(){
      /* ⭐ Kein eigener Warenkorb-Weg: der ECHTE Kaufknopf der Seite wird
         geklickt. Er legt beide Stuecke ein und oeffnet das Schubfach so, wie
         es der Shop immer tut. */
      /* \u26d4 ZUERST ARMIEREN, sonst legt der echte Knopf nur das Hauptprodukt ein.
         \u2b50 Es sei denn, der Kunde hat das zweite Stueck abgewaehlt — dann
         werden die Felder ausdruecklich geraeumt. */
      var ohne = document.documentElement.classList.contains('s304-ohne-zweites');
      try {
        if (window.S304_BUNDLE){
          if (ohne && window.S304_BUNDLE.entwaffnen) window.S304_BUNDLE.entwaffnen();
          else if (window.S304_BUNDLE.armieren) window.S304_BUNDLE.armieren();
        }
      } catch(e){}
      var echt = document.querySelector('.product__submit__buttons button[type="submit"], '
                                      + '#ProductSubmitButton-template--27556033233277__product, '
                                      + 'product-form button[name="add"]');
      if (!echt) echt = [...document.querySelectorAll('button')].filter(function(b){
        return /warenkorb|add to cart/i.test(b.textContent) && b.getBoundingClientRect().height > 10
               && !b.classList.contains('s304-duo') && !b.classList.contains('cart-bar__atc-btn');
      })[0];
      /* \u2b50 KEIN `zu()` davor. Frueher schloss das Blatt zuerst und der echte
         Knopf kam 60 ms spaeter — in dieser Luecke sah man die nackte PDP.
         Jetzt klickt der Knopf sofort; das Blatt bleibt liegen, bis das
         Schubfach wirklich offen ist, und verschwindet dahinter. */
      kaufLaeuft = true;
      if (echt) echt.click();
      var wache = 0;
      var uhr = setInterval(function(){
        wache++;
        var dr = document.querySelector('.drawer--cart');
        if ((dr && dr.classList.contains('is-open')) || wache > 40){
          clearInterval(uhr);
          kaufLaeuft = false;
          sollOffen = false;
          document.documentElement.classList.remove('s304-blatt-auf');
        }
      }, 80);
    });
    return fuss;
  }

  function fussSetzen(){
    var D = daten(); if (!D) return;
    var f = fussBauen(); if (!f) return;
    /* \u26d4 `gewaehlt()` aendert sich erst beim Armieren — im Blatt stimmt nur
       die markierte Zeile. Preis aus dem durchgestrichenen Betrag lesen. */
    var g = null;
    var dz = document.querySelector('.s304-sel__d');
    if (dz){
      var nm = dz.querySelector('.lnk');
      var alt = dz.querySelector('.s304-alt');
      var pz = alt ? parseFloat(String(alt.textContent).replace(/[^0-9,.]/g, '').replace(',', '.')) : NaN;
      if (nm) g = { n: nm.textContent.trim(), p: isNaN(pz) ? 0 : pz };
    }
    if (!g) g = window.S304_BUNDLE.gewaehlt();
    if (document.documentElement.classList.contains('s304-ohne-zweites')) g = null;
    var haupt = D.haupt || {};
    var zeilen =
        '<div><span>' + (haupt.n || '') + '</span><span>' + eur(haupt.std || 0) + '</span></div>';
    if (g) zeilen +=
        '<div class="frei"><span>' + g.n + '</span>'
      + '<span><s>' + eur(g.p) + '</s> ' + eur(0) + '</span></div>';
    zeilen +=
        '<div class="grau"><span>' + T('Versand', 'Shipping') + '</span>'
      + '<span>' + T('Gratis', 'Free') + '</span></div>'
      + '<div class="summe"><span>' + T('Gesamt', 'Total') + '</span>'
      + '<span>' + eur(haupt.std || 0) + '</span></div>';
    f.querySelector('.s304-zettel').innerHTML = zeilen;
    f.querySelector('.tx').textContent = g
      ? T('Beide in den Warenkorb legen', 'Add both to cart')
      : T('In den Warenkorb legen', 'Add to cart');
    f.querySelector('.pr').textContent = eur(haupt.std || 0);
  }

  /* ---------- auf / zu ---------- */
  function auf(){
    document.documentElement.classList.add('s304-blatt-auf');
    /* Die Liste steht im Blatt IMMER offen — man soll alles sehen, ohne noch
       einmal tippen zu muessen. */
    var d = document.querySelector('.s304-sel__d');
    if (d && !d.classList.contains('offen')) d.classList.add('offen');
    kopfSetzen(); mehrSetzen(); fussSetzen();
  }
  var kaufLaeuft = false;   /* \u26d4 haelt das Blatt, bis der Warenkorb offen ist */
  var sollOffen = false;    /* \u26d4 hat der Kunde geoeffnet? */
  var zurueck = 0;          /* wie oft schon zurueckgesetzt (Deckel gegen Dauerkampf) */
  function zu(){
    if (kaufLaeuft) return;
    document.documentElement.classList.remove('s304-blatt-auf');
  }

  /* Beobachter NUR auf `.s304-pop`, Attribut `class`. */
  function anhaengen(){
    var pop = document.querySelector('.s304-pop');
    if (!pop) return false;
    var beob = new MutationObserver(function(){
      if (pop.classList.contains('da')) { sollOffen = true; zurueck = 0; auf(); return; }
      /* \u26d4 Der Paarbild-Block springt 280 ms nach dem Klick in die Galerie
         und dabei verliert das Fenster seine Klasse — gemessen auf
         /products/icy-stellar: auf bei t+118, zu bei t+411, dasselbe Element.
         Wenn der Kunde nicht selbst geschlossen hat, setzen wir zurueck. */
      if (sollOffen && !kaufLaeuft && zurueck < 3){
        zurueck++;
        pop.classList.add('da');
        return;
      }
      zu();
    });
    beob.observe(pop, {attributes: true, attributeFilter: ['class']});
    if (pop.classList.contains('da')) auf();
    /* Auswahl geaendert -> Zettel neu rechnen. Ein Klick ist ein endliches
       Ereignis, keine Schleife. */
    /* \u2b50 Beobachter statt geratener Zeitpunkte: feste Fristen (60/200/450/900 ms)
       haben die Neubauten der bestehenden Logik nicht zuverlaessig erwischt.
       \u26d4 Er haengt NUR an `.s304-sel` und meldet sich waehrend der eigenen
       Schreibvorgaenge ab — sonst waere es genau die Rueckkopplung, die am
       20.09. den ganzen Shop eingefroren hat. */
    var selEl = document.querySelector('.s304-sel');
    if (selEl){
      var nachziehen = function(){
        selBeob.disconnect();
        try { mehrSetzen(); fussSetzen(); } catch(e){}
        selBeob.observe(selEl, {childList: true, subtree: true});
      };
      var selBeob = new MutationObserver(nachziehen);
      selBeob.observe(selEl, {childList: true, subtree: true});
    }
    pop.addEventListener('click', function(ev){
      /* \u26d4 Das Kreuz ist ein Schliessen DURCH DEN KUNDEN — danach darf der
         Rueckhol-Riegel nicht mehr greifen. Ohne diese Zeile liess sich das
         Blatt nicht mehr schliessen (gemessen: `nachX: true`). */
      if (ev.target && ev.target.closest && ev.target.closest('.s304-pop__x')) sollOffen = false;
      setTimeout(function(){ mehrSetzen(); fussSetzen(); }, 80);
    });
    /* Auf den dunklen Grund tippen schliesst das Blatt. */
    document.addEventListener('click', function(ev){
      if (!document.documentElement.classList.contains('s304-blatt-auf')) return;
      if (pop.contains(ev.target)) return;
      var duo = document.querySelector('.s304-duo');
      if (duo && duo.contains(ev.target)) return;
      /* \u26d4 Das Produktfenster liegt UEBER dem Blatt und gehoert dazu —
         ein Klick darin (auch auf sein Kreuz) darf das Blatt nicht schliessen.
         Gemessen: ohne diese Zeile ging beim Schliessen des Fensters auch das
         Blatt zu. */
      if (ev.target.closest && ev.target.closest('.s304-mod')) return;
      sollOffen = false;                /* der Kunde schliesst — nicht zurueckholen */
      var x = pop.querySelector('.s304-pop__x');
      if (x) x.click(); else zu();
    }, true);
    return true;
  }

  if (!anhaengen()){
    var n = 0, iv = setInterval(function(){ n++; if (anhaengen() || n > 40) clearInterval(iv); }, 250);
  }
})();

/* ==== DER KASTEN AUF DER PDP WIRD FASSUNG B — 21.09.2026, 06:45 ====

   Enzo: „das mit dem Toggle und so ist noch nicht gebaut auf der Produktseite.
   Das solltest du ja bauen." Gewaehlt hatte er: Fassung B, zwei Zeilen,
   kompakt, Wortlaut „geht auf uns".

   ⛔ WIEDERVERWENDUNG: `.s304-duo` bleibt der Knopf, der das Blatt oeffnet, und
      `duoZeichnen()` baut ihn weiter. Dieser Block schreibt nur den INHALT um,
      nachdem das Theme ihn gezeichnet hat — Beobachter NUR auf `.s304-huelle`,
      mit Abmeldung waehrend der eigenen Schreibvorgaenge (die Schleife vom
      20.09. soll sich nicht wiederholen).
   ⛔ Der Schalter schaltet NICHT das Bundle ab (dafuer gibt es keinen Weg in der
      bestehenden Logik) — er ist der sichtbare Beleg, dass das zweite Stueck
      dabei ist, und oeffnet wie die ganze Zeile das Blatt. Sobald es ein
      echtes Abwaehlen geben soll, sag Bescheid: das ist ein eigener Bau. */
(function(){
  "use strict";
  if (window.__s304Toggle) return;
  window.__s304Toggle = true;
  if (!document.body || !document.body.classList.contains('template-product')) return;

  var T = window.s304T || function(de){ return de; };

  function schreiben(){
    var duo = document.querySelector('.s304-duo');
    if (!duo) return;
    var D = (window.S304_BUNDLE && window.S304_BUNDLE.daten) || null;
    if (!D) return;

    /* Das gewaehlte Stueck: aus dem Blatt, sonst aus der API, sonst das erste. */
    var g = null;
    var dz = document.querySelector('.s304-sel__d');
    if (dz){
      var nm = dz.querySelector('.lnk');
      var alt = dz.querySelector('.s304-alt');
      if (nm) g = { n: nm.textContent.trim(),
                    p: alt ? parseFloat(String(alt.textContent).replace(/[^0-9,.]/g,'').replace(',','.')) : null };
    }
    if (!g && window.S304_BUNDLE.gewaehlt) g = window.S304_BUNDLE.gewaehlt();
    if (!g) g = (D.liste || [])[0];
    if (!g) return;

    var typ = (D.haupt && D.haupt.typ) || 'Walletchain';

    /* Zeile 1: Schalter + Zusage */
    var t = duo.querySelector('.s304-duo__t');
    if (t){
      var gr = t.querySelector('.gr'), kl = t.querySelector('.kl');
      /* \u26d4 „Deine zweite Bracelet" war falsch — Bracelet ist saechlich,
         Walletchain weiblich. Ohne Substantiv gibt es den Fall gar nicht. */
      /* ==== S304-GESCHENKZEILE — 21.09.2026, abends ====
         Enzo hat Vorschlag A abgenommen: „das finde ich gut, 100 %, lass uns das
         so machen." Dazu Jarvis' Copy-Urteil: „DEIN ZWEITES STUECK" benennt nur,
         es signalisiert weder den Geschenk-Charakter noch die Waehlbarkeit —
         beides muss diese eine Zeile tragen. Also die Funktionsbeschriftung
         „DEIN GESCHENK — WAEHLBAR".
         ⭐ Und das Bild dazu: der Freisteller des gewaehlten Stuecks, 54 px.
         Der Ausschnitt aus dem Blatt traegt nur Name und Preis, deshalb wird der
         volle Eintrag ueber den Namen aus `D.liste` nachgeschlagen (`bild(p)` im
         Bundle-Modul ist `p.fs || p.b`). */
      var voll = null, LL = (D && D.liste) || [];
      for (var vi = 0; vi < LL.length; vi++){
        if (LL[vi] && LL[vi].n === g.n) { voll = LL[vi]; break; }
      }
      var quelle = (voll && (voll.fs || voll.b)) || '';
      if (gr) gr.textContent = T('DEIN GESCHENK \u2014 W\u00c4HLBAR',
                                 'YOUR GIFT \u2014 YOUR CHOICE');
      if (kl) kl.innerHTML =
          (quelle ? '<span class="s304-tg__bi"><img src="' + quelle + '" alt="" loading="lazy" width="54" height="54"></span>' : '')
        + '<span class="s304-tg__n">' + g.n + '</span>'
        + (g.p ? '<span class="s304-tg__p"><s>' + g.p + ' €</s><b>0 €</b></span>' : '')
        + '<span class="s304-tg__ae">' + T('ÄNDERN', 'CHANGE') + '</span>';
      /* ⭐ „ENTFERNEN" steht in der ERSTEN Zeile, neben der Zusage — dort,
         wo vorher der Schalter war. Zwei Zeilen, je ein Ziel. */
      if (gr && !gr.querySelector('.s304-tg__weg')){
        var w = document.createElement('span');
        w.className = 's304-tg__weg';
        w.textContent = T('ENTFERNEN', 'REMOVE');
        w.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          document.documentElement.classList.add('s304-ohne-zweites');
          try { if (window.S304_BUNDLE && window.S304_BUNDLE.entwaffnen) window.S304_BUNDLE.entwaffnen(); } catch(e){}
          schreiben();
        }, true);
        gr.appendChild(w);
      }
    }
    /* ⛔ 21.09.: der Schalter ist RAUS — Begruendung im Kopfkommentar.
       Ein Schalter sagt: Einstellung. Eine Zeile mit ENTFERNEN sagt:
       liegt schon drin. Zweiteres ist die Wahrheit. */
    var altS = duo.querySelector('.s304-tg__sch');
    if (altS) altS.remove();
    duo.classList.add('s304-tg');

    /* Abgewaehlt: der Kasten sagt es, und der Kaufknopf heisst wieder einfach. */
    var ohne = document.documentElement.classList.contains('s304-ohne-zweites');
    duo.classList.toggle('s304-aus', ohne);
    if (ohne && t){
      var gr3 = t.querySelector('.gr'), kl3 = t.querySelector('.kl');
      if (gr3) gr3.textContent = T('Kein zweites Stück — derselbe Preis.',
                                   'No second piece — same price.');
      /* ⛔ Die Rueckholzeile ist Pflicht: ohne sie ist der Weg zurueck weg. */
      if (kl3) kl3.innerHTML = '<span class="s304-tg__zurueck">'
        + T('GRATIS-STÜCK HINZUFÜGEN', 'ADD THE FREE PIECE') + '</span>';
      if (!duo.__zurueck){
        duo.__zurueck = true;
        duo.addEventListener('click', function(ev){
          if (!document.documentElement.classList.contains('s304-ohne-zweites')) return;
          ev.preventDefault(); ev.stopPropagation();
          document.documentElement.classList.remove('s304-ohne-zweites');
          schreiben();
        }, true);
      }
    }
  }

  function start(){
    var h = document.querySelector('.s304-huelle');
    if (!h) return false;
    var beob;
    var nachziehen = function(){
      beob.disconnect();
      try { schreiben(); } catch(e){}
      beob.observe(h, {childList: true, subtree: true});
    };
    beob = new MutationObserver(nachziehen);
    beob.observe(h, {childList: true, subtree: true});
    schreiben();
    return true;
  }
  if (!start()){
    var n = 0, iv = setInterval(function(){ n++; if (start() || n > 40) clearInterval(iv); }, 250);
  }
})();

/* ==== DER KATEGORIE-KOPF WIRD EIN BILD — 21.09.2026, Entwurf 01 ====

   Enzo: „eigentlich finde ich, das Foto traegt alles am besten. Und man kann
   trotzdem auf die Bewertung draufdruecken."

   ⭐ DIE BEWERTUNG BLEIBT, WAS SIE IST. Sie ist ein echter Link
      (`a.wc-trust-header__stars` → `/products/…#pdp-reviews-section`) — er wird
      NICHT nachgebaut, nur umgefaerbt. Deshalb wird hier auch nichts neu
      gezeichnet: die beiden vorhandenen Bloecke (Titelzeile und Band) wandern
      unveraendert in eine gemeinsame Huelle, die das Bild traegt.
   ⛔ GEMESSEN: beide sind Geschwister in `MAIN.main-content`
      (`.wc-trust-header` y 78 h 57, `.s304-kb` y 142 h 83) — zusammen 148 px,
      genau die Flaeche aus dem Artefakt.
   ⛔ Kein Beobachter auf `document.body`. Der hier haengt an `MAIN.main-content`
      und meldet sich waehrend des eigenen Umhaengens ab. */
(function(){
  "use strict";
  if (window.__s304Kopfbild) return;
  window.__s304Kopfbild = true;
  if (!document.body || !document.body.classList.contains('template-collection')) return;

  var BILDER = {
    walletchains: '//304supply.de/cdn/shop/t/88/assets/s304-kopf-wc.jpg',
    bracelets:    '//304supply.de/cdn/shop/t/88/assets/s304-kopf-br.jpg'
  };

  function slug(){
    return (location.pathname.match(/\/collections\/([a-z0-9\-]+)/i) || [])[1] || '';
  }

  function huellen(){
    var kopf = document.querySelector('.wc-trust-header');
    var band = document.querySelector('.s304-kb');
    if (!kopf || !band) return false;
    if (kopf.parentElement && kopf.parentElement.classList.contains('s304-kopfbild')) return true;
    if (kopf.parentElement !== band.parentElement) return false;

    var s = slug();
    var bild = BILDER[s];
    if (!bild) return true;          /* Kollektion ohne Motiv: alles bleibt, wie es ist */

    var h = document.createElement('div');
    h.className = 's304-kopfbild s304-kopfbild--' + s;
    /* ⛔ Kein Inline-Bild mehr: ein Inline-Stil schlaegt jede CSS-Regel, und der
       staerkere Schleier steht im CSS. Das Motiv kommt ueber die Klasse. */
    kopf.parentElement.insertBefore(h, kopf);
    h.appendChild(kopf);
    h.appendChild(band);
    return true;
  }

  function start(){
    var m = document.querySelector('main.main-content') || document.body;
    var beob;
    var lauf = function(){
      beob.disconnect();
      try { huellen(); } catch(e){}
      beob.observe(m, {childList: true});
    };
    beob = new MutationObserver(lauf);
    beob.observe(m, {childList: true});
    huellen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* Das Band kommt per JS spaeter — deshalb ein paar feste Nachlaeufe. */
  [300, 800, 1600, 2600].forEach(function(ms){ setTimeout(function(){ try { huellen(); } catch(e){} }, ms); });
})();

/* ==== DER GRIFF AM BLATT WISCHT JETZT WIRKLICH — 21.09.2026 ====

   Enzo: „ganz oben ist ja so ein kleiner Balken, der so symbolisiert, hier
   wieder runter swipen, um es zurueckzumachen. Das funktioniert nicht."

   ⛔ Er hat recht: der Griff war reine Zierde (ein `::before` am Blatt). Ein
      Griff, der wie ein Griff aussieht und nichts tut, ist schlimmer als
      keiner.
   ⭐ Jetzt: nach unten ziehen schliesst. Waehrend des Ziehens folgt das Blatt
      dem Finger; unter 90 px federt es zurueck, darueber faellt es zu.
      ⛔ `passive: true` beim Ziehen — sonst haengt das Scrollen. Abgebrochen
      wird nur, wenn die Bewegung ueberwiegend waagerecht ist (dann will der
      Kunde in der Liste wischen, nicht schliessen). */
(function(){
  "use strict";
  if (window.__s304Wisch) return;
  window.__s304Wisch = true;

  var pop = null, startY = 0, startX = 0, zieht = false, dy = 0;

  function blatt(){ return document.querySelector('.s304-pop.da'); }
  function offen(){ return document.documentElement.classList.contains('s304-blatt-auf'); }

  function an(ev){
    if (!offen()) return;
    var p = blatt(); if (!p) return;
    var t = ev.touches ? ev.touches[0] : ev;
    /* Nur im oberen Bereich anfassen — der Rest ist Liste zum Scrollen. */
    var r = p.getBoundingClientRect();
    if (t.clientY > r.top + 56) return;
    pop = p; startY = t.clientY; startX = t.clientX; zieht = true; dy = 0;
    pop.style.transition = 'none';
  }
  function zug(ev){
    if (!zieht || !pop) return;
    var t = ev.touches ? ev.touches[0] : ev;
    var d = t.clientY - startY;
    var q = Math.abs(t.clientX - startX);
    if (q > Math.abs(d) + 12){ ab(); return; }   /* eher waagerecht: abbrechen */
    if (d < 0) d = d / 4;                        /* nach oben nur zaeh */
    dy = d;
    pop.style.transform = 'translateY(' + d + 'px)';
  }
  function ab(){
    if (!pop) return;
    pop.style.transition = 'transform .22s cubic-bezier(0,0,.3,1)';
    pop.style.transform = '';
    pop = null; zieht = false; dy = 0;
  }
  function aus(){
    if (!zieht || !pop) { return; }
    var p = pop, weit = dy;
    p.style.transition = 'transform .22s cubic-bezier(0,0,.3,1)';
    if (weit > 90){
      p.style.transform = 'translateY(110%)';
      setTimeout(function(){
        var x = p.querySelector('.s304-pop__x');
        if (x) x.click();
        p.style.transform = ''; p.style.transition = '';
      }, 200);
    } else {
      p.style.transform = '';
    }
    pop = null; zieht = false; dy = 0;
  }

  document.addEventListener('touchstart', an, {passive: true});
  document.addEventListener('touchmove',  zug, {passive: true});
  document.addEventListener('touchend',   aus, {passive: true});
  document.addEventListener('touchcancel', ab, {passive: true});
  /* Maus, damit es sich auch am Rechner pruefen laesst. */
  document.addEventListener('mousedown', an);
  document.addEventListener('mousemove', function(e){ if (zieht) zug(e); });
  document.addEventListener('mouseup', aus);
})();

/* ==== DIE PFEILE AM BUNDLE-BLOCK — 21.09.2026 ====
   Marke: S304-KORB-PFEILE
   ⛔ Warum nicht einfach `data-cross-sell-prev` wie das Original: der Handler
      des Themes (layout/theme.liquid ~1056) sucht die Spur mit
      `document.querySelector('[data-cross-sell-track]')` — also IMMER die
      erste im Dokument. Liegen Bracelet UND Walletchain im Korb, gibt es zwei
      Spuren; die Pfeile des zweiten Blocks haetten den ersten geschoben.
      Deshalb ein eigener Griff, der seine Spur im EIGENEN Block sucht. */
(function(){
  "use strict";
  document.addEventListener('click', function(e){
    var pfeil = e.target && e.target.closest
      ? e.target.closest('[data-s304-korb-prev],[data-s304-korb-next]') : null;
    if (!pfeil) return;
    e.preventDefault(); e.stopPropagation();
    var block = pfeil.closest('[data-s304-korb]'); if (!block) return;
    var spur = block.querySelector('.ic-cross-sell__track'); if (!spur) return;
    var karte = spur.querySelector('.ic-cross-sell__card'); if (!karte) return;
    var weite = karte.offsetWidth || 120;
    spur.scrollBy({
      left: pfeil.hasAttribute('data-s304-korb-prev') ? -weite : weite,
      behavior: 'smooth'
    });
  }, true);
})();

/* ==== S304-IC-RIEGEL — die Marke, die das Fenster freigibt (21.09.2026) ====
   Gehoert zum CSS-Block gleichen Namens.
   Die Marke `s304-ic-auf` wird NUR bei einem echten Antippen gesetzt, und nur
   auf Elementen, die erkennbar zum Inner Circle gehoeren. Jeder Versuch, das
   Fenster ohne Antippen zu oeffnen, wird mit Aufrufliste weggeschrieben —
   damit beim naechsten Mal der vierte Weg mit Namen dasteht statt geraten wird. */
(function(){
  "use strict";
  var AUSLOESER = '#ic-top-ticker, .ic-member-price, .ic-lock-veil, .ic-lock-cta,'
    + ' [data-ic-open], [href*="inner-circle"], [href*="member-dashboard"],'
    + ' [onclick*="_ic_open_modal"]';

  function auf(){ document.documentElement.classList.add('s304-ic-auf'); }
  function zu(){ document.documentElement.classList.remove('s304-ic-auf'); }
  zu();

  /* 1 · echtes Antippen auf einem Inner-Circle-Element gibt frei */
  document.addEventListener('click', function(e){
    if (!e.isTrusted) return;
    var z = e.target && e.target.closest ? e.target.closest(AUSLOESER) : null;
    if (!z) return;
    auf();
  }, true);

  /* 2 · schliesst das Fenster, faellt die Marke wieder */
  document.addEventListener('click', function(e){
    if (!e.isTrusted) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#ic-close') || t.id === 'ic-modal-overlay') setTimeout(zu, 60);
  }, true);

  /* 3 · jeder Oeffnungsversuch ohne Antippen wird protokolliert (und bleibt wirkungslos,
        weil das CSS ihn nicht sichtbar werden laesst) */
  var takt = setInterval(function(){
    if (typeof window._ic_open_modal !== 'function') return;
    clearInterval(takt);
    var alt = window._ic_open_modal;
    if (alt.__s304Protokoll) return;
    var neu = function(){
      if (!document.documentElement.classList.contains('s304-ic-auf')){
        var spur = ((new Error()).stack || '').slice(0, 900);
        try { sessionStorage.setItem('_s304_ic_ohne_klick', spur); } catch(x){}
        try { if (window.clarity) window.clarity('event', 's304_ic_popup_ohne_klick'); } catch(x){}
        try { console.warn('[304] IC-Fenster wollte ohne Antippen auf:\n' + spur); } catch(x){}
      }
      return alt.apply(this, arguments);
    };
    neu.__s304Protokoll = true;
    neu.__icOrig = alt.__icOrig || alt;
    neu.__icWrapped = alt.__icWrapped;
    window._ic_open_modal = neu;
  }, 60);
  setTimeout(function(){ clearInterval(takt); }, 15000);
})();

/* ==== DER VIERTE WEG IST GEFUNDEN — UND BEKOMMT EINE ENGE AUSNAHME (21.09.2026) ====
   Marke: S304-RIEGEL-KARTENSCAN

   ⭐ GEFUNDEN in `snippets/304-ic-card-scan.liquid`, Zeile 131:
        var istKarte = (ausUrl==='card') || (!ausUrl && ref()==='card');
      `ref()` liest `localStorage._ic_ref`. Heisst: wer EINMAL eine Dankeskarte
      gescannt oder den Link aus der Erinnerungsmail geoeffnet hat, traegt
      `_ic_ref='card'` dauerhaft im Speicher — und dann oeffnet sich das Fenster
      auf `/pages/inner-circle` OHNE Adressparameter und OHNE Klick, per
      `setInterval` alle 50 ms, bis es aufgeht.
      Der einzige Riegel davor ist `sessionStorage._ic_card_seen` — der faellt
      mit jeder neuen Browser-Sitzung. Also: einmal je Sitzung, immer wieder.

   ⛔ Das ist der einzige automatische Oeffner, der im Theme noch scharf ist.
      Alle anderen (autoTrigger, essStarten, ref-capture) sind mit Schaltern aus.
   ⛔ Was ich NICHT beweisen kann: dass Enzo GENAU den gesehen hat. Sein
      Bildschirmfoto zeigt die Adresse nicht.

   ⭐ DIE AUSNAHME, bewusst eng: ein ECHTER Scan soll weiter funktionieren.
      Also gibt der Riegel frei, wenn die ADRESSE `?ref=card` traegt — nicht,
      wenn es nur im Speicher steht. Damit bleibt der gewollte Weg offen und
      der ungewollte zu.
   ⭐ Die eigentliche Wurzel steht in Zeile 131 des Snippets. Die anzufassen ist
      Enzos Entscheidung: der localStorage-Rueckfall wurde absichtlich gebaut,
      weil eine Weiterleitung das `?ref` verschluckt hat. */
(function(){
  "use strict";
  try {
    var p = new URLSearchParams(window.location.search).get('ref');
    if (p === 'card' && /\/pages\/inner-circle/.test(window.location.pathname)){
      document.documentElement.classList.add('s304-ic-auf');
    }
  } catch(e){}
})();

/* ==== DIE VORAUSWAHL IST AB JETZT WIRKLICH SCHARF — 21.09.2026 ====
   Marke: S304-VORAUSWAHL-SCHARF

   ⛔ GEMESSEN, bevor gebaut: auf der PDP stand „DEIN GESCHENK — WÄHLBAR ·
      MIDNIGHT LINK 50 € → 0 €", aber `S304_BUNDLE.armiert()` war `null` und im
      Formular lag KEIN einziges `.s304-feld`. Wer den Kaufknopf gedrueckt hat,
      ohne vorher das Blatt zu oeffnen, hat nur das Hauptprodukt eingelegt.
      Die Zeile hat also etwas versprochen, was der Knopf nicht gehalten hat.

   ⭐ Enzo: „es muss halt so sein, wenn jemand dann beide in den Warenkorb legt
      und halt nicht die Auswahl geaendert hat."
   ⭐ Und Jarvis zum selben Punkt: „Vorauswahl behalten. Default-Effekt: eine
      vorausgewaehlte Option wird ueberproportional uebernommen, weil sie
      kognitiven Aufwand spart und als implizite Empfehlung gelesen wird."

   Die Vorauswahl wird deshalb beim Laden ARMIERT — dieselbe Funktion, die auch
   das Blatt benutzt (`S304_BUNDLE.armieren`), kein zweiter Weg. Nebenwirkung
   erwuenscht: der Kaufknopf heisst damit von Anfang an „Beide in den Warenkorb
   legen" mit dem Gesamtpreis.

   ⛔ Wer ENTFERNEN gedrueckt hat, traegt `s304-ohne-zweites` am <html> — dann
      wird NICHT armiert. Das ist der Fall, der nach dem Riegel durchkommt. */
(function(){
  "use strict";
  if (!document.body || !document.body.classList.contains('template-product')) return;

  function scharf(){
    var B = window.S304_BUNDLE;
    if (!B || !B.armieren || !B.gewaehlt) return false;
    if (document.documentElement.classList.contains('s304-ohne-zweites')) return true;
    /* ==== S304-BLATT-NACHZIEHEN — 21.09.2026 ====
       ⛔ GEMESSEN nach dem Umbau des Blattes: im Blatt ROYAL GRACE angetippt →
          die Zeile sagte ROYAL GRACE, `armiert()` stand aber weiter auf LINE 47,
          und im Formular lag LINE 47s Variante. Der Kaufknopf haette das FALSCHE
          Stueck eingelegt. Die alte Bedingung („schon armiert? dann fertig")
          kannte nur AN und AUS, nicht WELCHES. */
    var g = null, a = null;
    try { g = B.gewaehlt(); } catch(e){}
    try { a = B.armiert && B.armiert(); } catch(e){}
    if (!g) return !!a;
    if (a && a.n === g.n) return true;
    try { B.armieren(g); } catch(e){ return false; }
    return true;
  }

  if (!scharf()){
    var n = 0, iv = setInterval(function(){ n++; if (scharf() || n > 60) clearInterval(iv); }, 150);
  }
  /* Nach jedem Antippen nachziehen: das Theme zeichnet die Kaufbox neu, und das
     Blatt entwaffnet zwischendurch. Billig, weil `scharf()` sofort aussteigt,
     sobald schon armiert ist. */
  document.addEventListener('click', function(){ setTimeout(scharf, 320); }, true);
})();

/* ==== DAS GESCHENK LAESST SICH AUCH IM WARENKORB TAUSCHEN — 21.09.2026 ====
   Marke: S304-KORB-AENDERN

   Enzo: „es muss halt so sein, wenn jemand dann beide in den Warenkorb legt und
   halt nicht die Auswahl geaendert hat, dass der auch noch in dem Warenkorb
   seine Gratis-Auswahl wieder aendern kann und dann sieht das genau gleich aus."

   ⛔ WARUM ES DAS BRAUCHT: sobald beide Stuecke drin liegen, ist das Bundle VOLL
      — der Vorschlagsblock verschwindet also (richtig so), und damit gab es
      keinen Weg mehr, das Gratis-Stueck zu tauschen. Nur „entfernen" und neu
      anfangen.

   ⭐ DIESELBE SPRACHE WIE AUF DER PDP: Beschriftung „DEIN GESCHENK — WAEHLBAR",
      ein unterstrichenes AENDERN, und ein Blatt von unten mit VIER Kacheln.
      Jarvis' Auflage dazu: „Im Blatt gehoert KEIN durchgestrichener Preis,
      sondern nur ,GESCHENK'" — sonst faellt man im Geschenk-Moment in den
      Rechen-Frame zurueck. Deshalb tragen die Kacheln kein Preisschild.

   ⛔ Der Preisdeckel ist derselbe wie im Liquid: angeboten wird nur, was
      hoechstens so teuer ist wie das guenstigste BEZAHLTE Stueck derselben
      Kategorie. Shopifys BXGY rabattiert immer das guenstigere Stueck. */
(function(){
  "use strict";
  if (window.__s304KorbAendern) return;
  window.__s304KorbAendern = true;
  var T = window.s304T || function(de){ return de; };
  var laeuft = false, liste = null, katAktuell = null;

  function schub(){ return document.querySelector('cart-drawer.is-open, .drawer--cart.is-open') ||
                           document.querySelector('cart-drawer, .drawer--cart'); }

  function gratisZeile(korb){
    var frei = null, zahler = [];
    korb.items.forEach(function(i){
      if (i.final_price === 0) frei = i; else zahler.push(i);
    });
    if (!frei) return null;
    var deckel = null;
    zahler.forEach(function(i){
      if (i.product_type !== frei.product_type) return;
      if (deckel === null || i.final_price < deckel) deckel = i.final_price;
    });
    if (deckel === null) return null;
    return {frei: frei, deckel: deckel};
  }

  function kollektion(typ){ return typ === 'Walletchain' ? 'walletchains' : 'bracelets'; }

  function holen(typ, deckel, drin){
    return fetch('/collections/' + kollektion(typ) + '/products.json?limit=40')
      .then(function(r){ return r.json(); })
      .then(function(j){
        var aus = [];
        (j.products || []).forEach(function(p){
          if ((p.tags || []).indexOf('Inner Circle') >= 0) return;
          var v = null;
          (p.variants || []).forEach(function(x){ if (!v && x.title === 'Standard') v = x; });
          if (!v || !v.available) return;
          var cent = Math.round(parseFloat(v.price) * 100);
          if (cent > deckel) return;
          if (drin.indexOf(v.id) >= 0) return;
          aus.push({id: v.id, n: p.title, b: (p.images && p.images[0] ? p.images[0].src : ''), cent: cent});
        });
        return aus;
      });
  }

  function blattBauen(eintraege, frei){
    var alt = document.getElementById('s304-kb-blatt');
    if (alt) alt.remove();
    var h = document.createElement('div');
    h.id = 's304-kb-blatt';
    var kacheln = eintraege.slice(0, 4).map(function(e){
      var ist = (e.id === frei.variant_id);
      return '<button type="button" class="s304-kb-kachel' + (ist ? ' da' : '') + '" data-id="' + e.id + '">'
           +   '<img src="' + e.b + '" alt="" loading="lazy">'
           +   '<span class="s304-kb-n">' + e.n + '</span>'
           +   '<span class="s304-kb-g">' + T('GESCHENK', 'GIFT') + '</span>'
           + '</button>';
    }).join('');
    h.innerHTML =
      '<div class="s304-kb-schatten"></div>'
      + '<div class="s304-kb-karte">'
      +   '<span class="s304-kb-griff"></span>'
      +   '<span class="s304-kb-kopf"><b>' + T('DEIN GESCHENK — WÄHLBAR', 'YOUR GIFT — YOUR CHOICE') + '</b>'
      +     '<i>' + T('geht auf uns', 'on us') + '</i></span>'
      +   '<div class="s304-kb-raster">' + kacheln + '</div>'
      +   (eintraege.length > 4 ? '<button type="button" class="s304-kb-alle">'
             + T('Alle ' + eintraege.length + ' ansehen', 'See all ' + eintraege.length) + '</button>' : '')
      + '</div>';
    document.body.appendChild(h);
    requestAnimationFrame(function(){ h.classList.add('auf'); });

    h.addEventListener('click', function(e){
      if (e.target === h.querySelector('.s304-kb-schatten')) { zu(); return; }
      var alle = e.target.closest ? e.target.closest('.s304-kb-alle') : null;
      if (alle){ h.querySelector('.s304-kb-raster').innerHTML = eintraege.map(function(x){
          return '<button type="button" class="s304-kb-kachel' + (x.id === frei.variant_id ? ' da' : '') + '" data-id="' + x.id + '">'
               + '<img src="' + x.b + '" alt="" loading="lazy"><span class="s304-kb-n">' + x.n + '</span>'
               + '<span class="s304-kb-g">' + T('GESCHENK','GIFT') + '</span></button>'; }).join('');
        alle.remove(); return; }
      var k = e.target.closest ? e.target.closest('.s304-kb-kachel') : null;
      if (!k) return;
      var neu = parseInt(k.getAttribute('data-id'), 10);
      if (!neu || neu === frei.variant_id) { zu(); return; }
      if (laeuft) return;
      laeuft = true; k.classList.add('laeuft');
      fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'},
            body: JSON.stringify({id: String(frei.variant_id), quantity: 0})})
        .then(function(){ return fetch('/cart/add.js', {method:'POST',
              headers:{'Content-Type':'application/json'},
              body: JSON.stringify({items:[{id: neu, quantity: 1}]})}); })
        .then(function(){
          try { if (window.clarity) window.clarity('event', 's304_geschenk_im_korb_getauscht'); } catch(x){}
          document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
          setTimeout(function(){ laeuft = false; zu(); anbauen(); }, 900);
        })
        .catch(function(){ laeuft = false; k.classList.remove('laeuft'); });
    }, true);
  }

  function zu(){
    var h = document.getElementById('s304-kb-blatt');
    if (!h) return;
    h.classList.remove('auf');
    setTimeout(function(){ if (h.parentNode) h.remove(); }, 240);
  }

  function anbauen(){
    var s = schub(); if (!s) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(korb){
      var g = gratisZeile(korb);
      Array.prototype.forEach.call(s.querySelectorAll('.s304-kb-ae'), function(x){ x.remove(); });
      /* 21.09.2026 — Marke der Geschenkzeile immer zuerst loeschen, sonst
         bleibt sie an einer Zeile haengen, die kein Geschenk mehr ist. */
      Array.prototype.forEach.call(s.querySelectorAll('.s304-gratiszeile'), function(x){
        x.classList.remove('s304-gratiszeile');
      });
      if (!g) return;
      /* Die Zeile im Schubfach finden, die zu diesem Posten gehoert. */
      var ziel = null;
      Array.prototype.forEach.call(s.querySelectorAll('[data-item], .cart__item'), function(z){
        var t = (z.textContent || '').replace(/\s+/g, ' ');
        if (!ziel && t.indexOf(g.frei.product_title) >= 0) ziel = z;
      });
      if (!ziel) return;
      var kopf = document.createElement('div');
      kopf.className = 's304-kb-ae';
      kopf.innerHTML = '<span>' + T('DEIN GESCHENK — WÄHLBAR', 'YOUR GIFT — YOUR CHOICE') + '</span>'
                     + '<button type="button">' + T('ÄNDERN', 'CHANGE') + '</button>';
      ziel.insertBefore(kopf, ziel.firstChild);
      ziel.classList.add('s304-gratiszeile');   /* traegt den Riegel gegen den doppelten Preis */
      kopf.querySelector('button').addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var drin = korb.items.map(function(i){ return i.variant_id; });
        holen(g.frei.product_type, g.deckel, drin).then(function(l){
          if (!l.length) return;
          blattBauen(l, g.frei);
        });
      });
    }).catch(function(){});
  }

  ['theme:cart:refresh','theme:cart:update','theme:cart:add','theme:cart:open'].forEach(function(n){
    document.addEventListener(n, function(){ setTimeout(anbauen, 700); });
  });
  document.addEventListener('click', function(e){
    var k = e.target && e.target.closest ? e.target.closest('#cart-icon-bubble, a[href="/cart"], .header__icon--cart') : null;
    if (k) setTimeout(anbauen, 900);
  }, true);
  setTimeout(anbauen, 1500);

  /* ==== WACHE: das Theme rendert die Zeilen neu und wirft ÄNDERN weg ====
     21.09.2026 — siehe umbau-2fuer1/aendern_wache.py.
     Laeuft nur an, wenn sich die Zeilen-Signatur aendert oder das Kopfstueck
     fehlt. Ohne Geschenk im Korb bleibt die Signatur gleich -> kein Abruf. */
  var letzteSignatur = null;
  setInterval(function(){
    var s = schub(); if (!s) return;
    var zeilen = s.querySelectorAll('.cart__item, [data-item]');
    if (!zeilen.length) { letzteSignatur = null; return; }
    var sig = '';
    Array.prototype.forEach.call(zeilen, function(z){ sig += (z.getAttribute('data-item') || '?') + '|'; });
    if (!s.querySelector('.s304-kb-ae')) sig += 'ohne';
    if (sig === letzteSignatur) return;
    letzteSignatur = sig;
    anbauen();
  }, 700);
})();

/* ==== DAS BLATT AUF DER PDP WIRD DAS GLEICHE WIE IM WARENKORB — 21.09.2026 ====
   Marke: S304-PDP-BLATT

   Enzo: „Wenn ich jetzt auf Aendern druecke, sieht es immer noch so aus wie in
   dem Entwurf davor, wir wollten das ja anders haben … wir wollten ja immer nur
   vier Varianten zum Auswaehlen und darunter dann mehr. Das ist noch nicht live."
   Er hat recht: ich hatte das Kachel-Blatt nur im WARENKORB gebaut, auf der
   Produktseite lief weiter die alte Liste mit Preisen.

   ⭐ WIEDERVERWENDUNG STATT ZWEITEM BAU, an zwei Stellen:
     1. Der Behaelter `.s304-sel` bleibt, wie er ist — damit bleiben Auf- und
        Zuklappen, der Wischgriff und der Hintergrund unangetastet.
     2. Die Kacheln tragen die `.s304-kb-*`-Klassen aus dem Warenkorb-Blatt.
        Ein Aussehen, eine CSS-Stelle. Genau das, was „sieht genau gleich aus"
        heisst.
     3. Ein Klick auf eine Kachel klickt das ZUGEHOERIGE Original-Element
        (`.s304-sel__o`) an. Die Auswahl-Logik bleibt damit die bestehende —
        kein zweites Regelwerk, das auseinanderlaufen kann.

   ⛔ Jarvis' Auflage: „Im Blatt gehoert KEIN durchgestrichener Preis, sondern
      nur ,GESCHENK'" — vier Preisschilder ruecken den Kunden im Geschenk-Moment
      zurueck in den Rechen-Frame. Deshalb tragen die Kacheln kein Preisschild. */
(function(){
  "use strict";
  if (window.__s304PdpBlatt) return;
  window.__s304PdpBlatt = true;
  var T = window.s304T || function(de){ return de; };

  function eintraege(sel){
    var aus = [];
    var d = sel.querySelector('.s304-sel__d');
    if (d){
      var n0 = d.querySelector('.lnk');
      var b0 = d.querySelector('img');
      if (n0) aus.push({n: n0.textContent.trim(), b: b0 ? b0.getAttribute('src') : '', el: d, gewaehlt: true});
    }
    Array.prototype.forEach.call(sel.querySelectorAll('.s304-sel__o'), function(o){
      var n = o.querySelector('.lnk'), b = o.querySelector('img');
      if (n) aus.push({n: n.textContent.trim(), b: b ? b.getAttribute('src') : '', el: o, gewaehlt: false});
    });
    return aus;
  }

  function kachel(e){
    return '<button type="button" class="s304-kb-kachel' + (e.gewaehlt ? ' da' : '') + '">'
         +   '<img src="' + e.b + '" alt="" loading="lazy">'
         +   '<span class="s304-kb-n">' + e.n + '</span>'
         +   '<span class="s304-kb-g">' + T('GESCHENK', 'GIFT') + '</span>'
         + '</button>';
  }

  function umbauen(){
    var sel = document.querySelector('.s304-sel');
    if (!sel) return false;
    var liste = eintraege(sel);
    if (!liste.length) return false;

    var alt = sel.querySelector('.s304-pdpb');
    var stand = liste.map(function(e){ return e.n + (e.gewaehlt ? '*' : ''); }).join('|');
    if (alt && alt.getAttribute('data-stand') === stand) return true;   /* nichts geaendert */
    if (alt) alt.remove();

    var h = document.createElement('div');
    h.className = 's304-pdpb';
    h.setAttribute('data-stand', stand);
    h.innerHTML =
      '<span class="s304-kb-kopf"><b>' + T('DEIN GESCHENK — WÄHLBAR', 'YOUR GIFT — YOUR CHOICE') + '</b>'
      + '<i>' + T('geht auf uns', 'on us') + '</i></span>'
      + '<div class="s304-kb-raster">' + liste.map(kachel).join('') + '</div>'
      + (liste.length > 4 ? '<button type="button" class="s304-kb-alle">'
           + T('Alle ' + liste.length + ' ansehen', 'See all ' + liste.length) + '</button>' : '');
    sel.appendChild(h);
    sel.classList.add('s304-sel--kacheln');

    var kacheln = h.querySelectorAll('.s304-kb-kachel');
    Array.prototype.forEach.call(kacheln, function(k, i){
      k.addEventListener('click', function(ev){
        ev.preventDefault(); ev.stopPropagation();
        /* S304-KACHEL-SUCHT-UEBER-DEN-NAMEN — 21.09.2026
           ⛔ Vorher stand hier `liste[i].el`, eine Referenz auf das
              Original-Element. Das Theme zeichnet die Liste nach jeder Wahl
              neu; die gemerkten Knoten sind danach tot und der Klick geht ins
              Leere. Symptom: man konnte genau EINMAL aendern.
           ⭐ Deshalb frisch suchen, ueber den Namen. */
        var gesucht = liste[i] && liste[i].n;
        var ziel = null;
        if (gesucht){
          var kand = document.querySelectorAll('.s304-sel__o, .s304-sel__d');
          for (var q = 0; q < kand.length; q++){
            var nm = kand[q].querySelector('.lnk');
            if (nm && nm.textContent.trim() === gesucht) { ziel = kand[q]; break; }
          }
        }
        if (!ziel) ziel = liste[i] && liste[i].el;
        if (!ziel) return;
        ziel.click();                                      /* bestehende Auswahl-Logik */
        /* ⛔ Das Blatt blieb nach der Wahl offen — der Griff, der es sonst
           schliesst, haengt an der alten Liste. Also hier zumachen, und den
           Waechter oben gleich nachziehen lassen. */
        /* S304-BLATT-ZU-UEBER-DEN-EIGENEN-KNOPF */
        setTimeout(function(){
          var x = document.querySelector('.s304-pop__x');
          if (x) x.click();
        }, 200);
      }, true);
    });
    var alle = h.querySelector('.s304-kb-alle');
    if (alle) alle.addEventListener('click', function(ev){
      ev.preventDefault(); ev.stopPropagation();
      h.classList.add('offen'); alle.remove();
    }, true);
    return true;
  }

  /* Das Blatt wird vom Theme neu gezeichnet; deshalb ein ruhiger Takt, der NUR
     laeuft, solange es offen ist — dieselbe Bauart wie die Warenkorb-Wache. */
  setInterval(function(){
    if (!document.documentElement.classList.contains('s304-blatt-auf')) return;
    try { umbauen(); } catch(e){}
  }, 350);
  document.addEventListener('click', function(){ setTimeout(function(){
    if (document.documentElement.classList.contains('s304-blatt-auf')) { try { umbauen(); } catch(e){} }
  }, 120); }, true);
})();

/* ==== DER BIG-STEEL-FREISTELLER OHNE SCHATTEN — 21.09.2026, abends ====
   Marke: S304-FS-OHNE-SCHATTEN

   Enzo: „auf der Walletchain-PDP, das erste Bild, das Thumbnail — ohne Schatten,
   sondern einfach nur der Freisteller."

   ⛔ `big-steel-freisteller-schatten.jpg` traegt den Schlagschatten IM Bild, und
      `304-fs-url` kann ihn hier nicht wegschneiden: big-steel hat
      `freisteller_hoehe` 99,6 %, das Produkt fuellt den Rahmen also fast ganz.
      Ein Zuschnitt haette die Karabiner abgeschnitten.
   ⭐ Deshalb eine bereinigte Fassung: gemessen, wo die Kette endet (Zeile 1806
      von 2000 = 90,2 %, unterste Zeile mit >= 3 Pixeln unter Helligkeit 130),
      darunter alles auf Weiss, und im Band von 260 Zeilen darueber nur das
      WEICHE (Helligkeit >= 175) — das Metall bleibt unangetastet.
      Gegenprobe: unter der Kette min 255 (also reines Weiss), oberhalb min 10
      (das Metall ist unveraendert).
   ⭐ Das Bild liegt als Theme-Asset `304-fs-big-steel.jpg`; die Produktdaten
      wurden NICHT angefasst. Rueckweg: diesen Block entfernen.
   ⛔ Betrifft nur diese eine Datei — die anderen Walletchain-Freisteller werden
      von `304-fs-url` sauber zugeschnitten. */
(function(){
  "use strict";
  if (window.__s304FsOhneSchatten) return;
  window.__s304FsOhneSchatten = true;
  var ALT = 'big-steel-freisteller-schatten';
  var NEU = '//cdn.shopify.com/s/files/1/0908/7660/8893/t/88/assets/304-fs-big-steel.jpg';

  function tauschen(){
    var n = 0;
    Array.prototype.forEach.call(document.querySelectorAll('img'), function(im){
      var s = im.getAttribute('src') || '';
      if (s.indexOf(ALT) < 0) return;
      var b = /[?&]width=(\d+)/.exec(s);
      im.setAttribute('src', NEU + (b ? '?width=' + b[1] : ''));
      if (im.hasAttribute('srcset')) im.removeAttribute('srcset');
      n++;
    });
    /* auch Galerie-Quellen, die noch als <source> liegen */
    Array.prototype.forEach.call(document.querySelectorAll('source[srcset*="' + ALT + '"]'), function(q){
      q.setAttribute('srcset', NEU); n++;
    });
    return n;
  }
  tauschen();
  var t = 0, iv = setInterval(function(){ tauschen(); if (++t > 20) clearInterval(iv); }, 400);
  document.addEventListener('click', function(){ setTimeout(tauschen, 250); }, true);
  ['theme:cart:refresh','theme:cart:update','theme:cart:add'].forEach(function(n){
    document.addEventListener(n, function(){ setTimeout(tauschen, 400); });
  });
})();

/* ==== DER THEME-COLOR KOMMT IMMER WIEDER — JETZT EINE WACHE (21.09.2026) ====
   Marke: S304-THEMECOLOR-WACHE

   ⛔⛔ BEFUND AUS DEM AUDIT: Ich hatte den Meta an beiden bekannten Stellen
      entfernt (`head.liquid:10` und im Laufband-Snippet) — und im ausgelieferten
      Quelltext war er weg. Im BROWSER stand er trotzdem wieder da:
        <meta name="theme-color" content="#ffffff">
      direkt hinter `web-pixels@…/app/web-p…`, also von SHOPIFYS eigenem
      Pixel-Skript nachgetragen, NACH meinem Entfernen.
   ⭐ Ein einmaliges Entfernen ist gegen einen Nachtrager wirkungslos. Deshalb
      eine Wache am <head>, die ihn wegraeumt, sobald er auftaucht.
   ⛔ Warum das ueberhaupt zaehlt: `theme-color` laesst iOS-Safari BEIDE Leisten
      DECKEND malen. Ohne ihn bleiben sie durchscheinend und zeigen die Seite —
      genau das, was Enzo beschreibt: „dort ist einfach gar keine Farbe und man
      sieht halt einfach den Rest der PDP."
   ⛔ KEINE SCHLEIFE: der Rueckruf entfernt nur vorhandene Metas; sind keine
      mehr da, passiert nichts mehr. Zusaetzlich ein Zaehler als Notbremse.
   ⭐ RUECKWEG: diesen Block entfernen. */
(function(){
  "use strict";
  if (window.__s304TcWache) return;
  window.__s304TcWache = true;
  var weg = 0;
  function raeumen(){
    var m = document.querySelectorAll('meta[name="theme-color"]');
    for (var i = 0; i < m.length; i++){
      if (m[i].parentNode) { m[i].parentNode.removeChild(m[i]); weg++; }
    }
    return m.length;
  }
  raeumen();
  try {
    var kopf = document.head || document.documentElement;
    var beob = new MutationObserver(function(){
      if (weg > 60) { beob.disconnect(); return; }   /* Notbremse */
      raeumen();
    });
    beob.observe(kopf, {childList: true});
    setTimeout(function(){ beob.disconnect(); raeumen(); }, 20000);
  } catch(e){}
  window.__s304TcEntfernt = function(){ return weg; };
})();

/* ==== EINE SONDE FUER DEN UNTEREN RAND — nur mit ?diag=unten (21.09.2026) ====
   Marke: S304-DIAG-UNTEN

   ⛔ Der Grund: Chrome kann den Sicherheitsbereich eines iPhones nicht
      nachstellen (`env(safe-area-inset-bottom)` ist dort immer 0). Ich habe bei
      402 und bei 375 px gemessen, im Dunkelmodus, mit Pixelsonde ueber die
      unteren 80 px — in Chrome liegt dort immer die Seite. Ein Messkanal, der
      nichts sehen kann, darf kein „nichts gefunden" begruenden.
   ⭐ Also misst das Geraet selbst. Adresse mit `?diag=unten` aufrufen, ein
      Bildschirmfoto machen — darin steht, was der Browser wirklich sagt. */
(function(){
  "use strict";
  try { if (new URLSearchParams(location.search).get('diag') !== 'unten') return; } catch(e){ return; }
  function bauen(){
    var p = document.createElement('div');
    p.style.cssText = 'position:fixed;left:0;right:0;top:0;height:0;'
      + 'padding-bottom:env(safe-area-inset-bottom,0px);visibility:hidden';
    document.body.appendChild(p);
    var unten = Math.round(parseFloat(getComputedStyle(p).paddingBottom) || 0);
    p.remove();

    var H = window.innerHeight, W = window.innerWidth;
    var vv = window.visualViewport;
    var el = document.elementFromPoint(Math.round(W/2), H - 4);
    var farbe = 'keine', e = el, pfad = [];
    while (e && farbe === 'keine'){
      var c = getComputedStyle(e).backgroundColor;
      pfad.push(e.tagName.toLowerCase() + (e.className ? '.' + String(e.className).split(' ')[0] : ''));
      if (c && !/rgba\(0, 0, 0, 0\)|transparent/.test(c)) farbe = c;
      e = e.parentElement;
    }
    var k = document.createElement('div');
    k.style.cssText = 'position:fixed;left:8px;right:8px;top:8px;z-index:2147483647;background:#fff;'
      + 'color:#111;font:12px/1.45 monospace;padding:10px 12px;border:2px solid #111;white-space:pre-wrap';
    k.textContent =
        'safe-area-inset-bottom : ' + unten + ' px\n'
      + 'innerHeight            : ' + H + '\n'
      + 'visualViewport.height  : ' + (vv ? Math.round(vv.height) : '—') + '\n'
      + 'documentElement bg     : ' + getComputedStyle(document.documentElement).backgroundColor + '\n'
      + 'body bg                : ' + getComputedStyle(document.body).backgroundColor + '\n'
      + 'theme-color-Metas      : ' + document.querySelectorAll('meta[name="theme-color"]').length + '\n'
      + 'unterster Punkt        : ' + pfad.slice(0,3).join(' > ') + '\n'
      + 'dessen Farbe           : ' + farbe + '\n'
      + 'dunkel?                : ' + (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'ja' : 'nein');
    document.body.appendChild(k);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(bauen, 900); });
  else setTimeout(bauen, 900);
})();

/* ==== DAS KOMBINATIONSBILD OBEN — 21.09.2026, nachts ====
   Marke: S304-PAARBILD-OBEN

   Enzo: „wenn man bei den Bracelets ein Bracelet aendert und dazu packt, dass
   dann oben in dem Main-Bild … das Kombinations-Bild kommt" und, zum
   Seitenbanner: „oben soll sich das Bild dann auch veraendern auf die
   vorausgewaehlte Kombination."

   ⭐ DIE BILDER GIBT ES: 66 Paarfotos, jede Kombination aus den zwoelf
      Bracelets, in der Nacht vom 20. auf den 21.09. erzeugt. Sie liegen seit
      heute als Theme-Assets: `304-paar-<a>__<b>.jpg`, Namen alphabetisch
      sortiert, 1200 px. 66 von 66 hochgeladen, jede mit HTTP 200 bestaetigt.

   ⛔ WARUM NICHT `galerieSpringen`: der bestehende Weg klickt ein Vorschaubild
      an und braucht das Paarfoto deshalb als PRODUKTMEDIUM — das haette 132
      Medien an zwoelf Produkten bedeutet (jedes Paar an beiden). Hier wird
      stattdessen die Quelle des ERSTEN Dias getauscht; die Produktdaten bleiben
      unangetastet und der Rueckweg ist eine Zeile.

   ⛔ ERST LADEN, DANN SETZEN: fehlt eine Kombination, bliebe sonst ein kaputtes
      Bild stehen. Es wird also vorgeladen und nur bei Erfolg getauscht.
   ⛔ NICHT BEIM SEITENAUFRUF: das Hauptbild bleibt das Hauptbild, bis der Kunde
      etwas TUT (Blatt oeffnen, waehlen, Banner antippen). Sonst waere das
      Produktfoto der PDP ploetzlich ein anderes Produkt. */
(function(){
  "use strict";
  if (window.__s304PaarOben) return;
  window.__s304PaarOben = true;
  if (!document.body || !document.body.classList.contains('template-product')) return;

  var BASIS = '//cdn.shopify.com/s/files/1/0908/7660/8893/t/88/assets/304-paar-';
  var beruehrt = false, gesetzt = null, urSrc = null, urSrcset = null;

  function erstesBild(){
    var s = document.querySelectorAll('.product__slide[data-media-id]');
    return s.length ? s[0].querySelector('img') : null;
  }
  function zumErstenSpringen(){
    /* S304-SPRUNG-NICHT-BEI-OFFENEM-BLATT — 21.09.2026
       ⛔ Dieser Klick hat das Blatt zugemacht: er blubbert, und der
          Aussen-Klick-Griff des Blattes schliesst darauf. Symptom war
          „man kann nur einmal auswaehlen". */
    if (document.documentElement.classList.contains('s304-blatt-auf')) return;
    var s = document.querySelectorAll('.product__slide[data-media-id]');
    if (s.length && s[0].classList.contains('media--active')) return;  /* schon da */
    var t = document.querySelectorAll('a.product__thumb__link[data-media-id]');
    if (t.length) { try { t[0].click(); } catch(e){} }
  }
  function zuruecksetzen(){
    var im = erstesBild();
    if (!im || urSrc === null) { gesetzt = null; return; }
    im.setAttribute('src', urSrc);
    if (urSrcset !== null) im.setAttribute('srcset', urSrcset); else im.removeAttribute('srcset');
    gesetzt = null;
  }
  function schluessel(){
    var B = window.S304_BUNDLE;
    if (!B || !B.daten || !B.daten.haupt) return null;
    if (document.documentElement.classList.contains('s304-ohne-zweites')) return null;
    var a = B.daten.haupt.h;
    var z = null;
    try { z = (B.armiert && B.armiert()) || (B.gewaehlt && B.gewaehlt()); } catch(e){}
    if (!a || !z || !z.h) return null;
    if (B.daten.haupt.typ !== 'Bracelet') return null;      /* nur Bracelets haben Paarfotos */
    var k = [a, z.h].sort().join('__');
    /* S304-NUR-ERLAUBTE-PAARE — 21.09.2026
       ⛔ Ohne diese Abfrage sprang das Hauptbild zwischen VIER verschiedenen
          Modellen. Gezeigt wird nur, was zum haeufigsten Modell gehoert;
          sonst bleibt das Produktbild stehen. */
    if (window.S304_PAAR_ERLAUBT && !window.S304_PAAR_ERLAUBT[k]) return null;
    return k;
  }
  function nachziehen(){
    if (!beruehrt) return;
    var k = schluessel();
    if (!k) { if (gesetzt) zuruecksetzen(); return; }
    if (k === gesetzt) return;
    var im = erstesBild(); if (!im) return;
    if (urSrc === null){ urSrc = im.getAttribute('src'); urSrcset = im.getAttribute('srcset'); }
    var url = BASIS + k + '.jpg';
    var probe = new Image();
    probe.onload = function(){
      var i2 = erstesBild(); if (!i2) return;
      i2.setAttribute('src', url);
      i2.removeAttribute('srcset');
      gesetzt = k;
      zumErstenSpringen();
      try { if (window.clarity) window.clarity('event', 's304_paarbild_oben'); } catch(e){}
    };
    probe.onerror = function(){ /* diese Kombination gibt es nicht — Bild bleibt, wie es war */ };
    probe.src = url;
  }

  document.addEventListener('click', function(e){
    var z = e.target && e.target.closest ? e.target.closest(
      '.s304-duo, .s304-tg__ae, .s304-str, .s304-kb-kachel, .s304-sel__o, .s304-sel__d') : null;
    if (z) beruehrt = true;
    setTimeout(nachziehen, 380);
    setTimeout(nachziehen, 1200);
  }, true);
  setInterval(function(){ if (beruehrt) nachziehen(); }, 900);
})();

/* ==== DAS SEITENBANNER OEFFNET DAS BLATT — 21.09.2026 ====
   Marke: S304-STR-OEFFNET
   Enzo: „bei dem 2-fuer-1-Ding, was an der Seite als Banner kommt — wenn man da
   drauf drueckt, soll dann auch das aufgehen, und die vorausgewaehlte Bracelet
   soll dann schon ausgewaehlt sein."
   ⭐ Die Vorauswahl ist seit heute ohnehin armiert, es muss also nur das Blatt
      auf. Der Griff ist bewusst SPAET: erst nachsehen, ob es nicht schon ein
      anderer Horcher geoeffnet hat — sonst zwei Regelwerke fuer dieselbe Tat. */
(function(){
  "use strict";
  if (window.__s304StrOeffnet) return;
  window.__s304StrOeffnet = true;
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('.s304-str') : null;
    if (!b) return;
    setTimeout(function(){
      if (document.documentElement.classList.contains('s304-blatt-auf')) return;
      var ae = document.querySelector('.s304-tg__ae') || document.querySelector('.s304-duo');
      if (ae) ae.click();
    }, 360);
  }, false);
})();

/* ==== NACH DER WAHL: WIEDER HOCH ZUM BILD — 21.09.2026, nachts ====
   Marke: S304-NACH-DER-WAHL

   Enzo: „wenn ich auf Aendern gehe und auf eins druecke, dann scrollt der
   automatisch runter — der muss natuerlich automatisch wieder hoch scrollen zu
   dem Bild."
   ⛔ URSACHE: das Blatt schliesst, und das Theme stellt die Bildlaufhoehe
      wieder her, die es beim Oeffnen gemerkt hat — das ist die Hoehe der
      Kaufbox, nicht die der Galerie. Statt dagegen zu kaempfen wird nach dem
      Schliessen bewusst zur Galerie zurueckgefuehrt: dort ist ja gerade das
      Kombinationsbild erschienen, das ist der Grund des ganzen Schrittes.
   ⭐ Sanft (`behavior: smooth`) und erst, wenn das Blatt wirklich zu ist —
      sonst kaempfen zwei Bildlaeufe gegeneinander. */
(function(){
  "use strict";
  if (window.__s304NachDerWahl) return;
  window.__s304NachDerWahl = true;
  if (!document.body || !document.body.classList.contains('template-product')) return;

  function hoch(){
    var g = document.querySelector('.product__media-list, .product__slideshow, .product__slide[data-media-id]');
    if (!g) return;
    var r = g.getBoundingClientRect();
    var ziel = window.scrollY + r.top - 70;
    if (ziel < 0) ziel = 0;
    if (Math.abs(window.scrollY - ziel) < 40) return;      /* schon oben */
    try { window.scrollTo({top: ziel, behavior: 'smooth'}); }
    catch(e){ window.scrollTo(0, ziel); }
  }

  document.addEventListener('click', function(e){
    var k = e.target && e.target.closest ? e.target.closest('.s304-pdpb .s304-kb-kachel') : null;
    if (!k) return;
    var n = 0;
    var iv = setInterval(function(){
      n++;
      if (!document.documentElement.classList.contains('s304-blatt-auf')){
        clearInterval(iv);
        setTimeout(hoch, 220);
        return;
      }
      if (n > 24) clearInterval(iv);                        /* Notbremse ~6 s */
    }, 250);
  }, true);
})();

/* ==== „BEIDE IN DEN WARENKORB" AUS DEM BLATT: DIREKT IN DEN KORB ====
   Marke: S304-BLATT-DIREKT-IN-DEN-KORB
   Enzo: „wenn ich dann auf beide in den Warenkorb legen druecke, soll man gar
   nicht mehr zurueckkommen zur PDP und da liegt das kurz, sondern es geht dann
   direkt der Warenkorb auf."
   ⭐ Das Blatt bleibt also OFFEN, bis der Korb da ist, und wird erst dann
      geschlossen. Die bestehende Logik legt weiter ein; hier wird nur die
      Reihenfolge des Schliessens gedreht. */
(function(){
  "use strict";
  if (window.__s304BlattDirekt) return;
  window.__s304BlattDirekt = true;
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('.s304-blatt__f button, .s304-blatt__cta') : null;
    if (!b) return;
    document.documentElement.classList.add('s304-korb-kommt');
    var n = 0;
    var iv = setInterval(function(){
      n++;
      var dr = document.querySelector('cart-drawer.is-open, .drawer--cart.is-open');
      if (dr){
        clearInterval(iv);
        document.documentElement.classList.remove('s304-korb-kommt', 's304-blatt-auf');
        var pop = document.querySelector('.s304-pop');
        if (pop) pop.classList.remove('da');
        return;
      }
      if (n > 40){ clearInterval(iv); document.documentElement.classList.remove('s304-korb-kommt'); }
    }, 200);
  }, true);
})();

/* ==== DIE MARKE FUER DIE SCHWEBENDE LEISTE — 21.09.2026 ====
   Marke: S304-LEISTE-MARKE
   Gehoert zu `S304-STREIFEN-UNTEN`. Setzt `s304-leiste-da` ans <html>, solange
   die Kaufleiste wirklich sichtbar ist. Nur dann braucht die Seite unten
   Reserve; sonst reicht der Inhalt bis an die Kante — und genau das hat Enzo
   verlangt: „da soll einfach die PDP zu sehen sein."
   ⛔ Gemessen statt geraten: die Leiste traegt `visibility:hidden; opacity:0`,
      solange sie nicht gebraucht wird — `display` bleibt `flex`. Eine Pruefung
      auf `display` haette immer „da" gesagt. */
(function(){
  "use strict";
  if (window.__s304LeisteMarke) return;
  window.__s304LeisteMarke = true;
  function pruefen(){
    var cb = document.querySelector('cart-bar, .cart-bar');
    var da = false;
    if (cb){
      var c = getComputedStyle(cb);
      da = c.visibility !== 'hidden' && parseFloat(c.opacity) > .05 && c.display !== 'none';
    }
    document.documentElement.classList.toggle('s304-leiste-da', da);
  }
  pruefen();
  window.addEventListener('scroll', pruefen, {passive: true});
  setInterval(pruefen, 700);
})();

/* ==== NUR EIN MODELL — DIE PAARBILDER WERDEN KOHAERENT (21.09.2026, nachts) ====
   Marke: S304-PAAR-EIN-MODELL

   Enzo: „Snow Link ist falsch, das ist nicht das Tattoo … alles muss natuerlich
   model-kohaerent sein."

   ⭐ NACHGESEHEN, NICHT GERATEN: alle 66 Paarbilder auf neun Kontaktbogen
      angesehen und nach Taetowierung sortiert. Es sind VIER Modelle:
        A  Chrysantheme + Wabenmuster + konzentrischer Kreis   (~7 Bilder)
        B  wiederholte Dahlien-/Mandalablueten                 (34 Bilder)
        C  Koi-Karpfen mit Wellen                              (~20 Bilder)
        D  Hibiskus-Linienwerk, heller                         (~2 Bilder)
      Beim Wechseln sprang das Hauptbild also zwischen vier verschiedenen Armen.

   ⭐ B ist mit 34 von 66 das haeufigste Modell und deckt ELF der zwoelf
      Bracelets ab (nur blossom-link kommt ausschliesslich in C vor).
      Deshalb: NUR die B-Bilder werden gezeigt. Passt eine Kombination nicht,
      bleibt das normale Produktbild stehen — lieber kein Wechsel als ein
      fremder Arm.
   ⛔ Das ist kein „fehlendes" Bild: die anderen 32 existieren, sie zeigen nur
      ein anderes Modell. Wer sie will, erweitert diese Liste.
   ⭐ Der Weg zur vollen Abdeckung waere, die 32 mit demselben Modellfoto neu
      zu erzeugen — dafuer braucht es einen eigenen Lauf. */
(function(){
  "use strict";
  window.S304_PAAR_ERLAUBT = {
    /* ⛔ 21.09.2026 — 'blood-link__forest-link' und 'blood-link__ocean-link'
       ENTFERNT: beide Bilder zeigen EIN zweifarbiges Armband mit EINEM
       Verschluss statt zwei Stuecken (im Nahschnitt bei 100 % geprueft).
       Siehe umbau-2fuer1/paare_richtig.py. Ohne Eintrag bleibt das normale
       Produktfoto stehen — der bereits gemessene Rueckweg. */
    'blood-link__green-ice':1, 'blood-link__icy-stellar':1,
    'blood-link__silver-crest':1, 'blood-link__snow-link':1,
    'blue-ice__forest-link':1, 'blue-ice__icy-stellar':1,
    'forest-link__green-ice':1, 'forest-link__icy-stellar':1, 'forest-link__midnight-link':1,
    'forest-link__ocean-link':1, 'forest-link__red-ice':1, 'forest-link__silver-crest':1,
    'forest-link__snow-link':1, 'forest-link__white-ice':1,
    'green-ice__icy-stellar':1, 'green-ice__midnight-link':1, 'green-ice__ocean-link':1,
    'green-ice__red-ice':1, 'green-ice__snow-link':1, 'green-ice__white-ice':1,
    'icy-stellar__midnight-link':1, 'icy-stellar__ocean-link':1, 'icy-stellar__red-ice':1,
    'icy-stellar__silver-crest':1, 'icy-stellar__white-ice':1,
    'midnight-link__silver-crest':1,
    'ocean-link__silver-crest':1, 'ocean-link__snow-link':1, 'ocean-link__white-ice':1,
    'red-ice__silver-crest':1, 'red-ice__snow-link':1, 'red-ice__white-ice':1
  };
})();

/* ==== EIN LEERES THEME-WIDGET REISST 136 PX LOCH INS SCHUBFACH ====
   Marke: S304-LEERES-WIDGET
   21.09.2026

   GEMESSEN im offenen Schubfach bei 402x812 (2 Posten):
     letzte Warenkorbzeile endet bei y 306
     „DAS KOENNTE DIR GEFALLEN" beginnt bei y 442
     dazwischen: 136 px, belegt von `summary.cart__widget__title`
     („Kombinieren mit", 41 px) und `.cart__widget__content__inner` (40 px),
     deren Inhalt `<div class="cart__widget__products" data-upsell-products="">`
     KEIN einziges Kind hat.

   Das ist das Theme-eigene Upsell-Widget, nicht unseres. Es druckt seine
   Ueberschrift auch dann, wenn nichts darin steht — genau die Fehlerklasse
   „eine leere Liste und eine kaputte Verbindung sehen gleich aus".

   ⛔ KEIN `:has()`: das waere wieder eine Browser-Wette. Stattdessen eine
      Pruefung, die den ZUSTAND liest.
   ⭐ Und sie ist umkehrbar: fuellt das Theme das Widget spaeter doch (die
      Produkte werden nachgeladen), wird es im naechsten Durchlauf wieder
      eingeblendet. Ein einmaliges `display:none` waere ein stiller Riegel
      gegen eine Funktion, die morgen benutzt werden koennte. */
(function(){
  "use strict";
  if (window.__s304LeeresWidget) return;
  window.__s304LeeresWidget = true;

  function pruefen(){
    var toepfe = document.querySelectorAll('[data-upsell-products]');
    Array.prototype.forEach.call(toepfe, function(topf){
      /* 21.09.2026 — Rangfolge, nicht Selektorliste: `closest()` nimmt sonst
         den naechsten Treffer (.cart__widget__content) und laesst die
         Ueberschrift `<summary>` als Geschwister stehen. */
      var huelle = topf.closest('details')
                || topf.closest('.cart__widget')
                || topf.closest('.cart__widget__content')
                || topf.parentElement;
      if (!huelle) return;
      var leer = topf.children.length === 0;
      if (leer){
        if (huelle.getAttribute('data-s304-leer') !== 'ja'){
          huelle.setAttribute('data-s304-leer', 'ja');
          huelle.style.setProperty('display', 'none', 'important');
        }
      } else if (huelle.getAttribute('data-s304-leer') === 'ja'){
        huelle.removeAttribute('data-s304-leer');
        huelle.style.removeProperty('display');
      }
    });
  }

  setTimeout(pruefen, 2500);
  setInterval(pruefen, 1500);
})();

/* ==== DER KASSENKNOPF SPRICHT DIE SPRACHE DER SEITE ====
   Marke: S304-KASSENKNOPF-SPRACHE
   21.09.2026

   Gemessen auf `/en/`: `lang="en"`, alles andere englisch — und der wichtigste
   Knopf im Laden trug weiter **„JETZT SICHER ZUR KASSE"**. Das Theme rendert
   dort Deutsch (Luecke in Shopifys Uebersetzung, nicht im Code).

   ⛔ Mein erster Versuch sass in `preisSetzen()`. Nachgemessen: `data-s304-alt`
      ist dort `null` — die Funktion laeuft auf dieser Seite nie. Eine Reparatur
      an einer Stelle, die nicht ausgefuehrt wird, ist keine Reparatur.

   ⭐ Deshalb hier am TEXTKNOTEN, und selbstheilend: ersetzt wird nur, was
      wirklich deutsch aussieht. Traegt Shopify die Uebersetzung nach, gewinnt
      sie wieder von selbst. Der Preis dahinter kommt aus `--s304-kassenpreis`
      ueber `::after` und bleibt unberuehrt.
   ⛔ Kein MutationObserver (einer hat am 20.09. den ganzen Shop eingefroren) —
      eine Wache, die nur handelt, wenn sie deutschen Text sieht. */
(function(){
  "use strict";
  if (window.__s304KassenknopfSprache) return;
  window.__s304KassenknopfSprache = true;
  if (!window.s304EN) return;

  var DEUTSCH = /kasse|warenkorb|jetzt|sicher/i;

  function setzen(){
    var knoepfe = document.querySelectorAll('.cart__checkout, [name="checkout"]');
    Array.prototype.forEach.call(knoepfe, function(b){
      var ziel = b.querySelector('.btn__text') || b;
      Array.prototype.forEach.call(ziel.childNodes, function(n){
        if (n.nodeType !== 3) return;
        var t = (n.nodeValue || '').trim();
        if (!t || !DEUTSCH.test(t)) return;
        n.nodeValue = n.nodeValue.replace(t, 'SECURE CHECKOUT');
      });
    });
  }

  setTimeout(setzen, 900);
  setInterval(setzen, 1200);
})();
